interface ITranslations extends types.utils.translations.ITranslations {}

export const translations: ITranslations = {
	omantel: {
		ar: 'Omantel',
		en: 'Omantel',
	},
	close: {
		ar: 'اغلاق',
		en: 'Close',
	},
	'error.timeout': {
		ar: 'حدث خطأ في الاتصال',
		en: 'A connection error occurred.',
	},
	'error.wrong.response': {
		ar: 'نعتذر.. حدث خطأ. يرجى المحاولة مرة أخرى لاحقاً',
		en: 'Ooops! Api error. Please try again later.',
	},
	'error.occured': {
		ar: 'حدث خطأ غير متوقع',
		en: 'An unexpected error occurred.',
	},
	'error.password.too.short': {
		ar: 'كلمة المرور قصيرة جدا',
		en: 'Password is too short',
	},
	omr: {
		ar: 'ريال عماني',
		en: 'OMR',
	},
	min: {
		ar: 'الحد الأدنى',
		en: 'MIN',
	},
	gb: {
		ar: '%% جي بي',
		en: '%% GB',
	},
	keyword: {
		ar: 'الكلمة الرئيسية: ٪٪',
		en: 'Keyword: %%',
	},
	'gb.simple': {
		ar: ' جي بي',
		en: 'GB',
	},
	'mb.simple': {
		ar: 'ميجابايت',
		en: 'MB',
	},
	'home.name': {
		ar: 'الصفحة الرئيسية',
		en: 'Home',
	},
	'language.name.AR': {
		ar: 'العربي',
		en: 'Arabic',
	},
	'language.name.EN': {
		ar: 'العربية',
		en: 'English',
	},
	'translation.example': {
		ar: 'مثال للترجمة, value1: %%, value2: %%, value3: %%',
		en: 'Translation example, value1: %%, value2: %%, value3: %%',
	},
	'account.management.orders': {
		ar: 'الطلبات',
		en: 'Orders',
	},
	'account.management.orders.in.': {
		ar: 'الطلبات قيد الاجراء',
		en: 'Orders in progress',
	},
	'account.management.orders.in.progress.count': {
		ar: '(%%)الطلبات قيد الاجراء ',
		en: 'Orders in progress (%%)',
	},
	'account.management.orders.no': {
		ar: 'حاليًا ، ليس لديك أي طلبات.',
		en: 'Currently, you have no orders.',
	},
	'account.management.orders.go.to.store': {
		ar: 'اذهب إلى متجر عمانتل وابدأ بتصفح عرضنا."',
		en: 'Go to Omantel store and start browsing our offer.',
	},
	'account.management.orders.go.to.store.button': {
		ar: 'اذهب إلى متجر عمانتل',
		en: 'Go to Omantel store',
	},
	'account.management.order.history': {
		ar: 'الطلبات السابقة',
		en: 'Order history',
	},
	'account.management.order.in.progress': {
		ar: 'قيد الاجراء',
		en: 'In progress',
	},
	'account.management.order.completed': {
		ar: 'اكتمل الطلب',
		en: 'Order completed',
	},
	'account.management.order.id': {
		ar: '#%%, ',
		en: '#%%, ',
	},
	'account.management.payment.shipment.status': {
		ar: 'معلومات الطلب',
		en: 'Order info',
	},
	'account.management.online.payment': {
		ar: 'الدفع عبر الإنترنت',
		en: 'Online payment',
	},
	'account.management.payment.recieved': {
		ar: ' %% :المبلغ المستلم',
		en: 'Payment recieved: %%',
	},
	'account.management.delivery.address': {
		ar: 'عنوان التسليم',
		en: 'Delivery address',
	},
	'account.management.show.on.map': {
		ar: 'إظهار على الخريطة',
		en: 'Show on map',
	},
	'account.management.track.shipping': {
		ar: 'تتبع الطلب',
		en: 'Track shipping',
	},
	'account.management.order.delivered': {
		ar: 'تم تسليم الطلب',
		en: 'Order delivered',
	},
	'account.management.your.shipping.id': {
		ar: ' %% :معرّف الشحن الخاص بك',
		en: 'Your shipping ID: %%',
	},
	'account.management.track.delivery': {
		ar: 'تتبع الشحن',
		en: 'Track delivery',
	},
	'account.management.order.contents': {
		ar: 'محتويات الطلب',
		en: 'Order Contents',
	},
	'account.management.payment.summary': {
		ar: 'ملخص الدفع',
		en: 'Payment Summary',
	},
	'account.management.settings': {
		ar: 'الإعدادات',
		en: 'Settings',
	},
	'account.management.settings.personal.data': {
		ar: 'البيانات الشخصية',
		en: 'Personal data',
	},
	'account.management.settings.payment.method': {
		ar: 'طريقة الدفع',
		en: 'Payment method',
	},
	'account.management.settings.payment.method.empty': {
		ar: 'حاليا ، ليس لديك طريقة دفع مضافة.',
		en: 'Currently, you have no payment method added.',
	},
	'account.management.settings.payment.method.default': {
		ar: 'أساسي',
		en: 'Default',
	},
	'account.management.settings.payment.method.set.as.default': {
		ar: 'تعيين كأساسي',
		en: 'Set as default',
	},
	'account.management.settings.payment.method.delete': {
		ar: 'حذف',
		en: 'Delete',
	},
	'product.card.price.starts.from': {
		ar: 'يبدأ من',
		en: 'Starts from',
	},
	'product.card.price.installments': {
		ar: 'أقساط من',
		en: 'Installments from',
	},
	'product.card.price.installments-not-available': {
		ar: 'األقساط غير متوفرة',
		en: 'Installments not available',
	},
	'product.card.price': {
		ar: 'السعر',
		en: 'Price',
	},
	'product.card.discount': {
		ar: 'خصم يصل إلى ٪٪ ريال عماني!',
		en: 'Up to %% OMR discount!',
	},
	'product.card.preorder.now': {
		ar: 'اطلب مسبقًا الآن',
		en: 'Preorder now',
	},
	'product.card.view.details': {
		ar: 'عرض التفاصيل',
		en: 'View details',
	},
	'product.card.see.details': {
		ar: 'عرض التفاصيل',
		en: 'See details',
	},
	'product.card.notify.me': {
		ar: 'أعلمني',
		en: 'Notify me',
	},
	'product.card.apply': {
		ar: 'اطلب الآن',
		en: 'Apply now',
	},
	'product.card.preorder.starts': {
		ar: 'يبدأ الطلب المسبق في',
		en: 'Preorder starts on',
	},
	'product.card.product.unavailable': {
		ar: 'نفذت الكمية',
		en: 'Sold out',
	},
	'product.key.features': {
		ar: 'المميزات الرئيسية',
		en: 'Key features',
	},
	'product.whats.in.the.box': {
		ar: 'ماذا يوجد في الصندوق',
		en: "What's in the box",
	},
	'product.related.products': {
		ar: 'المنتجات ذات الصلة',
		en: 'Related products',
	},
	'product.similar.items': {
		ar: 'خيارات مماثلة',
		en: 'Similar items',
	},
	'product.recommended.for.you': {
		ar: 'مناسب لك',
		en: 'Recommended for you',
	},
	'product.explore.more': {
		ar: 'اكتشف المزيد',
		en: 'Explore more',
	},
	'product.enjoy.new.possibilities': {
		ar: 'تمتع بإمكانيات جديدة',
		en: 'Enjoy new possibilities',
	},
	'product.explore.apple.world': {
		ar: 'اكتشف عالم آبل',
		en: 'Explore Apple world',
	},
	'product.apple.store.button': {
		ar: 'اذهب إلى متجر آبل في موقع عمانتل',
		en: 'Go to Apple store at Omantel',
	},
	'product.popular.products': {
		ar: 'المنتجات الاكثر شهرة',
		en: 'Popular products',
	},
	'product.additional.description.tab.description': {
		ar: 'وصف',
		en: 'Description',
	},
	'product.additional.description.tab.technical.specification': {
		ar: 'المواصفات الفنية',
		en: 'Technical specification',
	},
	'product.additional.description.tab.reviews': {
		ar: 'المراجعات',
		en: 'Reviews',
	},
	'product.additional.description.tab.faq': {
		ar: 'الأسئلة الشائعة',
		en: 'FAQ',
	},
	'product.additional.description.tab.return.policy': {
		ar: 'سياسة الإرجاع',
		en: 'Return policy',
	},
	'product.cart-card.header': {
		ar: 'المنتجات المختارة',
		en: 'Selected items',
	},
	'product.cart-card.top-label-1': {
		ar: 'لقد قمت باختيار',
		en: "You've chosen the",
	},
	'product.cart-card.top-label-2': {
		ar: 'مع الباقة الحالية',
		en: 'with current plan',
	},
	'product.cart-card.top-label-3': {
		ar: 'مع الباقة المحدثة',
		en: 'with updated plan',
	},
	'product.cart-card.out-of-stock.description': {
		ar: 'عذرًا، هذا المنتج غير متوفر',
		en: 'Sorry, but this product is out of stock.',
	},
	'product.cart-card.modal.out-of-stock.title': {
		ar: 'غير متوفر',
		en: 'Out of stock',
	},
	'product.cart-card.modal.out-of-stock.description': {
		ar: 'المنتج الذي حددته نفد للتو. اختر منتج آخر أو قم بالتسجيل للحصول على إشعار توفر المنتج. ',
		en:
			'Item you have selected just went out of stock. Select another product configuration or sign up for back in stock notification.',
	},
	'product.cart-card.buySim.SimIncluded': {
		ar: 'يتضمن بطاقة SIM',
		en: 'SIM Card included',
	},
	'product.cart-card.buySim.plan-valid': {
		ar: 'صلاحية الباقة',
		en: 'Plan valid',
	},
	'product.cart-card.upfront': {
		ar: 'المقدم',
		en: 'Upfront',
	},
	'product.cart-card.12mo': {
		ar: 'أول ١٢ شهرا',
		en: 'First 12 mo.',
	},
	'product.cart-card.for1mo': {
		ar: 'مبلغ الفاتورة الأولى',
		en: '1st Bill Amount',
	},
	'product.cart-card.for11mo': {
		ar: 'لمدة ١١ شهر',
		en: 'For 11 mo.',
	},
	'product.cart-card.for12mo': {
		ar: 'لمدة ١٢ شهر',
		en: 'For 12 mo.',
	},
	'product.cart-card.for23months': {
		ar: 'لمدة 23 شهراً',
		en: 'For 23 Months.',
	},
	'product.cart-card.for23mo': {
		ar: 'لمدة 23 شهراً',
		en: 'For 23 mo.',
	},
	'product.cart-card.23mo': {
		ar: 'لمدة 23 شهراً',
		en: 'For 23 mo.',
	},
	'cart.checkout.remaining-mo': {
		ar: 'فواتير الأشهر المتبقية %%',
		en: 'Remaining %% Month’s Bills',
	},
	'product.cart-card.12months': {
		ar: 'أول ١٢ شهرا',
		en: 'First 12 months',
	},
	'product.cart-card.11months': {
		ar: 'أول 11 شهرًا',
		en: 'First 11 mo.',
	},
	'product.cart-card.last': {
		ar: 'الشهر الأخير',
		en: 'Last month',
	},
	'product.cart-card.23months': {
		ar: 'أول 23 شهرًا',
		en: 'First 23 mo.',
	},
	'product.cart-card.for1month': {
		ar: 'مبلغ الفاتورة الأولى',
		en: '1st Bill Amount',
	},
	'product.cart-card.for11months': {
		ar: 'لمدة ١١ شهر',
		en: 'For 11 Months',
	},
	'product.cart-card.for12months': {
		ar: 'لمدة ١٢ شهر',
		en: 'For 12 months',
	},
	'product.cart-card.for24months': {
		ar: 'لمدة ٢٤ شهر',
		en: 'For 24 months',
	},
	'cart.payment.summary.first-month-bill': {
		ar: 'فاتورة الشهر الأول',
		en: 'First Month bill',
	},
	'cart.payment.summary.remaining-monthly-bill': {
		ar: 'الفاتورة الشهرية المتبقية',
		en: 'Remaining %% Monthly bill',
	},
	'product.cart-card.24months': {
		ar: 'الأشهر المتبقية',
		en: '13 to 24 months',
	},
	'product.cart-card.24mo': {
		ar: 'لمدة ٢٤ شهر',
		en: 'For 24 mo.',
	},
	'product.cart-card.plan-vat': {
		ar: 'ضريبة القيمة المضافة على سعر الباقة',
		en: 'VAT on plan price',
	},
	'product.cart-card.plan-vat.tooltip': {
		ar: 'هذه هي قيمة الضريبة المضافة لباقة باقتي التي قمت باختيارها.',
		en: "This is the VAT value of the Baqati plan that you've chosen.",
	},
	'product.cart-card.device-vat.tooltip': {
		ar:
			'المبلغ الوحيد الذي عليك دفعه مقدما هو ضريبة القيمة المضافة للجهاز. وبالتالي جميع الأقساط على الجهاز لا تتضمن ضريبة القيمة المضافة.',
		en:
			'The only amount you have to pay upfront is the VAT value of the device. All further instalments on the device are therefore VAT-free.',
	},
	'product.cart-card.with-vat': {
		ar: 'مع %%٪ ضريبة القيمة المضافة',
		en: 'With %%% VAT:',
	},
	'product.cart-card.with-vat.b2b': {
		ar: 'يشمل %%% ضريبة القيمة المضافة​',
		en: '(%%% VAT included)',
	},
	'product.cart-card.vat-included': {
		ar: 'شامل %%٪ ضريبة القيمة المضافة',
		en: 'With %%% VAT included',
	},
	'product.cart-card.after-discount': {
		ar: 'بعد الخصم:',
		en: 'After discount:',
	},
	'product.cart-card.vat-from-device': {
		ar: 'ضريبة القيمة المضافة للجهاز',
		en: 'VAT on device',
	},
	'product.cart-card.vat-from-full-device': {
		ar: 'ضريبة القيمة المضافة من السعر الكامل للجهاز',
		en: 'VAT from full device price',
	},
	'product.cart-card.upfront-payment': {
		ar: 'مقدم الدفع',
		en: 'Upfront payment',
	},
	'product.cart-card.vat-value': {
		ar: '[AR] With %%% VAT:',
		en: 'With %%% VAT:',
	},
	'product.cart-card.no-pay1': {
		ar: '[AR] According to the device',
		en: 'According to the device ',
	},
	'product.cart-card.no-pay2': {
		ar: '[AR] you will not pay for the device',
		en: 'you will not pay for the device',
	},
	'product.cart-card.monthly': {
		ar: 'شهري',
		en: 'Monthly',
	},
	'product.cart-card.add-to-cart': {
		ar: 'اضف إلى عربة التسوق',
		en: 'Add to cart',
	},
	'product.cart-card.transaction.part-1': {
		ar: 'معاملتك ',
		en: 'Your transaction is ',
	},
	'product.cart-card.transaction.part-2': {
		ar: 'آمنة',
		en: 'secure',
	},
	'product.cart-card.sales-lead-info': {
		ar: 'لا يمكن طلب هذا الجهاز عبر متجر عمانتل الإلكتروني.لطلب الجهاز، يرجى ملء الاستمارة أدناه.',
		en: 'This device cannot be ordered through the e-shop. To proceed, please fill out the form below and submit.',
	},
	'product.cart-card.sales-lead.form.request-device': {
		ar: 'املأ الاستمارة لطلب الجهاز',
		en: 'Fill out the form to request the device.',
	},
	'product.cart-card.sales-lead.form.firstName': {
		ar: 'الاسم الأول',
		en: 'First Name',
	},
	'product.cart-card.sales-lead.form.lastName': {
		ar: 'الاسم الأخير',
		en: 'Last Name',
	},
	'product.cart-card.sales-lead.form.contactNumber': {
		ar: 'رقم التواصل',
		en: 'Contact Number',
	},
	'product.cart-card.sales-lead.form.email': {
		ar: 'البريد الإلكتروني',
		en: 'Email',
	},
	'product.cart-card.sales-lead.form.crNumber': {
		ar: 'رقم السجل التجاري',
		en: 'CR Number',
	},
	'product.cart-card.sales-lead.form.isOmantelCustomer': {
		ar: 'هل أنت مشترك حالي مع عمانتل؟',
		en: 'Are you an existing Omantel customer?',
	},
	'product.cart-card.sales-lead.form.yes': {
		ar: 'نعم',
		en: 'Yes',
	},
	'product.cart-card.sales-lead.form.no': {
		ar: 'لا',
		en: 'No',
	},
	'product.cart-card.sales-lead.form.log-in': {
		ar: 'لتعبئة بيانات الاستمارة تلقائيا، يرجى تسجيل الدخول أولا',
		en: 'Log in to fill out the form automatically',
	},
	'product.sales-existing.user.yes': {
		ar: 'لا',
		en: 'Yes',
	},
	'product.sales-existing.user.no': {
		ar: 'نعم',
		en: 'No',
	},
	'apple-brand-store.button.shop-all': {
		ar: 'تسوق كل شيء ',
		en: 'Shop all',
	},
	'apple-brand-store.label.accessories': {
		ar: 'إضافات',
		en: 'Accessories',
	},
	'apple-brand-store.label.more-from-apple': {
		ar: 'المزيد من آبل',
		en: 'More from Apple',
	},
	'apple-brand-store.label.shipping-options': {
		ar: 'خيارات الشحن',
		en: 'Shipping options',
	},
	'apple-brand-store.label.pickup.title': {
		ar: 'إمكانية الاستلام من المنفذ',
		en: 'Outlet pickup available',
	},
	'apple-brand-store.label.pickup.description': {
		ar:
			'لقد جعلنا الحصول على المنتجات التي تريدها أسهل وأسرع. ما عليك سوى الشراء من خلال Omantel.com أو من تطبيق عمانتل والاستلام من منفذ قريب منك. سيتم توصيل المنتجات الخاصة لك.',
		en:
			"We've made getting the products you want easier and faster. Just buy on Omantel.com or in the Omantel App and pick up at a store near you. Your items will be brought to you. ",
	},
	'apple-brand-store.label.delivery.title': {
		ar: 'توصيل مجاني للمنزل',
		en: 'Free home delivery',
	},
	'apple-brand-store.label.delivery.description': {
		ar:
			'ابحث عن أفضل منتج لك واطلبه لمنزلك. احصل على توصيل مجاني للمنزل على جميع أجهزتك وملحقاتك. سيتم توصيلها إلى باب بيتك.',
		en:
			'Find the best product for you and order for your home. Get free home delivery on all your devices and accessories. It will be delivered to your doorstep.',
	},
	'apple-services.title': {
		ar: ' دعم إضافي',
		en: 'EXTRA SUPPORT',
	},
	'apple-services.support.label': {
		ar: 'Apple خدمات',
		en: 'Apple services',
	},
	'apple-services.hero-banner.title-first': {
		ar: 'أفضل الخدمات',
		en: 'All the best.',
	},
	'apple-services.hero-banner.title-second': {
		ar: 'Apple  فقط مع.',
		en: 'Only at Apple.',
	},
	'apple-services.hero-banner.description': {
		ar:
			'مسلسلات وأفلام حائزة على جوائز وموسيقى رائعة .الكثير من األلعاب المذهلة مع طرق دفع سهلة. استمتعوا مع محتوى عالي الجودة وخدمات رائعة فقط من Apple .ستمنحك أجهزتك المفضلة المزيدمن المرح.',
		en:
			'Award-winning series and movies, fantastic music in surround sound, amazing games, convenient payment methods. That is, the highest quality content and services available only from Apple. Your beloved devices will now give you even more fun.',
	},
	'apple-services.service.title': {
		ar: 'الخدمة والدعم',
		en: 'Service and support',
	},
	'apple-services.service.description': {
		ar: ' Apple  من خبراء .',
		en: 'from Apple experts.',
	},
	'apple-services.support.title': {
		ar: ' Apple دعم',
		en: 'Apple Support',
	},
	'apple-services.support.description': {
		ar: 'احصل على الدعم لجميع منتجات Apple - كل ذلك في تطبيق واحد.',
		en: 'get the support for all Apple products - all in one app.',
	},
	'apple-menu.apple-store': {
		ar: 'متجر آبل',
		en: 'Apple Store',
	},
	'apple-menu.watch': {
		ar: 'ساعة',
		en: 'Watch',
	},
	'apple-menu.accessories': {
		ar: 'ملحقات',
		en: 'Accessories',
	},
	'apple-menu.apple-tv': {
		ar: 'تلفزيون آبل',
		en: 'Apple TV',
	},
	'store.searching.title': {
		ar: 'بحث: "%%"',
		en: 'Searching: "%%"',
	},
	'store.banner.explore': {
		ar: 'استكشف الآن',
		en: 'Explore now',
	},
	'store.banner.explore.our': {
		ar: 'استكشف متجر',
		en: 'Explore Our',
	},
	'store.banner.apple.store': {
		ar: 'Apple الخاص بنا',
		en: 'Apple Store',
	},
	'store.searching.found': {
		ar: ' (تم العثور على %%)',
		en: '(%% found)',
	},
	'store.categories.back-to': {
		ar: 'رجوع إلى %%',
		en: 'Back to %%',
	},
	'store.categories.header': {
		ar: 'الفئات',
		en: 'Categories',
	},
	'store.categories.all-categories': {
		ar: 'جميع الفئات',
		en: 'All categories',
	},
	'store.products.empty-state.title': {
		ar: ' هل أنت متأكد أنك تبحث عن `%%`?',
		en: 'Are you sure you look for `%%`?',
	},
	'store.products.empty-state.description': {
		ar: 'حاول إدخال الكلمة الأساسية بطريقة مختلفة واضغط على (Enter) للبحث مرة أخرى.',
		en: 'Try entering the keyword in a different way and hit enter to search again.',
	},
	'store.products.empty-state.button': {
		ar: 'بحث',
		en: 'Search',
	},
	'store.apple.watch.filters.caseColor': {
		ar: 'لون الهيكل',
		en: 'Case Color',
	},

	'store.apple.watch.filters.bandColor': {
		ar: 'لون الحزام',
		en: 'Band Color',
	},
	'navbar.language': {
		ar: 'En',
		en: 'العربية',
	},
	'navbar.personal': {
		ar: 'الأفراد',
		en: 'Personal',
	},
	'navbar-business': {
		ar: 'الشركات',
		en: 'Business',
	},
	'navbar.small-and-medium-businesses': {
		ar: 'المؤسسات الصغيرة والمتوسطة',
		en: 'Small and Medium Businesses',
	},
	'navbar.smb': {
		ar: 'المؤسسات الصغيرة والمتوسطة',
		en: 'SMB',
	},
	'navbar.small.enterprises-&-government': {
		ar: 'المؤسسات التجارية',
		en: 'Enterprises',
	},
	'navbar.investors': {
		ar: 'المستثمرون',
		en: 'Investors',
	},
	'navbar.enterprises-&-government': {
		ar: 'المؤسسات التجارية والحكومية',
		en: 'Enterprises & Government',
	},
	'navbar.wholesale': {
		ar: 'أعمال الجملة',
		en: 'Wholesale',
	},
	'navbar.cart.header': {
		ar: 'في عربة التسوق',
		en: 'In your cart',
	},
	'navbar.cart.vat': {
		ar: 'يشمل %%% ضريبة القيمة المضافة​',
		en: '(%%% VAT included)',
	},
	'navbar.cart.clear-all': {
		ar: ' مسح الكل',
		en: 'Clear all',
	},
	'navbar.cart.upfront': {
		ar: 'مقدم',
		en: 'Upfront',
	},
	'navbar.cart.monthly': {
		ar: 'الفاتورة الشهرية',
		en: 'Monthly',
	},
	'navbar.cart.remaining.months.bills': {
		ar: 'فواتير الشهر المتبقية %%',
		en: 'Remaining %% Month’s Bills',
	},
	'navbar.cart.go-to-cart': {
		ar: 'اذهب إلى عربة التسوق',
		en: 'Go to cart',
	},
	'navbar.cart.empty-state.title': {
		ar: 'لا يوجد شيئ هنا!',
		en: 'Nothing’s here!',
	},
	'navbar.cart.empty-state.description': {
		ar: 'عربة التسوق الخاصة بك فارغة ، فقط قم بزيارة متجرنا وابحث عن أفضل الأجهزة في عمان!',
		en: 'Your cart is empty go just check out our store and find the best devices in Oman!',
	},
	'flyout.cart.empty-state.label': {
		ar: 'حقيبة التسوق فارغة',
		en: 'Your Shopping Bag is empty.',
	},
	'navbar.cart.go-to-store': {
		ar: 'اذهب إلى المتجر',
		en: 'Go to store',
	},
	'breadcrumbs.store': {
		ar: 'المتجر',
		en: 'Store',
	},
	'breadcrumbs.home': {
		ar: 'الصفحة الرئيسية',
		en: 'Home',
	},
	'breadcrumbs.promotions': {
		ar: 'العروض ',
		en: 'Promotions',
	},
	'breadcrumbs.search': {
		ar: 'البحث',
		en: 'Search',
	},
	'notify-card.title': {
		ar: 'شكرا لك',
		en: 'Thank you!',
	},
	'notify-card.description.email.part-1': {
		ar: 'سنقوم بإشعارك عبر البريد الإلكتروني ',
		en: 'We`ll notify you via email ',
	},
	'notify-card.description.email.part-2': {
		ar: ' متى سيتوفر المنتج',
		en: ' when product will back in stock.',
	},
	'notify-card.description.number.part-1': {
		ar: 'سنقوم بإشعارك عبر الرسائل النصية',
		en: 'We’ll notify you via SMS ',
	},
	'notify-card.description.number.part-2': {
		ar: ' متى سيتوفر المنتج',
		en: ' when product will back in stock.',
	},
	'product-availability-card.title': {
		ar: 'تحقق إذا كان المنتج متوفرًا في منفذ عمانتل',
		en: 'Check if product is available in Omantel Outlet',
	},
	'product-availability-card.select.city': {
		ar: ' اختر مدينتك',
		en: 'Select your city',
	},
	'product-availability-card.product.available': {
		ar: ' المنتج متوفر',
		en: 'Product available',
	},
	'product-availability-card.product.unavailable': {
		ar: ' المنتج غير متوفر',
		en: 'Product unavailable',
	},
	'product-availability-card.product.device': {
		ar: ' الجهاز',
		en: 'DEVICE',
	},
	'product-availability-card.product.storage': {
		ar: ' سعة التخزين',
		en: 'STORAGE',
	},
	'product-availability-card.product.color': {
		ar: ' اللون',
		en: 'COLOR: ',
	},
	'megamenu.search.input.placeholder': {
		ar: '...البحث',
		en: 'Search...',
	},
	'megamenu.search.no-results': {
		ar: 'لم يتم العثور على نتائج. حاول إدخال الكلمة الأساسية بطريقة مختلفة.',
		en: 'No results found. Try entering the keyword in a different way.',
	},
	'megamenu.search.popular-products': {
		ar: 'المنتجات الأكثر شعبية',
		en: 'Popular products',
	},
	'megamenu.search.tab.portal': {
		ar: 'الموقع',
		en: 'Portal',
	},
	'megamenu.search.tab.store': {
		ar: 'المتجر',
		en: 'Store',
	},
	'megamenu.search.popular-product.starts-from': {
		ar: 'يبدأ من',
		en: 'Starts from',
	},
	'megamenu.search.popular-product.vat': {
		ar: ' %%% ضريبة القيمة المضافة',
		en: '+ %%% VAT',
	},
	'megamenu.mobile.title': {
		ar: 'الباقات التي تتناسب مع احتياجاتك',
		en: 'Mobile in your hands',
	},
	'megamenu.store.prefix': {
		ar: 'عرض جميع',
		en: 'Browse all',
	},
	'megamenu.search.featured': {
		ar: 'المنتجات المميزة',
		en: 'Featured',
	},
	'megamenu.search.topup': {
		ar: 'إعادة التعبئة',
		en: 'Topup',
	},
	'megamenu.search.pay-bill': {
		ar: 'دفع الفواتير',
		en: 'Pay bill',
	},
	'megamenu.search.top-up': {
		ar: 'تعبئة الرصيد',
		en: 'Top up',
	},
	'megamenu.search.roaming': {
		ar: 'التجوال',
		en: 'Roaming',
	},
	'megamenu.search.apple': {
		ar: 'آبل',
		en: 'Apple',
	},
	'megamenu.search.samsung': {
		ar: 'سامسونج',
		en: 'Samsung',
	},
	'megamenu.search.netflix': {
		ar: 'نتفلكس',
		en: 'Netflix',
	},
	'megamenu.search.i_tunes': {
		ar: 'iTunes',
		en: 'iTunes',
	},
	'megamenu.search.offer': {
		ar: 'عرض',
		en: 'Offer',
	},
	'megamenu.search.hayyak': {
		ar: 'حياك',
		en: 'Hayyak',
	},
	'megamenu.search.baqati': {
		ar: 'باقتي',
		en: 'Baqati',
	},
	'html.title.route.store': {
		ar: 'المتجر | متجر عمانتل الإلكتروني',
		en: 'Store | Omantel Eshop',
	},
	'html.title.route.promotions': {
		ar: 'البحث | متجر عمانتل الإلكتروني',
		en: 'Search | Omantel Eshop',
	},
	'html.title.route.test': {
		ar: 'عرض تجريبي | متجر عمانتل الإلكتروني',
		en: 'Test View | Omantel Eshop',
	},
	'html.title.route.default': {
		ar: ' مرحبا بكم في متجر عمانتل الإلكتروني',
		en: 'Welcome to Omantel Eshop',
	},
	'html.meta-data': {
		ar: 'عمانتل ، متجر ، متجر الكتروني ، بيع بالتجزئة ، أجهزة ،',
		en: 'omantel, store, eshop, retail, devices,',
	},
	'html.meta-data.route.store': {
		ar: 'المنتجات الجديدة ، المنتجات ، التهيئة ، الهاتف الذكي',
		en: 'new arrivals, products, configurator, smartphone',
	},
	'html.meta-data.route.promotions': {
		ar: 'عروض ترويجية ، صفقات ، بيع"',
		en: 'promotions, deals, sale',
	},
	'sorting-variant.PRICE_DESCENDING': {
		ar: 'السعر: من الأعلى إلى الأقل',
		en: 'Price: High to Low',
	},
	'sorting-variant.PRICE_ASSCENDING': {
		ar: 'السعر: من الأقل إلى الأعلى',
		en: 'Price: Low to High',
	},
	'sorting-variant.NEWEST_ARRIVALS': {
		ar: 'أحدث المنتجات',
		en: 'Newest arrivals',
	},
	'sorting-variant.RECOMMENDED': {
		ar: 'اخترنا لك',
		en: 'Recommended',
	},
	'sorting-method.title': {
		ar: 'الترتيب',
		en: 'Sorting',
	},
	'user.reviews.quantity': {
		ar: ' (%% مراجعات)',
		en: '(%% reviews)',
	},
	'availability.only.online': {
		ar: 'هذا المنتج متوفر في المتجر الالكتروني فقط.',
		en: 'This product is only available online.',
	},
	'availability.digital.products.instatly': {
		ar: 'يتم شحن المنتجات الرقمية على الفور.',
		en: 'Digital products are shipped instantly. ',
	},
	'availability.selected.product': {
		ar: 'يعتمد توفر المنتج على الخصائص المختارة',
		en: 'Availability may vary based on selected product features.',
	},
	'availability.time.left.to.order': {
		ar: 'اطلب ٪٪ لتحصل عليه غدًا.',
		en: 'Order in %% to get it tommorow.',
	},
	'availability.check.availability': {
		ar: 'تحقق من التوفر في',
		en: 'Check availability in',
	},
	'outlet.pickup.availability.outlet-available': {
		ar: 'عمانتل صالة في المنتج توافر من تحقق ',
		en: 'Check availability in Omantel Outlet',
	},
	'outlet.pickup.availability.outlet-bnpl': {
		ar: 'اختيار "اشتر الآن وادفع لاحقًا" يستثني إمكانية الاستلام من المتجر.',
		en: 'Choosing the "Buy now, pay later" option excludes the possibility of in-store pickup.',
	},
	'outlet.pickup.availability.outlet-not-available': {
		ar: 'عذراً هذا المنتج غير متوفر للاستلام من صالة عمانتل',
		en: 'Sorry, this product is currently not available for outlet pickup',
	},
	'availability.omantel.outlet': {
		ar: 'منفذ عمانتل',
		en: 'Omantel Outlet',
	},
	'availability.out.of.stock': {
		ar: 'عذرا ، هذا المنتج غير متوفر حاليا.',
		en: 'Sorry, this product is currently not available.',
	},
	'availability.out.of.stock.title': {
		ar: 'غير متوفر',
		en: 'Out of stock',
	},
	'availability.in.stock': {
		ar: 'متوفر',
		en: 'In stock',
	},
	'short.description.about.title': {
		ar: 'وصف',
		en: 'About',
	},
	'payment.summary.title.device.payment': {
		ar: 'دفع المنتج',
		en: 'Product payment',
	},
	'payment.summary.title.device.commitment-period': {
		ar: 'فترة الالتزام',
		en: 'Commitment period',
	},
	'payment.summary.title.payment': {
		ar: 'الدفع',
		en: 'Payment',
	},
	'payment.summary.description.title': {
		ar: 'سعر المنتج',
		en: 'Product price',
	},
	'payment.summary.description.device.title': {
		ar: 'سعر الجهاز',
		en: 'Device price',
	},
	'payment.summary.description.installments': {
		ar: 'الأقساط',
		en: 'Installments',
	},
	'payment.summary.description.subtitle': {
		ar: 'المقدم ',
		en: 'Upfront',
	},
	'payment.summary.one.time.payment': {
		ar: 'دفعة واحدة',
		en: 'One-time payment',
	},
	'payment.summary.payment-now': {
		ar: 'الدفع الآن',
		en: 'Payment Now',
	},
	'payment.summary.installments.period': {
		ar: ' %% شهر',
		en: ' %% months',
	},
	'payment.summary.installments.1st.bill.amount': {
		ar: 'مبلغ الفاتورة الأولى',
		en: '1st Bill Amount',
	},
	'modal.weak-password.message': {
		ar:
			'لا تلتزم كلمة المرور بسياسات كلمة المرور. تتضمن سياسة كلمة المرور ما يلي: الحد الأدنى 10 أحرف، والحد الأدنى حرف كبير واحد، والحد الأدنى رقم واحد، والحد الأدنى حرف خاص واحد ، ولا يُسمح بالأرقام المستمرة، على سبيل المثال Xyz@123 أو yxe@456',
		en:
			'The password does not adhere to the password policies. Password Policy includes the following: Minimum of 10 characters, Min 1 upper case, Min 1 digit, Min 1 special character, and Continuous numbers are not allowed e.g. Xyz@123 or yxe@456',
	},
	'modal.weak-password.reset-password': {
		ar: 'إعادة تعيين كلمة المرور',
		en: 'Reset Password',
	},
	'modal.login.returning.customers': {
		ar: 'المشتركيين الحاليين',
		en: 'Existing customer',
	},
	'modal.login.phone.number.or.email': {
		ar: 'رقم الهاتف أو البريد الإلكتروني',
		en: 'Phone number or e-mail',
	},
	'modal.login.password': {
		ar: 'كلمة المرور',
		en: 'Password',
	},
	'modal.login.sign.in': {
		ar: 'تسجيل الدخول',
		en: 'Sign in',
	},
	'modal.login.forgot.password': {
		ar: 'هل نسيت كلمة المرور؟',
		en: 'Forgot password?',
	},
	'modal.login.not.omantel.client': {
		ar: 'لست من عملاء عمانتل؟',
		en: 'Not an Omantel client?',
	},
	'modal.login.dont.have.account': {
		ar: 'ليس لديك حساب؟',
		en: 'Don`t have an account?',
	},
	'modal.login.omantel.client.already': {
		ar: 'هل أنت من مشتركي عمانتل؟',
		en: 'Are you Omantel customer already?',
	},
	'modal.login.create.account-pre': {
		ar: 'قم بـ ',
		en: '',
	},
	'modal.login.create.account': {
		ar: ' إنشاء حساب ',
		en: 'Create an account',
	},
	'modal.login.login-label': {
		ar: 'تسجيل الدخول',
		en: 'Login',
	},
	'modal.delete-payment-token.title': {
		ar: 'هل أنت متأكد أنك تريد حذف هذه البطاقة؟',
		en: 'Are you sure you want to delete this card?',
	},
	'modal.delete-payment-token.description': {
		ar: 'البطاقة التالية لن تكون متاحة بعد الآن..',
		en: 'Following card will no longer be available.',
	},
	'modal.delete-payment-token.delete': {
		ar: 'حذف',
		en: 'Delete',
	},
	'modal.login.create.account.shipping.easy': {
		ar: 'واجعل تجربة تسوقك سهلة ',
		en: ' and make your shopping experience easy.',
	},
	'modal.login.continue.as.guest': {
		ar: 'المتابعة كضيف',
		en: 'Continue as guest',
	},
	'modal.login.invalid.credentials': {
		ar: 'البيانات غير صالحة',
		en: 'Invalid credentials',
	},
	'product.details.login.prompt': {
		ar: ' قم بتسجيل الدخول إلى حساب عمانتل الخاص بك لمعرفة العروض المتاحة لك.',
		en: 'Log in to your Omantel account to see if there are any special offers available to you.',
	},
	'product.details.login.prompt.button': {
		ar: 'تسجيل الدخول',
		en: 'Log in',
	},
	'product.details.plan': {
		ar: 'الباقة',
		en: 'Plan',
	},
	'product.details.plan-upgrade': {
		ar: 'ترقية الباقة',
		en: 'Upgrade your plan',
	},
	'product.details.plan-title': {
		ar: 'كيف تريد أن تدفع؟',
		en: 'How would you like to pay?',
	},
	'product.details.plan.device.only': {
		ar: 'الجهاز فقط',
		en: 'Device only',
	},
	'product.details.plan.with.plan': {
		ar: 'مع الباقة',
		en: 'With plan',
	},
	'product.details.plan.your.number': {
		ar: 'رقم الهاتف',
		en: 'Your number',
	},
	'product.details.plan.your.current.plan': {
		ar: 'الباقة الحالية',
		en: 'Your current plan',
	},
	'product.details.plan.selected.plan': {
		ar: 'الباقة المختارة',
		en: 'Selected plan',
	},
	'product.details.plan.change': {
		ar: 'تغيير',
		en: 'Change',
	},
	'product.details.plan.exp.date.after.renewal': {
		ar: 'تاريخ الانتهاء بعد التجديد',
		en: 'Exp. date after renewal',
	},
	'product.details.plan.edit.warning': {
		ar:
			'عذرًا، لا يمكننا التحقق من تفاصيل التقسيط في الوقت الحالي. يرجى المحاولة مرة أخرى لاحقًا أو التواصل معنا عبر المساعد الرقمي "نور" لتلقي الدعم.',
		en:
			'Sorry, we are unable to check installment details at the moment. Please try again later or contact us through our digital assistant ‘Noor’ for support.',
	},
	'product.details.generic.warning': {
		ar:
			'لم نتمكن من إضافة هذا الجهاز إلى سلة التسوق. يرجى المحاولة مجدداً في وقت لاحق أو التواصل معنا عبر المساعد الرقمي "نور" لتلقي الدعم.',
		en:
			'We’re experiencing trouble adding this device to your cart. Please try again later or contact us through our digital assistant ‘Noor’ for support.',
	},
	'product.details.plan.edit.voucher.warning': {
		ar: 'عذرًا، ليس لدينا قسيمة لك',
		en: 'Sorry, we do not have a voucher for you',
	},
	'product.details.plan.edit.voucher.warning.invalid.account.category': {
		ar: 'فئة الحساب غير صالحة',
		en: 'Invalid account category',
	},
	'product.details.plan.edit.voucher.warning.closed.balance': {
		ar: 'الرصيد مغلق',
		en: 'Closed balance',
	},
	'product.details.plan.edit.voucher.warning.not.configured': {
		ar: 'الرقم غير مكون للقسيمة الذكية',
		en: 'Number not configured for smart voucher',
	},
	'product.details.plan.edit.voucher.warning.device.commitments.exists': {
		ar: 'وجود التزام للجهاز، غير مؤهل لجهاز آخر ',
		en: 'Device commitment exist, not eligible for another device',
	},
	'product.details.plan.edit.voucher.warning.not.active': {
		ar: 'رقم الهاتف غير نشط',
		en: 'Phone number is not active',
	},
	'product.details.plan.edit.warning.wrong.device': {
		ar:
			'عذرًا، لا يمكن شراء هذا الجهاز من خلال باقتك الحالية. يرجى اختيار جهاز آخر أو التواصل معنا عبر المساعد الرقمي "نور" لتلقي الدعم.',
		en:
			'Sorry, this device is not available for purchase with your current plan. Please select another device or contact us through our digital assistant ‘Noor’ for support.',
	},
	'product.details.plan.edit.warning.buy.device.only': {
		ar: 'اشتر ',
		en: 'Buy ',
	},
	'product.details.plan.edit.warning.device.only.underline': {
		ar: 'الجهاز فقط',
		en: 'Device only',
	},
	'product.details.plan.edit.warning.device.only': {
		ar: 'أو اتصل بالرقم %% للحصول على مزيد من المعلومات.',
		en: ' or call %% to get more information.',
	},
	'product.details.plan.edit.warning.device.only.other.number': {
		ar: 'اختر رقم آخر أو اتصل على %% للحصول على المزيد من المعلومات',
		en: 'select other number or call %% to get more information.',
	},
	'button.selector.upfront.button': {
		ar: 'مقدم',
		en: 'Upfront',
	},
	'button.selector.monthly.button': {
		ar: 'شهريا',
		en: 'Monthly',
	},
	'payment.summary.payment.caption.1': {
		ar: 'اطلب ',
		en: 'Get ',
	},
	'payment.summary.payment.caption.2': {
		ar: ' %% خصم ريال عماني ',
		en: ' %% OMR Discount',
	},
	'payment.summary.payment.caption.3': {
		ar: 'عند استخدام',
		en: ' using your',
	},
	'payment.summary.payment.caption.4': {
		ar: 'نقاط مكاسب',
		en: ' Makasib Points!',
	},
	'payment.summary.next-tier': {
		ar: 'النقاط إلى الفئة التالية ',
		en: 'Points to next tier: ',
	},
	'payment.summary.payment.caption.5': {
		ar: 'احصل %% عند استخدام %%',
		en: 'Get %% using your %%',
	},
	'comparison-bar.cancel': {
		ar: 'إلغاء',
		en: 'Cancel',
	},
	'comparison-bar.compare': {
		ar: 'قارن',
		en: 'Compare selected',
	},
	'plan-bar.min': {
		ar: 'الحد الادنى %%',
		en: '%% min.',
	},
	'plan-bar.mo': {
		ar: 'شهر/',
		en: '/mo.',
	},
	'plan-bar.current.plan': {
		ar: 'الباقة الحالية',
		en: 'Current plan',
	},
	'plan-bar.will.expire': {
		ar: 'ستنتهي الصلاحيه %%',
		en: 'Will expire %%',
	},
	'plan-bar.save': {
		ar: 'وفر على سعر جهازك باختيار هذه الباقة.',
		en: 'Save on your device price selecting this plan.',
	},
	'plan-bar.badge': {
		ar: 'وفر ٪٪ ريال عماني على جهازك',
		en: 'Save %% OMR on your device',
	},
	'plan-comparison.monthly.payment': {
		ar: 'الدفعات الشهرية',
		en: 'Monthly payment',
	},
	'plan-comparison.local.gcc.data': {
		ar: 'البيانات المحلية ودول الخليج',
		en: 'Local & GCC Data',
	},
	'plan-comparison.local.minutes': {
		ar: 'الدقائق المحلية',
		en: 'Local minutes',
	},
	'plan-comparison.international.minutes': {
		ar: 'الدقائق الدولية',
		en: 'International minutes',
	},
	'plan-comparison.roaming.recieving.minutes': {
		ar: 'دقائق استقبال التجوال',
		en: 'Roaming recieving minutes',
	},
	'plan-comparison.world.roaming.data': {
		ar: 'بيانات التجوال العالمية',
		en: 'World roaming data',
	},
	'plan-comparison.data.sharing': {
		ar: 'مشاركة البيانات',
		en: 'Data sharing',
	},
	'plan-comparison.store.credit': {
		ar: 'رصيد متجر جوجل / متجر أبل',
		en: 'GooglePlay / AppStore credit',
	},
	'plan-comparison.your.current.plan': {
		ar: 'باقتك الحالية',
		en: 'Your current plan',
	},
	'plan-comparison.recommended.plan': {
		ar: 'الباقة الموصى بها',
		en: 'Recommended plan',
	},
	'plan-comparison.local.gcc': {
		ar: 'محلي ودول الخليج',
		en: 'Local & GCC',
	},
	'plan-comparison.keep.this.plan': {
		ar: 'استمر على هذه الباقة',
		en: 'Keep this plan',
	},
	'plan-comparison.keep.current.plan': {
		ar: 'حافظ على الخطة الحالية',
		en: 'Keep current plan',
	},
	'plan-comparison.select.upgrade.plan': {
		ar: 'ترقية خطتي',
		en: 'Upgrade my plan',
	},
	'plan-comparison.select.plan': {
		ar: 'اختر الباقة',
		en: 'Select plan',
	},
	'plan-selector.recommended.plan': {
		ar: 'الباقة الموصى بها',
		en: 'Recommended plan',
	},
	'plan-selector.see.other.plans': {
		ar: 'اطلع على باقات أخرى',
		en: 'See other plans',
	},
	'comparison.breadcrumb': {
		ar: 'مقارنة',
		en: 'Comparison',
	},
	'homepage.breadcrumb': {
		ar: 'الصفحة الرئيسية',
		en: 'Home',
	},
	'comparison.compare': {
		ar: 'قارن',
		en: 'Compare',
	},
	'comparison.differences': {
		ar: 'ظلل الاختلافات',
		en: 'Highlight differences',
	},
	'comparsion-key.system': {
		ar: 'نظام التشغيل',
		en: 'Operating system',
	},
	'comparsion-key.screen': {
		ar: 'حجم الشاشة',
		en: 'Screen size',
	},
	'comparsion-key.storage': {
		ar: 'سعة التخزين',
		en: 'Storage',
	},
	'comparsion-key.weight': {
		ar: 'الوزن',
		en: 'Weight',
	},
	'comparsion-key.internet': {
		ar: 'الانترنت',
		en: 'Internet',
	},
	'comparsion-key.front-camera': {
		ar: 'الكاميرا الأمامية',
		en: 'Front camera',
	},
	'comparsion-key.battery': {
		ar: 'البطارية',
		en: 'Battery',
	},
	'comparison.key-features': {
		ar: 'الميزات الرئيسية',
		en: 'Key features',
	},
	'price-filter.from': {
		ar: 'من',
		en: 'From',
	},
	'price-filter.to': {
		ar: 'إلى',
		en: 'To',
	},
	'filters.title': {
		ar: 'خيارات التصنيف',
		en: 'Filters',
	},
	'filters.clear': {
		ar: 'مسح الكل',
		en: 'Clear All',
	},
	'filters.price': {
		ar: 'معدل السعر',
		en: 'Price range',
	},
	'filters.show-less': {
		ar: 'عرض أقل',
		en: 'Show less',
	},
	'filters.show-more': {
		ar: 'إظهار المزيد  (%%)',
		en: 'Show more (%%)',
	},
	'price-filter.save': {
		ar: 'حفظ',
		en: 'Save',
	},
	'price-filter.reset': {
		ar: 'إعادة تعيين',
		en: 'Reset',
	},
	'price-filter.range': {
		ar: '%% - %% ريال عماني',
		en: '%% - %% OMR',
	},
	'price-filter.less': {
		ar: ' اقل من %% ريال عماني',
		en: 'Less than %% OMR',
	},
	'price-filter.more': {
		ar: 'اكثر من %% ريال عماني',
		en: 'More than %% OMR',
	},
	'notify.me.when.available': {
		ar: 'أعلمني عند توفر المنتج',
		en: 'Notify me when available in stock',
	},
	'notify.me.radio.button.email': {
		ar: 'البريد الإلكتروني',
		en: 'Email',
	},
	'notify.me.radio.button.sms': {
		ar: 'الرسائل النصية',
		en: 'SMS',
	},
	'notify.me.label.EMAIL': {
		ar: 'البريد الإلكتروني',
		en: 'Email',
	},
	'notify.me.label.SMS': {
		ar: 'رقم الهاتف',
		en: 'Phone number',
	},
	'notify.me.label.full.name': {
		ar: 'الاسم الكامل',
		en: 'Full name',
	},
	'notify.me.button': {
		ar: 'أعلمني',
		en: 'Notify me',
	},
	'submit.button': {
		ar: 'إرسال',
		en: 'Submit',
	},
	'product.configuration.producer.code': {
		ar: 'رمز المنتج: %%',
		en: 'Producer code: %%',
	},
	'product.configuration.color': {
		ar: 'اللون: ',
		en: 'Color: ',
	},
	'product.configuration.caseColor': {
		ar: 'لون الهيكل:',
		en: 'Case Color:',
	},
	'product.configuration.capacity': {
		ar: 'سعة التخزين',
		en: 'Storage',
	},
	'product.configuration.bandColor': {
		ar: 'لون الحزام:',
		en: 'Band Color:',
	},
	'pagination.counter': {
		ar: '%% من %%',
		en: '%% of %%',
	},
	'footer.oman.telecommunications': {
		ar: '© الشركة العمانية للإتصالات 2022',
		en: 'Oman Telecommunications Company © 2022',
	},
	'footer.title.quick-contact': {
		ar: 'جهات التواصل',
		en: 'Quick contact',
	},
	'footer.call.centre-number': {
		ar: 'رقم مركز الإتصال',
		en: 'Call Centre Number',
	},
	'footer.call.international-operator': {
		ar: 'البدالة الدولية',
		en: 'International Operator',
	},
	'footer.call.business-centre': {
		ar: 'مركز إتصال الشركات',
		en: 'Business Call Centre',
	},
	'footer.company': {
		ar: 'الشركة',
		en: 'Company',
	},
	'footer.company.about-us': {
		ar: 'عن عمانتل',
		en: 'About us',
	},
	'footer.company.csr': {
		ar: 'المسؤولية الاجتماعية',
		en: 'CSR',
	},
	'footer.company.career': {
		ar: 'الوظائف',
		en: 'Career',
	},
	'footer.company.media-center': {
		ar: 'المركز الإعلامي',
		en: 'Media Center',
	},
	'footer.company.innovation-labs': {
		ar: 'مختبرات عمانتل للابتكار',
		en: 'Innovation Labs',
	},
	'footer.company.customer-care': {
		ar: 'خدمة المشتركين',
		en: 'Customer Care',
	},
	'footer.customer-care.support': {
		ar: 'المساعدة',
		en: 'Support',
	},
	'footer.customer-care.payment-channels': {
		ar: 'قنوات الدفع',
		en: 'Payment Channels',
	},
	'footer.customer-care.find-outlet': {
		ar: 'المنافذ',
		en: 'Find Outlet',
	},
	'footer.customer-care.coverage': {
		ar: 'التغطية',
		en: 'Coverage',
	},
	'footer.business': {
		ar: 'الشركات',
		en: 'Business',
	},
	'footer.business.investors': {
		ar: 'المستثمرون',
		en: 'Investors',
	},
	'footer.business.isupplier': {
		ar: 'iSupplier',
		en: 'iSupplier',
	},
	'footer.business.wholesale': {
		ar: 'أعمال الجملة',
		en: 'Wholesale',
	},
	'footer.business.e-tendering': {
		ar: 'التناقص الإلكتروني',
		en: 'e-Tendering',
	},
	'footer.business.excavation': {
		ar: 'تصاريح الحفريات',
		en: 'Excavation',
	},
	'footer.policies': {
		ar: 'السياسات',
		en: 'Policies',
	},
	'footer.policies.privacy-policy': {
		ar: 'سياسة الخصوصية',
		en: 'Privacy Policy',
	},
	'footer.policies.whistleblowing-policy': {
		ar: 'سياسة الإبلاغ عن المخالفات',
		en: 'Whistleblowing Policy',
	},
	'footer.follow-us': {
		ar: 'تابعونا على منصات التواصل الاجتماعي',
		en: 'FOLLOW US ON OUR SOCIAL MEDIA',
	},
	'footer.site-map': {
		ar: 'خارطة الموقع',
		en: 'SiteMap',
	},
	'footer.standard-customer-agreement': {
		ar: 'إتفاقية العملاء الموحدة',
		en: 'Standard Customer Agreement',
	},
	'footer.copyrights': {
		ar: 'الملكية الفكرية',
		en: 'Copyrights',
	},
	'continue.to.checkout': {
		ar: 'أتمم عملية الشراء',
		en: 'Continue to checkout',
	},
	'cart.items.your': {
		ar: 'تفاصيل طلبك',
		en: 'Your Items',
	},
	'cart.items.monthly': {
		ar: 'شهري',
		en: 'Monthly',
	},
	'cart.items.one-time': {
		ar: 'دفع لمرة واحدة',
		en: 'One-time Payment',
	},
	'cart.items.payment-now': {
		ar: 'الدفع الآن',
		en: 'Payment Now',
	},
	'cart.items.last-month': {
		ar: 'الشهر الأخير',
		en: 'Last month',
	},
	'cart.items.11-month': {
		ar: 'أول 11 شهرًا',
		en: 'First 11 months',
	},
	'cart.items.23-month': {
		ar: 'أول 23 شهرًا',
		en: 'First 23 months',
	},
	'cart.items.quantity': {
		ar: '%% :الكمية',
		en: 'Quantity: %%',
	},
	'cart.items.vat-price': {
		ar: '+%% ريال عماني',
		en: '+%% OMR',
	},
	'cart.items.vat-percent': {
		ar: ' (%%% ضريبة القيمة المضافة )',
		en: '(%%% VAT)',
	},
	'payment.summary.title': {
		ar: 'ملخص الدفع',
		en: 'Payment Summary',
	},
	'payment.summary.upfront': {
		ar: 'مقدم',
		en: 'Upfront',
	},
	'payment.summary.upfront.regular': {
		ar: 'السعر العادي',
		en: 'Regular price',
	},
	'payment.summary.upfront.vat': {
		ar: '%%% ضريبة القيمة المضافة (مضافة إلى إجمالي القيمة المقدمة)',
		en: '%%% VAT (added to total upfront value)',
	},
	'payment.summary.upfront.taxable.value.vat': {
		ar: '%%% ضريبة القيمة المضافة (تدفع مقدماً من القيمة الخاضعة للضريبة: %% ريال)',
		en: '%%% VAT (paid upfront from taxable value: %% OMR)',
	},
	'payment.summary.period': {
		ar: 'أول ١٢ شهرا',
		en: 'First 12 Months',
	},
	'payment.summary.long-period': {
		ar: 'الأشهر المتبقية',
		en: 'Remaining months',
	},
	'cart.checkout.remaining-months': {
		ar: 'فواتير الأشهر المتبقية %%',
		en: 'Remaining %% Month’s Bills',
	},
	'checkout-info.title': {
		ar: 'ماذا ستحتاج...',
		en: 'What you’ll need...',
	},
	'checkout-info.description-1': {
		ar: 'اسمك وتفاصيل الاتصال بك',
		en: 'Your name and contact details',
	},
	'checkout-info.description-2': {
		ar: 'عنوان التسليم الخاص بك',
		en: 'Your Omani delivery address',
	},
	'checkout-info.description-civil-number': {
		ar: 'الرقم المدني للبطاقة الشخصية أو بطاقة الإقامة الخاصة بك',
		en: 'Civil number of your National ID or Resident Card',
	},
	'checkout-info.description-3': {
		ar: 'تفاصيل بطاقة الخصم أو الائتمان الصادرة من عمان',
		en: 'Omani issued card details',
	},
	'checkout-info.description-3-hayyak': {
		ar: 'تفاصيل البطاقة المصرفية الصادرة في عُمان',
		en: 'Oman-issued bank card details',
	},
	'checkout-info.title-2': {
		ar: 'البطاقات المقبولة',
		en: 'Accepted cards',
	},
	'checkout-info.description-4': {
		ar: 'تذكر أننا نقبل',
		en: 'Remember, that we accept',
	},
	'checkout-info.description-5': {
		ar: 'بطاقة صادرة من عمان فقط!',
		en: 'Omani issued card only!',
	},
	'checkout-info.description-5.1': {
		ar: 'البطاقات المصرفية الصادرة من عُمان فقط!',
		en: 'Oman-issued bank cards only!',
	},
	'cart-view.title': {
		ar: 'عربة التسوق',
		en: 'Cart',
	},
	'cart-item.color': {
		ar: 'اللون: %%',
		en: 'Color: %%',
	},
	'cart-item.storage': {
		ar: 'تخزين: %%',
		en: 'Storage: %%',
	},
	'cart-item.apple-watch.case-color': {
		ar: 'لون الهيكل: %%',
		en: 'Case color: %%',
	},
	'cart.item.remove': {
		ar: 'إزالة',
		en: 'Remove Item',
	},
	'checkout-bar.go-back': {
		ar: 'العودة',
		en: 'Go back',
	},
	'telesales-cancel': {
		ar: 'إلغاء',
		en: 'Cancel',
	},
	'telesales-confirm': {
		ar: 'تأكيد',
		en: 'Confirm',
	},
	'telesales-checkout-bar.step-1': {
		ar: 'تأكيد',
		en: 'Confirmation',
	},
	'telesales-checkout-bar.step-2': {
		ar: 'تفاصيل التسليم',
		en: 'Delivery details',
	},
	'telesales-checkout-bar.step-3': {
		ar: 'الدفع',
		en: 'Payment',
	},
	'telesales-checkout-bar.step-4': {
		ar: 'ملخص',
		en: 'Summary',
	},
	'telesales-checkout.view.voice.title': {
		ar: 'طلب الهاتف الخاص بك',
		en: 'Your telephone order',
	},
	'telesales-checkout.popup.title': {
		ar: 'طلب الهاتف الخاص بك',
		en: 'Your telephone order',
	},
	'telesales-checkout.popup.title.SMS.password': {
		ar: 'أدخل كلمة مرور SMS',
		en: 'Enter SMS password',
	},
	'telesales-checkout.view.voice.description': {
		ar: 'رائع! تفصلك خطوة واحدة عن إتمام طلبك من متجر عمانتل',
		en: 'Great! You are only a step away from completing your Omantel Store order. ',
	},
	'telesales-checkout.popup.description': {
		ar: 'لإتمام طلبك، ستحتاج إلى 4 أرقام الأخيرة من البطاقة الشخصية أو بطاقة المقيم الخاصة بك.',
		en: 'To continue the purchase, please provide us 4 last digits of your ID card..',
	},
	'telesales-checkout.popup.description.SMS': {
		ar: 'لستتلقى كلمة المرور المكونة من 5 أرقام التي ستصلك على هاتفك المتنقل. لمتابعة الشراء: %%.',
		en: 'You will shortly receive a 5-digits password on your mobile: %%.',
	},
	'telesales-checkout.popup.sub-description.SMS': {
		ar: 'أدخل كلمة المرور',
		en: 'Enter the password below.',
	},
	'telesales-checkout.popup.enter-ID-card': {
		ar: 'الأرقام غير صحيحة.',
		en: 'Enter 4 last digits of your ID card',
	},
	'telesales-checkout.login.title': {
		ar: 'هل لديك حساب؟',
		en: 'Do you have an account?',
	},
	'telesales-checkout.login.subtitle': {
		ar: 'سجّل الدخول، وتجنب إدخال بياناتك مرتين.',
		en: 'Sign in and don’t enter your data twice.',
	},
	'telesales-checkout.popup.password.valid-for': {
		ar: 'كلمة المرور الخاصة بك صالحة لـ %%.',
		en: 'Your password is valid for %%.',
	},
	'telesales-checkout.popup.resend-code': {
		ar: 'أعد إرسال الرمز',
		en: 'Resend code',
	},
	'telesales-checkout.popup.enter-digits.incorrect': {
		ar: 'الأرقام غير صحيحة.',
		en: 'The digits are incorrect.',
	},
	'telesales-checkout.view.go.to.store.button': {
		ar: 'اذهب إلى متجر عمانتل',
		en: 'Go to Omantel store',
	},
	'checkout-bar.step-1': {
		ar: 'معلومات شخصية',
		en: 'Personal info',
	},
	'checkout-bar.step-2': {
		ar: 'طريقة الشحن',
		en: 'Shipping method',
	},
	'checkout-bar.step-3': {
		ar: 'الدفع',
		en: 'Payment',
	},
	'checkout-bar.step-4': {
		ar: 'ملخص',
		en: 'Summary',
	},
	'contact-details.title': {
		ar: 'تفاصيل الاتصال',
		en: 'Contact details',
	},
	'contact-details.provide.details': {
		ar: 'يرجى تزويدنا ببيانات الاتصال الخاصة بك.',
		en: 'Please provide us your contact details.',
	},
	'contact-details.provide.birth-date': {
		ar: 'يرجى ادخال تاريخ ميلادك',
		en: 'Please provide your birth date.',
	},
	'contact-details.input.title': {
		ar: 'اللقب',
		en: 'Title',
	},
	'contact-details.input.name': {
		ar: 'الإسم',
		en: 'Name',
	},
	'contact-details.input.middle.name': {
		ar: 'اسم الأب',
		en: 'Middle name',
	},
	'contact-details.input.surname': {
		ar: 'اسم العائلة',
		en: 'Surname',
	},
	'contact-details.input.father-name': {
		ar: 'اسم الأب',
		en: "Father's name",
	},
	'contact-details.input.grandfather-name': {
		ar: 'اسم الجد',
		en: "Grandfather's name",
	},
	'contact-details.input.mail': {
		ar: 'البريد الإلكتروني',
		en: 'E-mail',
	},
	'contact-details.input.phone': {
		ar: 'رقم الهاتف',
		en: 'Phone number',
	},
	'contact-details.omani.numbers': {
		ar: 'حاليًا ، نقبل فقط أرقام الاتصال العمانية.',
		en: 'Currently, we only accept Omani contact numbers.',
	},
	'navbar.careers': {
		ar: 'الوظائف',
		en: 'Careers',
	},
	'checkout-next-step.next': {
		ar: 'التالي',
		en: 'Next',
	},
	'checkout-next-step.next-step': {
		ar: 'الخطوة التالية:',
		en: 'Next step:',
	},
	'checkout-next-step.set-order': {
		ar: 'تثبيت الطلب',
		en: 'Set order',
	},
	'checkout-next-step.set-order.description': {
		ar: 'النقر فوق هذا الزر سوف يوجهك إلى بوابة الدفع ، حيث ستتمكن من إكمال طلبك.',
		en:
			'Clicking this button will redirect you to the payment gateway, where you’ll be able to complete your order.',
	},
	'checkout-summary.success.payment.confirmed': {
		ar: 'تم تأكيد الدفع',
		en: 'Payment confirmed',
	},
	'checkout-summary.success.order.confirmed': {
		ar: 'تم تأكيد الطلب',
		en: 'Order Confirmed',
	},
	'checkout-summary.success.bnpl.title': {
		ar:
			'[AR]Please note that the monthly instalment for the device has to be paid through other payment services in app/website/SSM',
		en:
			'Please note that the monthly instalment for the device has to be paid through other payment services in app/website/SSM',
	},
	'checkout-summary.success.payment.completed-part-1': {
		ar: 'دفعك للنظام ',
		en: 'Your payment for order ',
	},
	'checkout-summary.success.order.completed-part-1': {
		ar: 'وستضاف  الرسوم إلى ',
		en: 'Your order ',
	},
	'checkout-summary.success.payment.completed-part-2': {
		ar: 'قد اكتمل.',
		en: ' is completed.',
	},
	'checkout-summary.success.order.completed-part-2': {
		ar: 'تم إكمال طلبك الذي رقمه فواتيرك الشهرية.',
		en: ' is completed. ',
	},
	'checkout-summary.success.order.completed-part-3': {
		ar: 'تم إكمال طلبك الذي رقمه فواتيرك الشهرية.',
		en: 'The charges will be added to your monthly bills.',
	},

	'checkout-summary.success.payment.completed.thank.you': {
		ar: 'شكرا!',
		en: 'Thank you!',
	},
	'checkout-summary.success.payment.track.order': {
		ar: ':تتبع طلبك ',
		en: 'Track your order: ',
	},
	'checkout-summary.success.payment.order.details': {
		ar: 'تفاصيل الطلب',
		en: 'See order details',
	},
	'checkout-summary.success.payment.back.to.store': {
		ar: 'ارجع إلى المتجر',
		en: 'Go back to store',
	},
	'checkout-summary.rejected': {
		ar: 'تم رفض الدفع',
		en: 'Payment rejected',
	},
	'checkout-summary.zero.payment.rejected': {
		ar: 'فشل الطلب',
		en: 'Order failed',
	},
	'checkout-summary.failed': {
		ar: 'فشل الدفع',
		en: 'Payment Failed',
	},
	'checkout-summary.something.went.wrong.title': {
		ar: 'بيانات الدفع غير مكتملة. برجاء الاتصال على 1234.',
		en: 'Payment data incomplete. Please contact 1234',
	},
	'checkout-summary.something.went.wrong.description': {
		ar: 'حاول مرة اخرى.',
		en: 'Please try again.',
	},
	'checkout-summary.something.went.wrong.greencst.title': {
		ar: 'يرجى المحاولة مرة أخرى أو الاتصال على 1234',
		en: 'Please try again or call 1234',
	},
	'checkout-summary.something.went.wrong.greencst.description': {
		ar: 'حاول مرة اخرى.',
		en: 'Please try again.',
	},
	'checkout-summary.UNABLE_TO_MAKE_PAYMENT': {
		ar: 'يرجى إعادة المحاولة أو محاولة إجراء الدفع بعد مرور بعض الوقت.',
		en: 'Please retry or try making the payment after sometime.',
	},
	'checkout-summary.submission.failed.discription': {
		ar: 'تم الدفع بنجاح. نحن بصدد إكمال طلبك.',
		en: 'Your payment has been successful. We are in the process of completing your order.',
	},
	'checkout-summary.payment.SUBMISSION_FAILED.title': {
		ar: 'الدفع معلق',
		en: 'Payment Pending',
	},
	'checkout-summary.payment.cancel.discription': {
		ar: 'تم الدفع بنجاح. نحن بصدد إكمال طلبك.',
		en: 'Your payment has been successful. We are in the process of completing your order.',
	},
	'checkout-summary.payment.CANCEL.title': {
		ar: 'تم إلغاء المعاملة',
		en: 'Transaction cancelled',
	},
	'checkout-summary.INVALID_CARD_DATA.title': {
		ar: 'هناك مشكلة في الدفع الخاص بك.',
		en: 'There was a problem with your payment.',
	},
	'checkout-summary.INVALID_CARD_DATA.description': {
		ar: 'تأكد من تفاصيل بطاقتك، وأن لديك ما يكفي من الأموال على حسابك أو حاول استخدام بطاقة مختلفة..',
		en:
			'Make sure that card details are valid, you have enough funds on your account\n or try using a different card.',
	},
	'checkout-summary.ORDER_ALREADY_PLACED_BEFORE.title': {
		ar: 'تم تسجيل طلب و دفعه على هذا الرقم مسبقا',
		en: 'An order for your selected number has already been placed and paid for.',
	},
	'checkout-summary.ORDER_ALREADY_PLACED_BEFORE.description': {
		ar: 'الرجاء الإنتظار حتى تتم معاملة الطلب السابق قبل وضع طلب آخر. للمزيد من المعلومات اتصل على %%',
		en:
			'Please wait for the previous order to be processed before placing another one.\n If you have any questions, please call %% and contact our support.',
	},
	'checkout-summary.try.again': {
		ar: 'حاول مرة أخرى',
		en: 'Try again',
	},
	'checkout-summary.try.again.pay': {
		ar: 'ادفع',
		en: 'Pay',
	},
	'order-card.title': {
		ar: 'طلبك',
		en: 'Your order',
	},
	'checkout.secure-checkout': {
		ar: 'الدفع الآمن',
		en: 'Secure checkout',
	},
	'shipping-method.title': {
		ar: 'طريقة الشحن',
		en: 'Shipping method',
	},
	'shipping-method.description': {
		ar: 'يرجى اختيار إحدى خيارات الشحن الآتية.',
		en: 'Please choose one of the following shipping options.',
	},
	'shipping-method.description-sim': {
		ar: 'يرجى تزويدنا بتفاصيل عنوان التسليم الذي يجب أن نرسل إليه بطاقة sim الجديدة.',
		en: 'Please provide us with delivery details for which we should send your new sim card.',
	},
	'digital-product-shipping-method.title': {
		ar: 'طريقة توصيل المنتجات الرقمية',
		en: 'Digital products delivery method',
	},
	'digital-product-shipping-method.description': {
		ar: 'سيتم إرسال الرمز إلى بريدك الإلكتروني.',
		en: 'Your code will be sent to your e-mail.',
	},
	'shipping-method.address-type.same': {
		ar: 'عنوان التسليم يطابق عنوان الفاتورة',
		en: 'Same as billing address',
	},
	'shipping-method.address-type.diffrent': {
		ar: 'استخدم عنوانًا مختلفًا',
		en: 'Use different address',
	},
	'shipping-method.edit-address': {
		ar: 'تعديل العنوان',
		en: 'Edit address',
	},
	'shipping-method.enter-address': {
		ar: 'أدخل العنوان',
		en: 'Enter address',
	},
	'deliver-address.shipmentAddress': {
		ar: 'عنوان التسليم',
		en: 'Delivery address',
	},
	'deliver-address.billingAddress': {
		ar: 'عنوان الفواتير',
		en: 'Billing address',
	},
	'deliver-address.text-field.organization': {
		ar: 'اسم المؤسسة (اختياري)',
		en: 'Organization name (optional)',
	},
	'deliver-address.text-field.governorate': {
		ar: 'المحافظة',
		en: 'Governorate',
	},
	'deliver-address.text-field.wilayat': {
		ar: 'الولاية',
		en: 'Wilayat',
	},
	'deliver-address.text-field.city': {
		ar: 'المدينة',
		en: 'City',
	},
	'deliver-address.text-field.city/area': {
		ar: 'المدينة / المنطقة',
		en: 'City / Area',
	},
	'deliver-address.text-field.area': {
		ar: 'منطقة',
		en: 'Area',
	},
	'deliver-address.text-field.way': {
		ar: 'رقم الطريق',
		en: 'Way number',
	},
	'deliver-address.text-field.house': {
		ar: 'رقم المنزل / المبنى (اختياري)',
		en: 'House / Building number (optional)',
	},
	'deliver-address.text-field.house-info': {
		ar: 'الشقة / رقم المنزل أو المبنى ',
		en: 'House or Building number / Apartment',
	},
	'deliver-address.text-field.apartment': {
		ar: 'رقم الشقة (اختياري)',
		en: 'Apartment number (optional)',
	},
	'deliver-address.text-field.landmark': {
		ar: 'اتجاهات إضافية',
		en: 'Additional directions',
	},
	'deliver-address.next': {
		ar: 'التالي',
		en: 'Next',
	},
	'deliver-address.view-map': {
		ar: 'إعرض الخريطة',
		en: 'View map',
	},
	'deliver-address.save': {
		ar: 'حفظ',
		en: 'Save',
	},
	'deliver-address.map-description': {
		ar: 'اضغط على موقع الفاتورة',
		en: 'Drop a pin at a location you want to have your order delivered.',
	},
	'deliver-address.save-address': {
		ar: 'احفظ هذا العنوان للاستخدام في المستقبل',
		en: 'Save this address for future usage',
	},
	'telesales-checkout.view.section.name': {
		ar: 'أكمل طلبك',
		en: 'Complete your order',
	},
	'telesales-checkout.view.empty.cart': {
		ar: '[AR] Your cart is empty',
		en: 'Your cart is empty',
	},
	'telesales.view.bar.name': {
		ar: 'أكمل طلبك عبر الهاتف',
		en: 'Complete your telephone order',
	},
	'checkout.view.section.name': {
		ar: 'الدفع الآمن',
		en: 'Secure checkout',
	},
	'menu.item.Mobile': {
		ar: 'الهاتف النقال',
		en: 'Mobile',
	},
	'menu.item.prepaid': {
		ar: 'مسبقة الدفع',
		en: 'Prepaid',
	},
	'menu.item.postpaid': {
		ar: 'آجلة الدفع',
		en: 'Postpaid',
	},
	'menu.item.homeservices': {
		ar: 'الخدمات المنزلية',
		en: 'Home Services',
	},
	'menu.postpaid.item.new-baqati': {
		ar: 'باقتي الجديدة',
		en: 'New Baqati',
	},
	'menu.home-services.item.home-internet-plans': {
		ar: 'باقات الانترنت المنزلي',
		en: 'Home internet plans',
	},
	'menu.home-services.item.wi-fi-mesh': {
		ar: 'Wi-Fi Mesh',
		en: 'Wi-Fi Mesh',
	},
	'menu.home-services.item.additional services': {
		ar: 'خدمات إضافية',
		en: 'Additional services',
	},
	'menu.home-services.item.track-your-hbb': {
		ar: 'تتبع حالة طلبك للانترنت المنزلي',
		en: 'Track your HBB',
	},
	'menu.home-services.item.tv-&-entertainment': {
		ar: 'الترفيه التلفزيوني',
		en: 'TV & Entertainment',
	},
	'menu.home-services.item.smart-homes': {
		ar: 'المنزل الذكي',
		en: 'Smart Homes',
	},
	'menu.home-services.item.smart-living': {
		ar: 'الحياة المنزلية الذكية',
		en: 'Smart Living',
	},
	'menu.home-services.item.fixed-services': {
		ar: 'الخدمات الثابتة',
		en: 'Fixed services',
	},
	'menu.home-services.item.promotions': {
		ar: 'العروض',
		en: 'Promotions',
	},
	'menu.home-services.item.ultra-fast': {
		ar: 'إنترنت هائل السرعة',
		en: 'Ultra fast',
	},
	'menu.home-services.item.baiti-fiber': {
		ar: 'بيتي فايبر',
		en: 'Baiti Fiber',
	},
	'menu.home-services.item.baiti-5g': {
		ar: 'بيتي 5G',
		en: 'Baiti 5G',
	},
	'menu.home-services.item.basic-adsl': {
		ar: 'الأساسية (ADSL)',
		en: 'Basic (ADSL)',
	},
	'menu.home-services.item.afaaq-satellite': {
		ar: 'آفاق (الأقمار الصناعية)',
		en: 'Afaaq (Satellite)',
	},
	'menu.home-services.item.wireless-(4g/5g)': {
		ar: 'إنترنت الجيل الرابع والخامس اللاسلكي',
		en: 'Wireless (4G/5G)',
	},
	'menu.home-services.item.basic': {
		ar: 'الأساسية',
		en: 'Basic',
	},
	'menu.home-services.item.afaaq': {
		ar: 'آفاق',
		en: 'Afaaq',
	},
	'menu.home-services.item.omantel-tv+': {
		ar: ' TV+عمانتل ',
		en: 'Omantel TV +',
	},
	'menu.home-services.item.osn+': {
		ar: 'OSN+',
		en: 'OSN+',
	},
	'menu.home-services.item.shahid-vip': {
		ar: ' VIP شاهد',
		en: 'Shahid VIP',
	},
	'menu.home-services.item.shahid': {
		ar: ' VIP شاهد',
		en: 'Shahid',
	},
	'menu.home-services.item.jawwy-tv-home': {
		ar: ' TV جوي',
		en: 'Jawwy TV Home',
	},
	'menu.home-services.item.jawwy-TV': {
		ar: ' TV جوي',
		en: 'Jawwy TV',
	},
	'menu.home-services.item.devices': {
		ar: 'الأجهزة',
		en: 'Devices',
	},
	'menu.home-services.item.gaming-console': {
		ar: 'Gaming Console',
		en: 'Gaming Console',
	},
	'menu.home-services.item.gaming-add-on': {
		ar: 'الخدمات الإضافية للألعاب',
		en: 'Gaming Add-on',
	},
	'menu.home-services.item.geforce-now': {
		ar: 'GeForce NOW',
		en: 'GeForce NOW',
	},
	'menu.home-services.item.fixed-line': {
		ar: 'الهاتف الثابت',
		en: 'Fixed line',
	},
	'menu.home-services.item.sahl': {
		ar: 'سهل',
		en: 'Sahl',
	},
	'menu.postpaid.item.al-ufuq': {
		ar: 'الأفق',
		en: 'Al Ufuq',
	},
	'menu.postpaid.item.erada-plans': {
		ar: 'باقة إرادة',
		en: 'Erada',
	},
	'menu.postpaid.item.aman': {
		ar: 'باقة أمان',
		en: 'Aman',
	},
	'menu.postpaid.item.roaming': {
		ar: 'التجوال',
		en: 'Roaming',
	},
	'menu.postpaid.item.jawazak-gcc': {
		ar: 'جوازك دول الخليج',
		en: 'Jawazak GCC',
	},
	'menu.postpaid.item.jawazak-world': {
		ar: 'جوازك حول العالم',
		en: 'Jawazak World',
	},
	'menu.postpaid.item.jawazak-flight': {
		ar: 'جوازك على متن الطائرة',
		en: 'Jawazak in flight',
	},
	'menu.postpaid.item.roaming-abroad': {
		ar: 'التجوال في الخارج',
		en: 'Roaming Abroad',
	},
	'menu.postpaid.item.transfer-your-number': {
		ar: 'انقل رقمك',
		en: 'Transfer your Number',
	},
	'menu.postpaid.item.e-sim': {
		ar: 'الشريحة الإلكترونية',
		en: 'eSIM',
	},
	'menu.postpaid.item.apple-watch-cellular': {
		ar: 'Apple Watch Cellular',
		en: 'Apple Watch Cellular',
	},
	'menu.postpaid.item.promotions': {
		ar: 'العروض',
		en: 'Promotions',
	},
	'menu.item.get-plans': {
		ar: 'الباقات',
		en: 'Get Plans',
	},
	'menu.item.header.see-all': {
		ar: 'مشاهدة الكل',
		en: 'See all',
	},
	'menu.item.services': {
		ar: 'الخدمات',
		en: 'Services',
	},
	'menu.services.item.5g': {
		ar: 'الجيل الخامس',
		en: '5G',
	},
	'menu.services.item.mobile-app': {
		ar: 'تطبيق عمانتل',
		en: 'Mobile App',
	},
	'menu.services.item.value-added-services': {
		ar: 'الخدمات والمزايا الإضافية',
		en: 'Value Added Services',
	},
	'menu.services.item.auction-number': {
		ar: 'المزايدة بالأرقام',
		en: 'Auction number',
	},
	'menu.services.item.other-services': {
		ar: 'الخدمات الأخرى',
		en: 'Other Services',
	},
	'menu.services.item.get-our-services': {
		ar: 'احصل على خدماتنا',
		en: 'Get our Services',
	},
	'menu.services.item.call-me-back': {
		ar: 'خدمة اتصل',
		en: 'Call me back',
	},
	'menu.services.item.emergency-services': {
		ar: 'خدمة الطوارئ',
		en: 'Emergency Services',
	},
	'menu.services.item.voice-mail': {
		ar: 'البريد الصوتي',
		en: 'Voice mail',
	},
	'menu.services.item.family-&-friends': {
		ar: 'الأقارب والأصدقاء',
		en: 'Family & Friends',
	},
	'menu.services.item.dcb-netflix': {
		ar: 'DCB Netflix',
		en: 'DCB Netflix',
	},
	'menu.services.item.permit-services': {
		ar: 'خدمات التصاريح الخارجية',
		en: 'Permit Services',
	},
	'menu.services.item.money-transfer': {
		ar: 'تحويل الرصيد',
		en: 'Money transfer',
	},
	'menu.services.item.Hayyak-Internet-Gifting': {
		ar: 'إهداء باقات',
		en: 'Hayyak Internet Gifting',
	},
	'menu.item.new-label': {
		ar: 'جديد',
		en: 'NEW',
	},
	'menu.prepaid.item.new-hayyak-plans': {
		ar: 'باقات حياك الجديدة',
		en: 'New Hayyak Plans',
	},
	'menu.prepaid.item.hdop': {
		ar: 'باقة حياك بيانات',
		en: 'Hayyak Data Only',
	},
	'menu.prepaid.item.tourist-pack': {
		ar: 'باقات الزوار',
		en: 'Tourist Packs',
	},
	'menu.prepaid.item.erada': {
		ar: 'ايراده',
		en: 'Erada Plans',
	},
	'menu.prepaid.item.aman': {
		ar: 'باقات أمان',
		en: 'Aman Plans',
	},
	'menu.prepaid.item.payg': {
		ar: 'الدفع حسب الاستهلاك',
		en: 'PAYG',
	},
	'menu.prepaid.item.roaming': {
		ar: 'التجوال',
		en: 'Roaming',
	},
	'menu.prepaid.item.jawazak-gcc': {
		ar: 'جوازك دول الخليج',
		en: 'Jawazak GCC',
	},
	'menu.prepaid.item.jawazak-world': {
		ar: 'جوازك حول العالم',
		en: 'Jawazak World',
	},
	'menu.prepaid.item.jawazak-flight': {
		ar: 'جوازك على متن الطائرة',
		en: 'Jawazak in flight',
	},
	'menu.prepaid.item.roaming-abroad': {
		ar: 'التجوال في الخارج',
		en: 'Roaming Abroad',
	},
	'menu.prepaid.item.add-ons': {
		ar: 'الخدمات والمزايا الإضافية',
		en: 'Add-ons',
	},
	'menu.prepaid.item.mobile-internet': {
		ar: 'الإنترنت المتنقل',
		en: 'Mobile Internet',
	},
	'menu.prepaid.item.national-calls': {
		ar: 'مكالمات محلية',
		en: 'National Calls',
	},
	'menu.prepaid.item.international-calls': {
		ar: 'الاتصالات الدولية',
		en: 'International Calls',
	},
	'menu.prepaid.item.nonstop-social': {
		ar: 'تواصل بلا توقف',
		en: 'Nonstop Social',
	},
	'menu.prepaid.item.Marhaba-World': {
		ar: 'عالم مرحبا',
		en: 'Marhaba World',
	},
	'menu.prepaid.item.unlimited-youtube-&-music': {
		ar: 'يوتيوب وموسيقى بلاحدود',
		en: 'Unlimited Youtube & Music',
	},
	'menu.prepaid.item.talk-more': {
		ar: 'تكلم أكثر',
		en: 'Talk more',
	},
	'menu.prepaid.item.hayyak-liberty': {
		ar: 'حياك على راحتك',
		en: 'Hayyak Liberty',
	},
	'menu.prepaid.add-ons.item.tourist-pack': {
		ar: 'باقات الزوار',
		en: 'Tourist Pack',
	},
	'menu.prepaid.add-ons.item.hayyak-tariff': {
		ar: 'تعرفة حياك',
		en: 'Hayyak Tariff',
	},
	'menu.prepaid.add-ons.item.p2p': {
		ar: 'الانتقال من مسبق الدفع إلى آجل الدفع',
		en: 'Upgrade Prepaid to postpaid',
	},
	'menu.prepaid.item.transfer-your-number': {
		ar: 'انقل رقمك',
		en: 'Transfer your number',
	},
	'menu.prepaid.item.e-sim': {
		ar: 'الشريحة الإلكترونية',
		en: 'eSIM',
	},
	'menu.prepaid.item.apple-watch-cellular': {
		ar: 'Apple Watch Cellular',
		en: 'Apple Watch Cellular',
	},
	'mobile-menu.step.back': {
		ar: 'عودة',
		en: 'Back',
	},
	'menu.prepaid.item.promotions': {
		ar: 'العروض',
		en: 'Promotions',
	},
	'menu.item.Home': {
		ar: 'الصفحة الرئيسية',
		en: 'Home',
	},
	'menu.item.Store': {
		ar: 'المتجر',
		en: 'Store',
	},
	'menu.item.Makasib': {
		ar: 'مكاسب',
		en: 'Makasib',
	},
	'menu.item.5g': {
		ar: 'الجيل الخامس',
		en: '5G',
	},
	'mobile.menu.browse.omantel': {
		ar: ' تصفح عمانتل',
		en: 'Browse Omantel',
	},
	'address.billing.address': {
		ar: 'عنوان الفواتير',
		en: 'Billing address',
	},
	'address.billing.address.subtitle': {
		ar: 'يرجى تزويدنا بعنوان الفاتورة',
		en: 'Please provide us your billing address',
	},
	'terms.and.conditions.title': {
		ar: 'الشروط والأحكام',
		en: 'Terms & Conditions',
	},
	'terms.and.conditions.text': {
		ar: 'لقد قرأت وفهمت ووافقت على ',
		en: 'I’ve read, understand and agree to the ',
	},
	'terms.and.conditions.clickable': {
		ar: 'الشروط والأحكام',
		en: ' Terms & Conditions',
	},
	'address.edit.address': {
		ar: ' العنوان',
		en: 'Edit address',
	},
	'addres.enter.address': {
		ar: 'أدخل العنوان',
		en: 'Enter address',
	},
	'outlet-available.modal.title': {
		ar: ' المنتج فيها يتوفر التي عمانتل صالات من تحقق ',
		en: 'Check in which Omantel Outlet product is available',
	},
	'outlet-available.modal.title-small': {
		ar: 'عمانتل صالات في التوفر',
		en: 'Availability in Omantel outlets',
	},
	'outlet-available.modal.device-label': {
		ar: 'الجهاز',
		en: 'Device',
	},
	'outlet-available.modal.storage-label': {
		ar: 'التخزين سعة',
		en: 'Storage',
	},
	'outlet-available.modal.color-label': {
		ar: 'اللون:',
		en: 'Color:',
	},
	'outlet-available.modal.sunday-label': {
		ar: 'الأحد:',
		en: 'Sunday:',
	},
	'outlet-available.modal.monday-label': {
		ar: 'الأثنين:',
		en: 'Monday:',
	},
	'outlet-available.modal.tuesday-label': {
		ar: 'الثلاثاء:',
		en: 'Tuesday:',
	},
	'outlet-available.modal.wednesday-label': {
		ar: 'الأربعاء:',
		en: 'Wednesday:',
	},
	'outlet-available.modal.thursday-label': {
		ar: 'الخميس:',
		en: 'Thursday:',
	},
	'outlet-available.modal.friday-label': {
		ar: 'الجمعة:',
		en: 'Friday:',
	},
	'outlet-available.modal.saturday-label': {
		ar: 'السبت:',
		en: 'Saturday:',
	},
	'outlet-available.modal.closed-label': {
		ar: 'مغلق',
		en: 'Closed',
	},
	'outlet-available.modal.product-available-label': {
		ar: 'المنتج متوفر',
		en: 'Product available',
	},
	'outlet-available.modal.product-unavailable-label': {
		ar: 'المنتج غير متوفر',
		en: 'Product unavailable',
	},
	'outlet-available.modal.location-label': {
		ar: 'الموقع:',
		en: 'Location:',
	},
	'outlet-available.modal.address-label': {
		ar: 'العنوان:',
		en: 'Address:',
	},
	'outlet-available.modal.phone-label': {
		ar: 'رقم الهاتف:',
		en: 'Phone Number:',
	},
	'outlet-available.modal.hours-label': {
		ar: 'ساعات العمل:',
		en: 'Opening hours:',
	},
	'outlet-available.modal.willayat-label': {
		ar: 'الولاية:',
		en: 'Willayat:',
	},
	'secure-checkout.title': {
		ar: 'تفاصيل الدفع',
		en: 'Payment details',
	},
	'secure-checkout.subtitle': {
		ar: 'يرجى تحديد طريقة الدفع المفضلة لديك.',
		en: 'Please select your preferred payment method.',
	},
	'secure-checkout.input.card-number.label': {
		ar: 'رقم البطاقة',
		en: 'Card number',
	},
	'secure-checkout.input.card-holder.label': {
		ar: ' حامل البطاقة',
		en: 'Card holder',
	},
	'secure-checkout.input.exp-date.label': {
		ar: 'تاريخ الإنتهاء',
		en: 'Exp. date',
	},
	'secure-checkout.input.cvc-cvv.label': {
		ar: 'CVC/CVV',
		en: 'CVC/CVV',
	},
	'secure-checkout.input.card-number.placeholder': {
		ar: 'XXXX XXXX XXXX XXXX',
		en: 'XXXX XXXX XXXX XXXX',
	},
	'secure-checkout.input.card-holder.placeholder': {
		ar: 'الإسم اللقب',
		en: 'Name Surname',
	},
	'secure-checkout.input.exp-date.placeholder': {
		ar: 'MM / YY',
		en: 'MM / YY',
	},
	'secure-checkout.input.cvc-cvv.placeholder': {
		ar: 'XXX',
		en: 'XXX',
	},
	'secure-checkout.input.save-card': {
		ar: 'حفظ هذه البطاقة للدفعات التالية',
		en: 'Save this card for future payments',
	},
	'secure-checkout.payment-tokens.select-from-saved-cards': {
		ar: 'التحديد من البطاقات المحفوظة',
		en: 'Select from saved cards',
	},
	'secure-checkout.payment-tokens.add-new-card': {
		ar: 'إضافة بطاقة جديدة',
		en: 'Add New Card',
	},
	'secure-checkout.payment-appple-pay': {
		ar: 'آبل باي',
		en: 'Apple Pay',
	},
	'secure-checkout.payment-tokens.use-different-card': {
		ar: 'استخدم بطاقة مختلفة',
		en: 'Use different card',
	},
	'secure-checkout.add-card': {
		ar: 'إضافة بطاقة جديدة',
		en: 'Add new card',
	},
	'secure-checkout.payment-tokens.selected': {
		ar: 'المحدد',
		en: 'Selected',
	},
	'secure-checkout.payment-tokens.delete': {
		ar: 'حذف',
		en: 'Delete',
	},
	'validate.personal.data.first.name.must.be.string': {
		ar: 'يجب أن يتضمن الاسم الأول حروف فقط',
		en: 'First name must includes letters only',
	},
	'validate.personal.data.first.name.required': {
		ar: 'الإسم الأول مطلوب',
		en: 'First name is required',
	},
	'validate.personal.data.middle.name.must.be.string': {
		ar: 'يجب أن يتضمن الاسم الأوسط حروف فقط',
		en: 'Middle name must includes letters only',
	},
	'validate.personal.data.last.name.must.be.string': {
		ar: 'يجب أن يتضمن اسم العائلة حروف فقط',
		en: 'Last name must includes letters only',
	},
	'validate.personal.data.last.name.required': {
		ar: 'إسم العائلة مطلوب',
		en: 'Last name is required',
	},
	'validate.personal.data.email.must.be.email': {
		ar: 'تنسيق البريد الإلكتروني مطلوب',
		en: 'Email format required',
	},
	'validate.personal.data.email.required': {
		ar: 'البريد الإلكتروني مطلوب',
		en: 'Email required',
	},
	'validate.personal.data.birth-date.required': {
		ar: 'تاريخ الميلاد مطلوب',
		en: 'Birth date required',
	},
	'validate.personal.data.father-name.required': {
		ar: 'اسم الأب مطلوب',
		en: "Father's name required",
	},
	'validate.personal.data.father-name.must.be.string': {
		ar: 'يجب أن يتضمن اسم الأب حروفا فقط',
		en: "Father's name must includes letters only",
	},
	'validate.personal.data.grandfather-name.required': {
		ar: 'اسم الجد مطلوب',
		en: "Grandfather's name required",
	},
	'validate.personal.data.grandfather-name.must.be.string': {
		ar: 'يجب أن يتضمن اسم الجد حروفا فقط',
		en: "Grandfather's name must includes letters only",
	},
	'validate.personal.data.oman.format.phone.number': {
		ar: 'حاليًا نقبل فقط أرقام الاتصال العمانية.',
		en: 'Currently, we only accept Omani contact numbers.',
	},
	'validate.personal.data.contact.number.required': {
		ar: 'رقم الهاتف مطلوب',
		en: 'Contact Number is required',
	},
	'validate.personal.data.phone.number.required': {
		ar: 'رقم الهاتف مطلوب',
		en: 'Phone number required',
	},
	'validation.creditCards.expired': {
		ar: 'البطاقة منتهية الصلاحية',
		en: 'Card expired',
	},
	'validation.creditCards.expDate': {
		ar: 'يبدو أن التاريخ الذي تم إدخاله غير صحيح',
		en: 'Wrong format (MM/YY)',
	},
	'validation.creditCards.expDate.required': {
		ar: 'يرجى تحديد تاريخ الانتهاء',
		en: 'Expiry date is required',
	},
	'validation.creditCards.name.format': {
		ar: 'يرجى إدخال الاسم الصحيح',
		en: 'Provide valid name and surname',
	},
	'validation.creditCards.name.letters': {
		ar: 'يرجى إدخال الأحرف فقط لاسم حامل البطاقة',
		en: 'Card holder should have only letters',
	},
	'validation.creditCards.name.max': {
		ar: 'عدد حروف الاسم تتجاوز الحد الأقصى',
		en: 'Name and surname are too long',
	},
	'validation.creditCards.name.min': {
		ar: 'عدد حروف الاسم والقبيلة قليلة جداً',
		en: 'Name and surname are too short',
	},
	'validation.creditCards.name.required': {
		ar: 'اسم حامل البطاقة مطلوب',
		en: 'Card holder name is required',
	},
	'validation.creditCards.name.twoWords': {
		ar: 'يرجى إدخال الاسم المطابق لبطاقة الإئتمان',
		en: 'Card holder should have only name and surname',
	},
	'validation.creditCards.numbers': {
		ar: 'نأسف! يبدو أن الرقم الذي تم إدخاله غير صحيح',
		en: 'Oh! Entered number seems to be incorrect',
	},
	'validation.creditCards.numbers.required': {
		ar: 'رقم البطاقة مطلوب',
		en: 'Card number is required',
	},
	'validation.creditCards.securityCode.format': {
		ar: 'رمز الحماية الثلاثي الذي تم إدخاله غير صحيح',
		en: 'Wrong CVV code format',
	},
	'validation.creditCards.securityCode.min': {
		ar: 'رمز الحماية مكون من ثلاثة أرقام',
		en: 'CVV code is to short',
	},
	'validation.creditCards.securityCode.required': {
		ar: 'رمز الحماية الثلاثي مطلوب',
		en: 'CVV code is required',
	},
	'contact.details.dropdown.mr': {
		ar: 'السيد',
		en: 'Mr',
	},
	'contact.details.dropdown.ms': {
		ar: 'آنسة',
		en: 'Ms',
	},
	'payment-details.title': {
		ar: 'طريقة الدفع',
		en: 'Payment method',
	},
	'payment-details.payment.card': {
		ar: 'الدفع بالبطاقة',
		en: 'Payment by card',
	},
	'payment-details.payment.card.description': {
		ar: ' سيخصم %% ريال عماني من بطاقتك',
		en: 'Your card will be charged for OMR %%.',
	},
	'payment-details.payment.makasib.description': {
		ar: 'ستستبدل %% من نقاط مكاسب أي ما يعادل %% ريال عماني.',
		en: 'You will redeem %% Makasib points, which is equal to OMR %%.',
	},
	'shipping-details.title': {
		ar: 'تفاصيل التوصيل',
		en: 'Shipping details',
	},
	'order-details.title': {
		ar: 'تفاصيل الطلب',
		en: 'Order details',
	},
	'sim-order-details.accordion.contact-data.data.civil-number': {
		ar: 'الرقم المدني',
		en: 'Civil number',
	},
	'shipping-details.accordion.contact-data.title': {
		ar: 'تفاصيل الاتصال وعنوان الفواتير',
		en: 'Contact details & Billing address',
	},
	'shipping-details.accordion.contact-data.section-header': {
		ar: 'البيانات',
		en: 'Contact details',
	},
	'shipping-details.accordion.contact-data.data.title': {
		ar: 'اللقب',
		en: 'Title',
	},
	'shipping-details.accordion.contact-data.data.name': {
		ar: 'الإسم',
		en: 'Name',
	},
	'shipping-details.accordion.contact-data.data.email': {
		ar: 'بريد إلكتروني',
		en: 'E-mail',
	},
	'shipping-details.accordion.contact-data.data.phoneNumber': {
		ar: 'رقم الهاتف',
		en: 'Phone number',
	},
	'shipping-details.accordion.billing-data.section-header': {
		ar: 'عنوان الفواتير',
		en: 'Billing address',
	},
	'shipping-details.accordion.delivery-method.section-header': {
		ar: 'طريقة التوصيل',
		en: 'Delivery method',
	},
	'shipping-details.accordion.delivery-method.title': {
		ar: 'توصيل',
		en: 'Delivery',
	},
	'shipping-details.accordion.outlet.description': {
		ar: 'سيتم توصيل طلبك للصالة التي اخترتها',
		en: 'Order will be delivered at your selected outlet',
	},
	'shipping-details.accordion.delivery-method.description': {
		ar: 'سيتم تسليم الطلب على العنوان الذي اخترته',
		en: 'Order will be delivered at your selected address',
	},
	'shipping-details.accordion.delivery-address.section-header': {
		ar: 'عنوان التسليم',
		en: 'Delivery address',
	},
	'shipping-details.accordion.outlet-pickup.section-header': {
		ar: 'تفاصيل الصالة',
		en: 'Outlet details',
	},
	'shipping-details.accordion.appointment.section-header': {
		ar: 'تفاصيل الموعد',
		en: 'Appointment details',
	},
	'shipping-details.accordion.appointment.outlet-in': {
		ar: 'صالة عمانتل في',
		en: 'Omantel outlet in',
	},
	'shipping-details.accordion.appointment.outlet-on': {
		ar: 'يوم',
		en: 'on',
	},
	'shipping-details.accordion.appointment.outlet-appointment-description': {
		ar: 'موعد الاستلام من الصالة ',
		en: 'Outlet pickup appointment: ',
	},
	'shipping-details.billing.shipping-data.data.outlet-located': {
		ar: 'مكان الصالة',
		en: 'The facility where the outlet is located',
	},
	'shipping-details.billing.shipping-data.data.address': {
		ar: 'العنوان',
		en: 'Address',
	},
	'shipping-details.billing.shipping-data.data.phone-number': {
		ar: 'رقم الهاتف',
		en: 'Phone number',
	},
	'shipping-details.billing.shipping-data.data.opening-hours': {
		ar: 'ساعات العمل',
		en: 'Opening hours',
	},

	'shipping-details.billing.contact-data.data.governorate': {
		ar: 'محافظة',
		en: 'Governorate',
	},
	'shipping-details.billing.contact-data.data.wilayat': {
		ar: 'ولاية',
		en: 'Wilayat',
	},
	'shipping-details.billing.contact-data.data.city': {
		ar: 'المدينة',
		en: 'City',
	},
	'shipping-details.billing.contact-data.data.city-area': {
		ar: 'المدينة / المنطقة',
		en: 'City / Area',
	},
	'shipping-details.billing.contact-data.data.way': {
		ar: 'رقم الطريق',
		en: 'Way number',
	},
	'shipping-details.billing.contact-data.data.house': {
		ar: 'رقم المنزل / المبنى',
		en: 'House / building number',
	},
	'shipping-details.billing.contact-data.data.landmark': {
		ar: 'توجيهات إضافية حول التسليم ، المعالم (اختياري)',
		en: 'Additional directions about delivery, landmark etc. (optional)',
	},
	'shipping-details.accordion.shipping-data.title': {
		ar: 'طريقة توصيل المنتجات',
		en: 'Products delivery method',
	},
	'sim-order-details.accordion.shipping-data.title': {
		ar: 'تفاصيل تسليم المنتجات',
		en: 'Products delivery details',
	},
	'shipping-details.accordion.digital-shipping-data.title': {
		ar: 'طريقة توصيل المنتجات الرقمية',
		en: 'Digital products delivery method',
	},
	'shipping-details.accordion.contact-data.subtitle-0': {
		ar: 'البيانات',
		en: 'Contact details',
	},
	'shipping-details.accordion.contact-data.subtitle-1': {
		ar: '%%',
		en: '%%',
	},
	'shipping-details.accordion.contact-data.subtitle-2': {
		ar: '%% %%',
		en: '%% %%',
	},
	'shipping-details.accordion.contact-data.subtitle-3': {
		ar: '%% %% %%',
		en: '%% %% %%',
	},
	'shipping-details.accordion.shipping-data.subtitle-0': {
		ar: 'توصيل',
		en: 'Delivery',
	},
	'shipping-details.accordion.shipping-data.subtitle-1': {
		ar: 'توصيل, %%',
		en: 'Delivery, %%',
	},
	'shipping-details.accordion.shipping-data.subtitle-2': {
		ar: 'توصيل, %%, %%',
		en: 'Delivery, %%, %%',
	},
	'shipping-details.accordion.shipping-data.subtitle-3': {
		ar: 'توصيل, %%, %%, %%',
		en: 'Delivery, %%, %%, %%',
	},
	'shipping-details.accordion.shipping-data.subtitle-4': {
		ar: 'توصيل, %%, %%, %%, %%',
		en: 'Delivery, %%, %%, %%, %%',
	},
	'shipping-details.accordion.shipping-data.subtitle-5': {
		ar: 'توصيل, %%, %%, %%, %%%%',
		en: 'Delivery, %%, %%, %%, %%%%',
	},
	'shipping-details.billing.shipping-data.data.governorate': {
		ar: 'محافظة',
		en: 'Governorate',
	},
	'shipping-details.billing.shipping-data.data.wilayat': {
		ar: 'ولاية',
		en: 'Wilayat',
	},
	'shipping-details.billing.shipping-data.data.city': {
		ar: 'المدينة',
		en: 'City',
	},
	'shipping-details.billing.shipping-data.data.city-area': {
		ar: 'المدينة / المنطقة',
		en: 'City / Area',
	},
	'shipping-details.billing.shipping-data.data.way': {
		ar: 'رقم الطريق',
		en: 'Way number',
	},
	'shipping-details.billing.shipping-data.data.house': {
		ar: 'رقم المنزل / المبنى',
		en: 'House / building number',
	},
	'shipping-details.billing.shipping-data.data.landmark': {
		ar: 'توجيهات إضافية حول التسليم ، والمعالم (اختياري)',
		en: 'Additional directions about delivery, landmark etc. (optional)',
	},
	'shipping-details.billing.shipping-data.data.apartment': {
		ar: 'الشقة',
		en: 'Apartment',
	},
	'delivery.address.required-field': {
		ar: 'حقل مطلوب',
		en: 'Required field',
	},
	'delivery.area.missing-reminder': {
		ar: '[AR]Select the area for this address and save it to continue the process.',
		en: 'Select the area for this address and save it to continue the process.',
	},
	'delivery.address.search': {
		ar: 'عنوان البحث...',
		en: 'Please search your location, put pin on a map or use navigate button',
	},
	'address.apt': {
		ar: 'شقة.',
		en: 'Apt.',
	},
	'plans.selected.number.billing.type.': {
		ar: '',
		en: '',
	},
	'plans.selected.number.billing.type.POSTPAID': {
		ar: 'باقاتي',
		en: 'Baqati',
	},
	'plans.selected.number.billing.type.PREPAID': {
		ar: 'حياك',
		en: 'Hayyak',
	},
	'plans.selected.number.dropdown': {
		ar: 'الرقم المحدد',
		en: 'Selected number',
	},
	'contact-details.save': {
		ar: 'حفظ',
		en: 'Save',
	},
	'contact-details.cancel': {
		ar: 'إلغاء',
		en: 'Cancel',
	},
	'package-name.LOC_DATA_PACKAGE_SIZE': {
		ar: 'يشمل البيانات',
		en: 'Included data',
	},
	'package-name.INCLUDED_DATA': {
		ar: 'يشمل البيانات',
		en: 'Included data',
	},
	'package-name.LOC_MIN_PACKAGE_SIZE': {
		ar: 'يشمل الدقائق',
		en: 'Included minutes',
	},
	'package-name.INCLUDED_MINUTES': {
		ar: 'يشمل الدقائق',
		en: 'Included minutes',
	},
	'package-name.INCLUDED_SMS': {
		ar: 'يشمل الرسائل القصيرة',
		en: 'Included sms',
	},
	'package-name.LOC_SMS_PACKAGE_SIZE': {
		ar: 'يشمل الرسائل القصيرة',
		en: 'Included sms',
	},
	'package-name.WHATSAPP_PACKAGE_SIZE': {
		ar: 'يشمل واتساب',
		en: 'Whatsap included',
	},
	'package-name.DOUBLE_DATA_INCLUDED': {
		ar: 'بيانات مزدوجة',
		en: 'Double data',
	},
	'package-name.INCLUDED_ROAMING_DATA': {
		ar: 'التجوال',
		en: 'Roaming',
	},
	'package-name.INCLUDED_ROAM_REC_MIN': {
		ar: 'دقائق التجوال',
		en: 'Roaming minutes',
	},
	'package-name.INT_CALL_DISCOUNT_SIZE': {
		ar: 'خصم المكالمات',
		en: 'Call discount',
	},
	'package-name.PROMO_DATA': {
		ar: 'البيانات الترويجية',
		en: 'Promo data',
	},
	'package-name.PROMO_DATA_NAT_PLUS_GCC': {
		ar: 'البيانات الترويجية المحلية',
		en: 'Promo data local',
	},
	'package-name.PROMO_MINUTES': {
		ar: 'دقائق',
		en: 'Promo minutes',
	},
	'package-name.PROMO_APPSTORE_CREDIT': {
		ar: 'متجر التطبيق',
		en: 'Promo App Store',
	},
	'package-name.PROMO_GOBIZ_DATA': {
		ar: 'بيانات GoBiz الترويجية',
		en: 'Promo GoBiz Data',
	},
	'package-name.PROMO_ROAM_REC_MIN': {
		ar: 'دقائق التجوال الترويجية',
		en: 'Promo roaming minutes',
	},
	'package-name.INCLUDED_INT_MINUTES': {
		ar: 'الدقائق الدولية',
		en: 'Intl. minutes',
	},
	'package-name.DATA_INCLUDED': {
		ar: 'البيانات المتوفرة',
		en: 'Data included',
	},
	'package-name.PLAN_SPEED': {
		ar: 'سرعة',
		en: 'Speed',
	},
	'plan.contract.duration': {
		ar: '%% شهر مدة العقد ',
		en: '%% months contract',
	},
	'plan-bar.no.commitment': {
		ar: 'لا يوجد التزام',
		en: 'No commitment',
	},
	'plan.duration': {
		ar: '%% شهر',
		en: '%% Months',
	},
	'product.details.plan.recommended.plan': {
		ar: 'الباقة المختارة',
		en: 'Selected plan',
	},
	'product.details.plan.monthly-omr': {
		ar: '  ريال/شهر%%',
		en: 'OMR/mo. %%',
	},
	'plan.no.commitment.new.contract': {
		ar: 'خطتك الحالية ليس لها أي التزام ، وسوف يستمر عقدك الجديد لمدة ٪٪ من الأشهر',
		en: 'Your current plan has no commitment, your new contract would last for %% months',
	},
	'plan.minutes': {
		ar: 'دقائق.',
		en: 'min.',
	},
	'plan.internet': {
		ar: 'جي بي',
		en: 'GB',
	},
	'product.cart.plan.duration.upgrade': {
		ar: '٪٪ رفع مستوى العقد',
		en: '%% months contract upgrade',
	},
	'product.cart.plan.duration.renewal': {
		ar: '٪٪ شهر تم تجديد العقد',
		en: '%% months contract renewal',
	},
	'cart.item.details.one-time': {
		ar: 'دفع لمرة واحدة',
		en: 'One-time payment',
	},
	'cart.item.details.payment-now': {
		ar: 'الدفع الآن',
		en: 'Payment Now',
	},
	'cart.item.details.monthly': {
		ar: 'شهري',
		en: 'Monthly',
	},
	'price-tag.monthly': {
		ar: '/شه.',
		en: '/mo.',
	},
	'product-card.capacity': {
		ar: 'التخزين المتاح:',
		en: 'Available storage:',
	},
	'plan-selector.select.your.plan': {
		ar: 'اختر باقتك',
		en: 'Select your plan',
	},
	'plan-selector.subtitle.xs': {
		ar: 'تم تحديد باقتك. لا تتردد في تصفح باقاتنا الأخرى كذلك.',
		en: 'Recommended plan is already selected. Feel free to browse our other plans as well.',
	},
	'plan.button.subtitle.select.plan': {
		ar: 'حدد باقتك الجديدة أو احتفظ بباقتك الحالية.',
		en: 'Select your new plan or keep your current one.',
	},
	'plan-comparison.keep.my.plan': {
		ar: 'استمر في الباقة .',
		en: 'Keep my plan',
	},
	'plan-comparison.select.new.plan': {
		ar: 'اختر باقة جديدة',
		en: 'Select new plan',
	},
	'added-to-card.title': {
		ar: 'تمت الإضافة',
		en: 'Added to your cart',
	},
	'added-to-card.continue': {
		ar: 'مواصلة التسوق',
		en: 'Continue shopping',
	},
	'added-to-card.go-to-cart': {
		ar: 'اذهب إلى عربة التسوق',
		en: 'Go to cart',
	},
	'cart.item.plan.details': {
		ar: 'التفاصيل',
		en: 'Details',
	},
	'plan.details.title': {
		ar: 'الباقه المختارة',
		en: 'Your selected plan',
	},
	'product.configuration.country': {
		ar: 'البلد:',
		en: 'Country:',
	},
	'availability.gift': {
		ar: 'يتم شحن المنتجات الرقمية على الفور.',
		en: 'Digital products are shipped instantly.',
	},
	'price-section.info': {
		ar: 'شامل %%% ضريبة القيمة المضافة​',
		en: 'With %%% VAT:',
	},
	'message.box.vat': {
		ar: '٪٪٪ ضريبة القيمة المضافة مدفوعة مقدمًا من السعر',
		en: 'Full %%% VAT paid upfront from retail price',
	},
	'message.box.vat.first.month.bill': {
		ar: 'ضريبة القيمة المضافة الكاملة %%% للجهاز مشمولة في فاتورة الشهر الأول',
		en: 'Full %%% VAT for device included in first month bill',
	},
	'message.box.vat.percent': {
		ar: '%%%',
		en: '%%%',
	},
	'message.box.vat.percent.vat': {
		ar: 'ضريبة القيمة المضافة',
		en: 'VAT',
	},
	'message.box.vat.monthly': {
		ar: '[AR] Full %%% VAT from retail price',
		en: 'Full %%% VAT from retail price',
	},
	'payment.summary.monthly': {
		ar: 'شهري',
		en: 'Monthly',
	},
	'megamenu.my-omantel.good-morning': {
		ar: 'صباح الخير ',
		en: 'Good morning,',
	},
	'megamenu.my-omantel.check-email': {
		ar: 'تحقق من بريدك الإلكتروني',
		en: 'Check your email',
	},
	'megamenu.my-omantel.5g.ready': {
		ar: 'أجهزة تدعم شبكة 5G',
		en: '5G ready devices',
	},
	'megamenu.my-omantel.get.playstation': {
		ar: 'PlayStation',
		en: 'Get PlayStation',
	},
	'megamenu.my-omantel.outlets': {
		ar: 'المنافذ',
		en: 'Outlets',
	},
	'megamenu.my-omantel.around-me': {
		ar: 'حولي',
		en: 'Around me',
	},
	'megamenu.my-omantel.help': {
		ar: 'المساعدة',
		en: 'Help',
	},
	'megamenu.my-omantel.quick-services': {
		ar: 'خدمات سريعة',
		en: 'Quick services',
	},
	'megamenu.my-omantel.title': {
		ar: 'مرحباً بك في عمانتل',
		en: 'Welcome to Omantel',
	},
	'megamenu.my-omantel.create-account.title': {
		ar: 'أنشئ حسابك اليوم للبدء بإستخدام خدمات عمانتل الإلكترونية  ',
		en: 'Create an account to get started today',
	},
	'megamenu.my-omantel.create-account.button': {
		ar: 'إنشاء حساب',
		en: 'Create account',
	},
	'megamenu.my-omantel.form.title': {
		ar: 'لديك حساب؟ تسجيل الدخول الآن',
		en: 'Have an account? Sign in now.',
	},
	'megamenu.my-omantel.log-in.button': {
		ar: 'تسجيل الدخول',
		en: 'Sign in',
	},
	'megamenu.my-omantel.forgot-password.button': {
		ar: 'نسيت كلمة المرور الخاصة بك؟',
		en: 'Forgot Password?',
	},
	'megamenu.my-omantel.log-out.button': {
		ar: 'تسجيل الخروج',
		en: 'Log out',
	},
	'login.form.error.phone.required': {
		ar: 'يجب إدخال رقم الهاتف أو البريد الإلكتروني',
		en: 'Phone number or e-mail is required',
	},
	'login.form.password.error.required': {
		ar: 'كلمة المرور مطلوبة',
		en: 'Password is required',
	},
	'megamenu.my-omantel.balance': {
		ar: 'الرصيد الحالي',
		en: 'Current balance',
	},
	'megamenu.my-omantel.data': {
		ar: 'البيانات المتبقية',
		en: 'Data left',
	},
	'megamenu.my-omantel.makasib': {
		ar: 'نقاط مكاسب',
		en: 'Makasib points',
	},
	'megamenu.my-omantel.my-account.button': {
		ar: 'حسابي',
		en: 'My account',
	},
	'megamenu.my-omantel.store-orders.button': {
		ar: 'طلباتي',
		en: 'Store orders',
	},
	'cart.payment.summary.item.installment': {
		ar: 'الأقساط',
		en: 'installment',
	},
	'cart.payment.summary.item.subscription': {
		ar: 'الإشتراك',
		en: 'subscription',
	},
	'logged-user-bar.welcome': {
		ar: 'مرحباً',
		en: 'Welcome',
	},
	'logged-user-bar.dashboard': {
		ar: 'الصفحة الرئيسية',
		en: 'Dashboard',
	},
	'megamenu.my-omantel.bill': {
		ar: 'الفاتورة الحالية',
		en: 'Current bill',
	},
	'megamenu.my-omantel.data-unlimited': {
		ar: 'غير محدودة',
		en: 'Unlimited',
	},
	'megamenu.my-omantel.no-data': {
		ar: 'لا توجد بيانات',
		en: 'no data',
	},
	'navbar.my-omantel': {
		ar: 'حسابي',
		en: 'My Omantel',
	},
	'makasib.tier.alufuq': {
		ar: 'الأفق',
		en: 'Al Ufuq',
	},
	'makasib.tier.gold': {
		ar: 'الذهبية',
		en: 'Gold',
	},
	'makasib.tier.platinum': {
		ar: 'البلاتينية',
		en: 'Platinum',
	},
	'makasib.tier.silver': {
		ar: 'الفضية',
		en: 'Silver',
	},
	'availability.preorder.title': {
		ar: 'الطلب المسبق مفتوح الآن',
		en: 'Preorder is open now!',
	},
	'availability.preorder.subtitle': {
		ar: 'سيتم شحن هذا المنتج تاريخ %%',
		en: 'This product shipments will start on %%',
	},
	'availability.preorder.subtitle.second-version': {
		ar: 'يستغرق شحن هذا المنتج ما يصل إلى 20 من تاريخ الطلب',
		en: 'This product shipment will take up to 20 days from order date',
	},
	'cart.additional.info.preorder.title': {
		ar: 'هذا المنتج متوفر للطلب المسبق',
		en: 'This product is in preorder!',
	},
	'cart.additional.info.title': {
		ar: 'هذا المنتج متوفر للطلب المسبق',
		en: 'This product is in preorder!',
	},
	'cart.additional.info.delivery.info': {
		ar: 'سيتم شحن هذا المنتج تاريخ',
		en: 'This product shipments will start on',
	},
	'cart.additional.info.subtitle': {
		ar: 'قد يتغير تاريخ التسليم لأسباب خارجة عن سيطرة عمانتل. سيتم إعلامكم إذا حدث أي تغيير.',
		en:
			'The delivery date may change regardless of the Omantel company. We will provide you information if preorder dates will change.',
	},
	'cart.items.accordion.title': {
		ar: 'منتج تم طلبه مسبقاً',
		en: 'Preordered product',
	},
	'cart.items.subtitle.accordion': {
		ar: 'سيتم شحن هذا المنتج تاريخ %%',
		en: 'This product shipments will start on %%',
	},
	'cart.items.section.header': {
		ar: 'ملاحظة الطلب المسبق',
		en: 'Preorder notice',
	},
	'cart.items.section.content': {
		ar: 'قد يتغير تاريخ التسليم لأسباب خارج عن سيطرة عمانتل. سيتم إعلامكم إذا حدث أي تغيير.',
		en:
			'The delivery date may change regardless of the Omantel company. We will provide you information if preorder dates will change.',
	},
	'cart.voucher.section.title': {
		ar: 'استخدام قسيمة عمانتل الإلكترونية',
		en: 'Apply Omantel E-Voucher',
	},
	'cart.voucher.expires.on': {
		ar: '%% تاريخ الانتهاء',
		en: 'Expires on %%',
	},
	'cart.makasib.section.title': {
		ar: 'ادفع بنقاط مكاسب',
		en: 'Pay with Makasib points',
	},
	'cart.makasib.accordion.subtitle': {
		ar: 'سيخفض السعر الإجمالي بقيمة %% ر.ع باستخدام %% نقطة مكاسب.',
		en: 'The total price will be lowered by OMR %%  using %% Makasib points.',
	},
	'cart.voucher.accordion.subtitle': {
		ar: 'سيتم خصم %% ر.ع من المبلغ الإجمالي باستخدام القسيمة الإلكترونية %%.',
		en: 'The total price will be lowered by OMR %%  using %% e-voucher code.',
	},
	'cart.makasib.expiring.points': {
		ar: 'ستنتهي قريبا:',
		en: 'Expire soon:',
	},
	'cart.makasib.summary.title': {
		ar: 'الدفع بنقاط مكاسب',
		en: 'Payment with Makasib points',
	},
	'cart.e-voucher.summary.title': {
		ar: '%%  القسيمة الإلكترونية',
		en: 'E-Voucher %%',
	},
	'cart.e-voucher.payment.summary': {
		ar: ' الدفع باستخدام قسيمة إلكترونية',
		en: 'Payment by e-voucher',
	},
	'cart.e-voucher.payment.summary.single-voucher': {
		ar: 'ستسخدم  %% قسيمة إلكترونية بقيمة  %%ر.ع.',
		en: 'You will use in this transaction e-voucher %% for OMR %%.',
	},
	'cart.e-voucher.payment.summary.multiple-vouchers': {
		ar: 'ستسخدم  %% قسيمة إلكترونية بقيمة  %% ر.ع.',
		en: 'You will use in this transaction %% e-vouchers for OMR %%.',
	},
	'cart.makasib.validator.number.error': {
		ar: 'يرجى إدخال أرقام فقط',
		en: 'Please enter numbers only',
	},

	'cart.makasib.method.partial': {
		ar: 'ادفع جزئيًا باستخدام نقاطي',
		en: 'Pay partially using my points',
	},
	'cart.makasib.method.fully': {
		ar: 'ادفع %% بالكامل باستخدام %% من نقاطك',
		en: 'Pay full %% using your %% points',
	},
	'cart.makasib.no-points.label': {
		ar: 'ليست لديك أي نقاط مكاسب.',
		en: "You don't have any Makasib points.",
	},
	'cart.makasib.no-points.earn': {
		ar: 'تعرف على كيفية كسب النقاط',
		en: 'Check how to earn points',
	},
	'cart.makasib.apply.button': {
		ar: 'استخدام',
		en: 'Apply',
	},
	'cart.makasib.amount.placeholder': {
		ar: 'الكمية',
		en: 'Amount',
	},
	'cart.makasib.points-now.label': {
		ar: 'النقاط الآن',
		en: 'Points now',
	},
	'cart.makasib.method.fully-disabled': {
		ar: 'ادفع بالكامل باستخدام النقاط',
		en: 'Pay fully using points',
	},
	'cart.makasib.points-to-use.label': {
		ar: 'نقاط للاستخدام',
		en: 'Points to use',
	},
	'cart.makasib.voucher.placeholder': {
		ar: 'رمز القسيمة الإلكترونية',
		en: 'E-voucher code',
	},
	'cart.makasib.voucher.applied': {
		ar: 'استخدمت القسيمة الإلكترونية',
		en: 'E-voucher applied',
	},
	'cart.makasib.voucher.remove': {
		ar: 'حذف',
		en: 'Remove',
	},
	'cart.makasib.voucher.error': {
		ar: 'رمز القسيمة الإلكترونية غير صالح.',
		en: 'Not valid e-voucher code.',
	},
	'cart.makasib.voucher-info.exchange': {
		ar: 'يمكنك الحصول على قسيمة عمانتل عند استبدال جهازك',
		en: 'You can get an Omantel e-voucher when you trade in your old device',
	},
	'cart.makasib.voucher-info.limit-reached': {
		ar: 'تم الوصول إلى الحد الأقصى لاستخدام القسيمة.',
		en: 'Maximum Voucher Limit Reached.',
	},
	'cart.makasib.voucher-info.giftcards': {
		ar: 'لا يمكنك الدفع مقابل بطاقات الهدايا ومنتجات Microsoft باستخدام القسائم الإلكترونية.',
		en: 'You cannot pay for Gift cards and Microsoft products with e-vouchers.',
	},
	'cart.makasib.points.success': {
		ar: 'تم تخفيض السعر الإجمالي.',
		en: 'Your total price was lowered.',
	},
	'cart.makasib.errors.up-amount': {
		ar: 'الحد الأقصى للمبلغ المسموح به: %% ريال عماني ',
		en: 'Maximum allowed amount : OMR %%',
	},
	'cart.makasib.errors.lower.amount': {
		ar: 'نقاطك غير كافية. يرجى إدخال مبلغ أقل.',
		en: 'Insufficient balance. Please enter a lower amount.',
	},
	'cart.makasib.expiry.tooltip': {
		ar: '%% من نقاط مكاسب ستنتهي في غضون أسبوعين ',
		en: '%% of your Makasib points will expire within 2 weeks',
	},
	'cart.makasib.points-left.label': {
		ar: 'النقاط المتبقية',
		en: 'Points left',
	},
	'cart.makasib.log-in': {
		ar: 'لاستخدام نقاط مكاسب، يجب تسجيل الدخول.',
		en: 'To use Makasib points, you need to log in.',
	},
	'cart.makasib.gift-card.warning': {
		ar: ' لا يمكنك الدفع مقابل بطاقات الهدايا أو منتجات Microsoft باستخدام نقاط مكاسب.',
		en: 'You cannot pay for Gift cards or Microsoft products with Makasib points.',
	},
	'cart.voucher.gift-card.warning': {
		ar: 'لا يمكنك الدفع مقابل بطاقات الهدايا ومنتجات Microsoft باستخدام القسائم الإلكترونية.',
		en: 'You cannot pay for Gift cards and Microsoft products with e-vouchers.',
	},
	'cart.makasib.monthly.warning': {
		ar: 'لا يمكنك استخدام نقاط مكاسب للدفعات شهرية.',
		en: 'You cannot apply Makasib points for monthly payments.',
	},
	'cart.voucher.log-in': {
		ar: 'لاستخدام القسيمة الإلكترونية، عليك تسجيل الدخول.',
		en: 'To use eVoucher, you need to log in.',
	},
	'cart.voucher.warning1': {
		ar: 'قيمة قسيمتك الإلكترونية أعلى من سعر المنتجات التي يشملها الخصم. إذا قمت بإكمال عملية الدفع الآن ،',
		en:
			'The value of your e-voucher is higher than the price of products eligible for a discount. If you checkout now, ',
	},
	'cart.voucher.warning2': {
		ar: 'ستخسر %% ريال عماني ',
		en: 'you will lose OMR %%',
	},
	'cart.voucher.warning3': {
		ar: 'من قسيمتك الإلكترونية. ضع في اعتبارك إضافة المزيد إلى عربة التسوق قبل الدفع.',
		en: 'of your e-voucher. Consider adding something more to the cart before checkout.',
	},
	'cart.voucher.modal.return': {
		ar: 'العودة إلى عربة التسوق ',
		en: 'Return to cart',
	},
	'cart.voucher.modal.excess1': {
		ar: 'قيمة قسيمتك الإلكترونية أعلى من سعر المنتجات التي يشملها الخصم. إذا قمت بإكمال عملية الدفع الآن ، ',
		en:
			'The value of your e-voucher code is higher than the price of products eligible for a discount. If you checkout now, ',
	},
	'cart.voucher.modal.excess2': {
		ar: 'ستخسر %% ريال عماني ',
		en: 'you will lose %% OMR',
	},
	'cart.voucher.modal.excess3': {
		ar: 'من قسيمتك الإلكترونية. ربما ترغب في إضافة شيء ما إلى عربة التسوق أولاً؟ ',
		en: 'of your e-voucher. Maybe you would like to add something more to the cart first?',
	},
	'cart.voucher.modal.no-changes1': {
		ar: 'لم يضاف رمز قسيمتك الإلكترونية أو نقاط مكاسب.  ',
		en: 'Your e-voucher code or makasib points has not been added. ',
	},
	'cart.voucher.modal.no-changes2': {
		ar: 'ربما تريد محاولة تطبيق الخصم مرة أخرى؟ ',
		en: 'Maybe you want to try to apply the discount again?',
	},
	'cart.voucher.modal.checkout-question': {
		ar: 'هل أنت متأكد أنك تريد الدفع الآن؟ ',
		en: 'Are you sure you want to checkout now?',
	},
	'checkout-summary.success.payment.completed.preorder': {
		ar: 'تاريخ الشحن %%',
		en: 'Planned date of shipping %%',
	},
	'shipping-details.accordion.delivery-method.preorder': {
		ar: 'سيتم شحن هذا المنتج تاريخ %%',
		en: 'This product shipments will start on %%',
	},
	'cart.item.preorder.plan.info': {
		ar: 'سيتم تفعيل باقتك الجديدة عند شحن جهازك',
		en: 'Your new plan will be active once your device will be shipped.',
	},
	'error.mixed-shipping': {
		ar: 'هذا المنتج لديه طريقة شحن مخصصة ولا يمكن شحنه مع بقية طلبك. قم بإزالته من سلة التسوق و اطلبه بشكل منفصل.',
		en:
			'This product have a custom shipping method and can’t be shipped with rest of your order. Remove it from your cart and order it as a separate transaction.',
	},
	'list.product.card.badge': {
		ar: 'اطلب مسبقا',
		en: 'Preorder',
	},
	'price-section.info.only-vat': {
		ar: 'بالإضافة إلى %%% ضريبة القيمة المضافة',
		en: 'With %%%VAT from retail price:',
	},
	'payment-summary.installments-device': {
		ar: 'تقسيط %% شهر',
		en: '%% months installments',
	},
	'payment-summary.subscription-device': {
		ar: 'تقسيط %% الإشتراك',
		en: '%% months subscription',
	},
	'payment.summary.bill.vat.full.price': {
		ar: '%%% ضريبة القيمة المضافة (على السعر الكامل للجهاز)',
		en: '%%% VAT (on the device full price)',
	},
	'payment.summary.bill.vat': {
		ar: '%%% ضريبة القيمة القيمة المضافة (تضاف إلى إجمالي الفاتورة)',
		en: '%%% VAT (added to total bill value)',
	},
	'giftcard-price': {
		ar: 'السعر: %%',
		en: 'Price: %%',
	},
	'giftcard-country': {
		ar: 'الدولة: %%',
		en: 'Country: %%',
	},
	'upsell.title': {
		ar: 'قد يعجبك أيضاً',
		en: 'Other customers also bought this products',
	},
	'apple.upSell.title': {
		ar: 'كثيرًا ما يتم شراؤها معًا ',
		en: 'Frequently bought together',
	},
	'product.additional.info.panel.faq.title': {
		ar: 'الأسئلة الشائعة',
		en: 'Frequently Asked Questions',
	},
	'product.additional.section.title.order': {
		ar: 'الطلبات',
		en: 'Order',
	},
	'product.additional.section.title.payment': {
		ar: 'الدفع',
		en: 'Payment',
	},
	'product.additional.section.title.return.and.cancellation': {
		ar: 'الإرجاع والإلغاء',
		en: 'Return and cancellation',
	},
	'product.additional.section.title.delivery': {
		ar: 'توصيل',
		en: 'Delivery',
	},
	'product.additional.section.title.terms.and.conditions': {
		ar: 'الأحكام والشروط',
		en: 'Terms and Conditions',
	},
	'product.additional.subtitle.how.can.purchase': {
		ar: 'كيف يمكنني شراء جهاز من عمانتل؟',
		en: 'How can I purchase a device from Omantel?',
	},
	'product.additional.subtitle.how.can.purchase.content': {
		ar:
			'اذهب إلى متجر عمانتل ، حدد المنتج أو الجهاز الذي تريده ، قم بإضافته إلى سلة التسوق الخاصة بك ، ثم انقر فوق تسجيل المغادرة ، يمكنك إما تسجيل الدخول كمشتركي عمانتل أو كضيف ، ثم عليك ملء صفحة العنوان ، بعد القبول الشروط والأحكام الخاصة بك لإكمال مرحلة الدفع حتى تتمكن من تأكيد طلبك. ستتلقى رسالة بريد إلكتروني تحتوي على جميع المعلومات المتعلقة بطلبك',
		en:
			'Go to Omantel store, select the item or a device that you want, add it to your cart, then click on check out, you can either login as Omantel customer or as a guest, then you have to fill the address page, after accepting the terms and condition you have to complete the payment stage so you can confirm your order. You will receive an email with all the information about your order.',
	},
	'product.additional.subtitle.what.information': {
		ar: 'ما هي المعلومات التي يجب علي إدخالها عند الطلب؟',
		en: 'What information should I input when ordering?',
	},
	'product.additional.subtitle.what.information.content': {
		ar: 'اسمك ، بريدك الإلكتروني ، رقم هاتفك المحمول ، عنوانك ، تفاصيل بطاقتك المصرفية',
		en: 'Your name, email, mobile number, Your address, bank card details.',
	},
	'product.additional.subtitle.have.the.product': {
		ar: 'هل لديكم المنتجات في المخزون؟',
		en: 'Do you have the product in stock?',
	},
	'product.additional.subtitle.have.the.product.content': {
		ar:
			'معظم المنتجات المعروضة في موقعنا متوفرة. إذا كان المنتج غير متوفر ، فسيتم وضع علامة عليه وستكون قادرًا على اختيار أن يتم إعلامك بمجرد توفره.',
		en:
			'Most of products which are shown in our site are available. If the item is out of stock, it will be labeled and you will be able to choose to be notified once its available.',
	},
	'product.additional.subtitle.payment.methods': {
		ar: 'ما هي طرق الدفع التي يمكنني استخدامها؟',
		en: 'What payment methods can I use?',
	},
	'product.additional.subtitle.payment.methods.content': {
		ar: 'يمكنك الدفع فقط من خلال بطاقات الـ Visa أو Master أو American Express',
		en: 'You can only pay through a visa or master or american express card',
	},
	'product.additional.subtitle.pay.cash': {
		ar: 'هل يمكنني الدفع نقدًا عند الاستلام؟',
		en: 'Can I pay cash on delivery?',
	},
	'product.additional.subtitle.pay.cash.content': {
		ar: 'لا ، يمكنك الدفع فقط من خلال بطاقات الـ Visa أو Master أو American Express',
		en: 'No, You can only pay through a visa or master or american express card.',
	},
	'product.additional.subtitle.can.purchase.installment': {
		ar: 'هل يمكنني الشراء بالتقسيط؟',
		en: 'Can I purchase with installment?',
	},
	'product.additional.subtitle.can.purchase.installment.content': {
		ar: 'يمكن لعملاء باقتي فقط شراء أي جهاز بالتقسيط',
		en: 'Only Baqati customers can purchase any device with installment',
	},
	'product.additional.subtitle.vat.charged': {
		ar: 'هل يتم احتساب ضريبة القيمة المضافة؟',
		en: 'Is VAT charged?',
	},
	'product.additional.subtitle.vat.charged.content': {
		ar: 'نعم ، يتم إضافة ضريبة القيمة المضافة إلى السعر الإجمالي لطلبك.',
		en: 'Yes, VAT is added to the total price of your order.',
	},
	'product.additional.subtitle.what.is.return.policy': {
		ar: 'ما هي سياسة الإرجاع؟',
		en: 'What is the return policy?',
	},
	'product.additional.subtitle.what.is.return.policy.content': {
		ar:
			'تقدم شركة الاتصالات العمانية ش م ع ع (عمانتل) استرداد أو استبدال أو إلغاء طلبك للأجهزة والملحقات المشتراة مباشرة من عمانتل من خلال منفذ عمانتل وعبر الإنترنت من متجر عمانتل على الإنترنت',
		en:
			'Oman Telecommunication Company SAOG (Omantel) offers a refund, exchange, or cancel your order for devices and accessories purchased directly from Omantel through Omantel’s outlet and online from Omantel’s Online-Store ',
	},
	'product.additional.subtitle.what.is.order.cancellation': {
		ar: 'ما هي سياسة إلغاء الطلب؟',
		en: 'What is the order cancellation policy?',
	},
	'product.additional.subtitle.what.is.order.cancellation.content': {
		ar:
			'يمكنك إلغاء طلبك مع استرداد كامل المبلغ إذا استلمت عمانتل طلب الإلغاء هذا قبل إعادة توجيه المنتجات المطلوبة إلى شركة الشحن لتسليمها.		إذا كانت السلعة المطلوبة جاهزة للتسليم ، فستتحمل رسوم الشحن التي تتحملها عمانتل. سيتم استرداد الأموال باستخدام نفس طريقة الدفع المستخدمة لإجراء عملية الشراء الأصلية. قد يستغرق رد الأموال ما يصل إلى (30) يومًا.	إذا تم إرفاق عنصر مع التزام الخدمة ، فسيتم إلغاء الخدمة تلقائيًا أيضًا.',
		en:
			'You can cancel your order with full refund if such cancellation request received by Omantel before forwarding the ordered Items to the currier for delivery. \n\n If the ordered item is up for delivery, then you will incur the shipping charge incurred by Omantel. \n\n Refund will be made using the same method of payment used to make the original purchase. Refund may take up to (30) days.  \n\n If an Item is bundled with service commitment, then the service will be automatically cancelled as well.',
	},
	'product.additional.subtitle.what.delivery.charges': {
		ar: 'ما هي رسوم التوصيل؟',
		en: 'What are the delivery charges?',
	},
	'product.additional.subtitle.what.delivery.charges.content': {
		ar: '2 ريال عماني لطلبات مسقط و 3 ريال عماني للمناطق الأخرى',
		en: '2 OMR for Muscat orders and 3 OMR for other regions',
	},
	'product.additional.subtitle.how.long.receive.order': {
		ar: 'كم من الوقت يستغرق استلام طلبي؟',
		en: 'How long does it take to receive my order?',
	},
	'product.additional.subtitle.how.long.receive.order.content': {
		ar: 'سيتم استلام طلبك خلال 48 ساعة.',
		en: 'You order will be received within 48hrs.',
	},
	'product.additional.subtitle.can.track.order': {
		ar: 'هل يمكنني تتبع طلبي؟',
		en: 'Can I track my order?',
	},
	'product.additional.subtitle.can.track.order.content': {
		ar: 'يمكنك تتبع طلبك من خلال الرابط الموجود في البريد الإلكتروني.',
		en: 'You can track your order through the link provided in the email.',
	},
	'product.additional.subtitle.what.are.the.t.and.c': {
		ar: 'ما هي الشروط والأحكام؟',
		en: 'What are the terms and conditions?',
	},
	'product.additional.subtitle.what.are.the.t.and.c.content': {
		ar:
			'<ul><li> مكن الإستفادة من العرض بالإشتراك في باقتي آجلة الدفع لمدة 12/24 شهر.</li><li> في حال إنهاء المشترك الخدمة لدى عمانتل في أي وقت قبل انقضاء فترة العقد يتوجب عليه تسديد المبلغ المتبقي كالتالي: ]قيمة القسط الشهري عن جميع الأشهر المتبقية+ قيمة الخصم المقدم(إن وجد)+ المستحقات الغير مدفوعة[ – الضمان (إن وجد)</li><li> يمكن لمشتركي باقتي آجلة الدفع شراء جهاز واحد في حالة تفعيل الخدمة لمدة اقل من سنة.</li><li>يمكن لمشتركي باقتي آجلة الدفع شراء جهازين في حالة تفعيل الخدمة لمدة اكثر من سنة واقل من ثلاث سنوات.</li><li>يمكن لمشتركي باقتي آجلة الدفع شراء ثلاثة اجهزة في حالة تفعيل الخدمة لمدة اكثر من ثلاث سنوات.</li><li> لا يمكن للمشترك تغيير الباقة أو نقل ملكية الرقم خلال فترة العقد.</li><li> العرض مخصص للمشتركيين الافراد في باقتي آجلة الدفع فقط</li> <li>لمشتركين الذين تبقى على تسديد أقساطهم شهرواحد يستطيعوا ترقية هواتفهم الذكية الآن بأحدث الهواتف الذكية المتوفرة من عمانتل وسوفا يحصل المشترك مجاناً على خصم لآخر شهر من الاقساط المتبقية من عقد الالتزام الحالي.</li> <li>لمشتركين الذين تبقى على تسديد أقساطهم شهرين يستطيعوا ترقية هواتفهم الذكية الآن بأحدث الهواتف الذكية المتوفرة من عمانتل وسوفا يحصل المشترك مجاناً على خصم لآخر شهرين من الاقساط المتبقية من عقد الالتزام الحالي الخاص بك.</li> <li> يسري عرض الاجهزة في حالة توفر الاجهزة لدى عمانتل.</li> </ul>',
		en:
			'<ul><li>Customers opting in for the offer would need to subscribe to any post-paid plan for 12 or 24 month`s duration as per their choice. </li> <li>  Customers choosing to opt out before the end of contract period would be charged the following: [Monthly installments for the number of remaining months + the provided fixed discount (if applicable) + the unpaid usage of Baqati plan] – Deposit (if applicable) </li> <li> Any Active Post-paid subscriber for less than one year will be eligible for 1 device. \n\n Any Active Post-paid subscriber for more than one year and less than 3 years will be eligible for 2 devices. </li> <li> Any Active Post-paid subscriber for more than 3 years will be eligible for 3 devices. </li><li> Customers cannot change or transfer the ownership of the mobile subscription during the contract period. </li><li> It is applicable for Baqati residential customers only. </li><li> For customers who remain with one-month installment can upgrade their current smartphone now with the latest smartphones from Omantel and get a one-month discount of the remaining installments of the current commitment contract. </li><li> For customers who remain with two month installments can upgrade the current smartphone now with the latest smartphones from Omantel and get a TWO month`s discount of the remaining installments of the current commitment contract. </li><li> The smartphones offerings is subject to the avaliblity of devices. </li></ul>',
	},
	'product.additional.find.the.answer': {
		ar: 'لم تجد الجواب؟ اتصل بنا',
		en: 'Didn’t find the answer? Contact us!',
	},
	'product.additional.call.centre': {
		ar: 'مركز إتصال الشركات - %%',
		en: 'Business Call Centre Number - %%',
	},
	'product.additional.on.whatsapp': {
		ar: 'على WhatsApp - %%',
		en: 'On WhatsApp - %%',
	},
	'filter.5g': {
		ar: 'أجهزة تدعم شبكة 5G​',
		en: '5G Ready',
	},
	'filter.preorder': {
		ar: 'الطلب المسبق​',
		en: 'Preorder',
	},
	'filter.available': {
		ar: 'متوفر حاليا​',
		en: 'Available now',
	},
	'filter.promotions': {
		ar: 'العروض​',
		en: 'Promotions',
	},
	'product.additional.info.panel.return.policy.title': {
		ar: 'سياسة الإرجاع',
		en: 'Return policy',
	},
	'return.policy.title.return.policy': {
		ar: 'سياسة الإرجاع',
		en: 'Return policy',
	},
	'return.policy.title.return.policy.content': {
		ar:
			'تتيح الشركة العمانية للاتصالات ش.م.ع.ع (عمانتل) إمكانية استرداد أو استبدال أو إلغاء الطلبات الخاصة بالأجهزة والملحقات التي يتم شراؤها مباشرة من منافذ عمانتل أو من متجر عمانتل الإلكتروني ( ويشار إليها بـ"السلعة") كما هو موضح أدناه:',
		en:
			'Oman Telecommunication Company SAOG (Omantel) offers a refund, exchange, or cancel your order for devices and accessories purchased directly from Omantel through Omantel’s outlet and online from Omantel’s Online-Store herein after referred to as (the “ Item”) as provided below: -',
	},
	'return.policy.title.cancellation.before.shipping': {
		ar: 'إلغاء الطلب  قبل الشحن',
		en: 'Order Cancellation before Shipping ',
	},
	'return.policy.title.cancellation.before.shipping.content': {
		ar:
			'يمكن للمشتري إلغاء الطلب و إسترجاع المبلغ المدفوع كاملاُ في حال تلقت عمانتل طلب الإلغاء قبل إحالة المنتج للشحن، وسيتم إرجاع المبالغ بذات طريقة الدفع المستخدمة في الشراء. وقد يستغرق إرجاع المبلغ المدفوع مدة قد تصل إلى (30) يوما.	</br>وفي حال كون هذا المنتج مشتملاً على باقة خدمة، فإن هذه الخدمة سيتم إلغاؤها بشكل تلقائي تبعاً لطلب الإلغاء الخاص بالمنتج.',
		en:
			'You may opt to cancel your order with the entitlement for full refund if such cancellation request received by Omantel before forwarding the ordered Items to the currier for delivery. Refund will be made using the same method of payment used to make the original purchase. Refund may take up to (30) days. </br> If an Item is bundled with service commitment, then the service will be automatically cancelled as well.',
	},
	'return.policy.title.cancellation.before.delivery': {
		ar: 'إلغاء الطلب قبل التسليم',
		en: 'Order Cancellation before Delivery',
	},
	'return.policy.title.cancellation.before.delivery.content': {
		ar:
			'للمشتري القيام بإلغاء الطلب  بعد بدء الشحن وقبل التوصيل/التسليم الفعلي على أن يتحمل المشتري رسوم الشحن التي تكبدتها الشركة.  وتعتمد رسوم الشحن على المسافة والوزن إلا أنها لا تتجاوز عادة 15٪ من القيمة الإجمالية للطلب وسيتم إرجاع المبلغ المدفوع مخصوما منه قيمة الشحن وذلك بذات طريقة الدفع المستخدمة في عملية الشراء، وقد يستغرق إرجاع المبلغ المدفوع مدة قد تصل إلى (30) يوما.</br>	في حال كون هذا الطلب مشتملاً على باقة خدمة، فإن هذه الخدمة سيتم إلغاؤها بشكل تلقائي تبعاً لطلب الإلغاء الخاص بالمنتج.',
		en:
			'You may opt to cancel your order after the Item is shipped for delivery but before the actual delivery is made to you however you will incur the shipping charge incurred by Omantel. The amount of the shipping charges may vary depending on the distance and weight of the ordered items however the shipping charges will not usually exceed 15% of the gross value of the ordered Items. Refund minus the shipping charge will be made using the same method of payment used to make the original purchase. Refund may take up to (30) days. </br> If an Item is bundled with service commitment, then the service will be automatically cancelled as well.',
	},
	'return.policy.title.missing.order.item': {
		ar: 'الشحنة غير المكتملة',
		en: 'Missing ordered Item from the delivered package ',
	},
	'return.policy.title.missing.order.item.content': {
		ar:
			'عند وجود أضرار واضحة  في المغلف الذي يحوي الطلب، يتعين   وضع ملاحظة في إيصال الإستلام أو رفض استلام الشحنة. في حال اكتشافك بأن الشحنة التي تحوي المنتج غير مكتملة، فبإمكانك التقدم بشكوى من خلال متجرنا الالكتروني أو التواصل مع  مركز الاتصال  أو التفضل بزيارة أياً من منافذنا. وسيتم تسليم/شحن المنتج الذي لم يتم شحنه وفقا للطلب الأصلي  بشكل فوري. في حال كون المنتج مشتملاً على باقة خدمة، ولا يمكن التمتع بهذه الخدمة بدون المنتج الذي لم يتم شحنه، فإن مدة الإلتزام بالخدمة بالإضافة إلى أي أقساط مستحقة سيتم إحتسابها عند إتمام تسليم المنتج فقط .',
		en:
			'If the package is visibly damaged, you must placea note on the courier delivery receipt or reject the delivery. Shall you discover on receipt of the package that an ordered Item is missing, you are expected to log a complaint in our Online Store, contact our Contact Center, or visit any of our outlets. An immediate issue of the Item will be made to you if the value of the missing Item is of certain value.. </br> If an Item is bundled with service commitment and the service cannot be used without the missing Item, then the commitment period and any due installments shall commence only on delivering the such missing Item to you.',
	},
	'return.policy.title.damaged.items': {
		ar: 'المنتجات التالفة أو بها عيوب مصنعية',
		en: 'Damaged Items or Manufacturer Defect',
	},
	'return.policy.title.damaged.items.content': {
		ar:
			'عند وجود أضرار واضحة  في المغلف الذي يحوي السلعة، يتعين   وضع ملاحظة في إيصال الإستلام أو رفض استلام الشحنة، وفي حال إكتشافك بعد استلام الشحنة أن السلعة قد تعرضت للتلف بشكل ظاهر أو أنها معيبة أو ظهر بها عيب مصنعي خلال فترة 15 (خمسة عشر) يوما تحسب من تاريخ استلام السلعة، فإنه يحق لك إرجاع السلعة التالفة أو المعيبة او التي ظهر فيها عيب مصنعي لأيا من منافذ البيع الخاصة بعمانتل أو للمورد المعين من قبل عمانتل وذلك في العناوين الموضحة في شهادة الضمان.</br> 	وعلى الرغم من أننا سنبذل قصارى جهدنا لتفادي طول الإجراءات ، إلا أن هذه الإجراءات ستكون في حدود المعقول لإيقاع الفحص على السلعة  للتحقق فيما إذا كانت مشوبة بخلل مصنعي ومصدر الضرر الذي لحق بها. </br> 	وحال أنتهى الفحص بأن الاضرار /العيوب التي لحقت بالسلعة وقعت أثناء عملية الشحن وقبل تسليم السلعة أو بسبب عيب مصنعي فيحق لك طلب إصلاح السلعة أو إستبدالها بأخرى بذات المواصفات.</br> 	كما يحق لك إلغاء الطلب وإستراداد المبلغ المدفوع نظير السلعة، وسيتم إرجاع المبالغ بذات طريقة الدفع المستخدمة في الشراء وقد يستغرق إرجاع المبلغ المدفوع مدة قد تصل إلى (30) يوما. </br> <br> 	في حال كون طلب السلعة مشتملاً على باقة خدمة، ولا يمكن التمتع بهذه الخدمة بدون السلعة فإن مدة الإلتزام بالخدمة بالإضافة إلى أي أقساط مستحقة ستبدأ فقط عند تسليم السلعة التي تم إصلاحها/ إستبدالها ، وفي حال اخترت إسترداد قيمة المبلغ الدفوع مقابل السلعة فإنه سيتم إلغاء الخدمة بشكل تلقائي.',
		en:
			'You must immediately notice any damage on the packaging by placing a note on the courier delivery receipt or rejecting delivery. Shall you discover on receipt of the package that an ordered Item is visibly damaged or that an Item is faulty on receipt or becomes faulty for manufacturer defect within a period of 15 (Fifteen) days calculated from the date of receipt of the purchased Item, you are entitled to return the delivered damaged or faulty Item for manufacturer defect to any of Omantel’s outlets or to our appointed supplier at the addresses provided in the warranty certificate. </br> While we will endeavor to avoid prolonged process, it is understood, however, that inspection is necessary to determine whether the Item suffers a manufacturer defect and the source of damage inflicted on the Item. </br> If the inspection concludes that the Item is damaged during the shipping process and before the delivery is made or has a manufacturer defect, then you may opt to get the Item repaired or replaced with a new Item of the same standards.  </br> Also, you may opt for a    full refund of the amount paid for the item and such refund will be made using the same method of payment used to make the original purchase and may take up to (30) days.  </br> If an Item is bundled with service commitment and the service cannot be used without the damaged or faulty Item, then the commitment period and any due installments shall commence only on delivering the repaired / replaced item to you. However, if you opt for refund option, then the service will be automatically cancelled as well.',
	},
	'return.policy.title.wrong.delivered': {
		ar: 'تسليم سلعة غير مطابقة للطلب الاصلي',
		en: 'Wrong delivered Items ',
	},
	'return.policy.title.wrong.delivered.content': {
		ar:
			'في حال اكتشافك بان السلعة التي قمت باستلامها ليست مطابقة لطلب السلعة  ، فإنه يحق لك خلال فترة لا تتجاوز (3) أيام إبلاغ عمانتل بعدم مطابقة السلعة لطلبك، و إعادة السلعة غير المطابقة إلى عمانتل و في هذه الحالة يتوجب أن تكون السلعة في حالة مماثلة لحالة السلعة الجديدة وأن لا تكون مشوبة بأي ضرر كالخدوش أو ضرر بسبب الماء وبدون إحداث أي تغيير في الأجهزة أو البرامج الأصلية أو العبوة الأصلية للشركة المصنعة. في حال كون السلعة المطلوب متوفرة لدى عمانتل، فسيتم تسليمها لك تلقائيا. </br> </br>	وفي حال كون السلعة المطلوبة غير متوفرة لدى عمانتل، فسيتم إشعارك بذلك فوراً، ويكون لك الخيار في هذه الحالة بإلغاء الطلب واسترداد قيمة السلعة بذات طريقة الدفع المستخدمة في الشراء وقد يستغرق إرجاع المبلغ المدفوع مدة قد تصل إلى (30) يوما. </br>	</br>	في حال كون هذا الطلب مشتملاً على باقة خدمة، ولا يمكن التمتع بهذه الخدمة بدون السلعة غير المطابقة للطلب الاصلي، فإن مدة الإلتزام بالخدمة بالإضافة إلى أي أقساط مستحقة سيتم إحتسابها فقط عند إتمام تسليم السلعة الصحيحة، وفي حال اخترت إسترجاع قيمة السلعة فإنه سيتم إلغاء الخدمة بشكل تلقائي. </br> </br> </br>	في حالة كان السلعة المسترجعة بموجب هذا البند مشوبة بضرر أو تم تغيير حالتها الأصلية أو إحداث تغيير عليها أو البرامج الملحقة بها، فإنه لا يمكن إرجاعها في هذه الحالة أو استرداد قيمته، وستقوم عمانتل بإعادة السلعة مرة أخرى وعلى نفس العنوان الموضح في ملصق الشحن.، وفي حال كانت السلعة مشمولة بباقة خدمة، فإن الإلتزام بالخدمة في هذه الحالة يكون صحيحا و نافذاً.',
		en:
			'Shall you discover on receipt of the package that a delivered item is not the Item that you ordered, you may within a period not exceeding ( 3 ) days notify Omantel that wrong Items were delivered to you. These wrong Items shall be sent back to Omantel and must be in like-new condition with no physical or water damage with no alteration to original hardware or software and in the manufacturer`s original packaging. Shall the Items placed in the original order are available in Omantel, they will be issued immediately.  </br> If an Item is not available in Omantel, we will let you know immediately and you may opt to cancel the order and refund will be made using the same method of payment used to make the original purchase. Refund may take up to (30) days. </br> If an Item is bundled with service commitment and the service cannot be used due to delivery of the wrong item, then the commitment period and any due installments shall commence only on delivering the such correct Item to you. However, if you opt for refund option, then the service will be automatically cancelled as well. </br>	If an Item has physical or liquid damage or alteration to original hardware or software, it cannot be returned and a credit will not be issued. Omantel will return ineligible devices to you at the same address shown on the shipping label. In this event and if the Item is bundled with service commitment, then the service commitment shall be valid and enforceable.',
	},
	'return.policy.title.repair.during.warranty': {
		ar: 'الإصلاح خلال فترة الضمان',
		en: 'Repair during warranty period ',
	},
	'return.policy.title.repair.during.warranty.content': {
		ar:
			'تخضع السلع المشتراة لإلتزامات الضمان، ويجوز لك الاتصال بعمانتل  أو مزودها على العناوين الواردة في شهادة الضمان لإصلاح السلعة، إذا كانت السلعة قابلة للإصلاح. قم بعمل نسخة من الفاتورة أو الإيصال واحتفظ بالنسخ الأصلية لك. قم كذلك بإزالة المعلومات السرية أو الخاصة أو الشخصية من السلعة وتسليمها إلى إحدى منافذ عمانتل أو لأي من الموردين. وتقع على عاتقك مسؤولية التأكد من حصولك على إيصال بتسليم السلعة  في منفذ عمانتل أو للمورد.',
		en:
			'Subject to the warranty obligations, you may contact Omantel or its supplier at the addresses provided in the warranty certificate to repair the product, if product is capable to be repaired. Make a copy of the invoice or receipt and keep original for your records. Remove confidential, proprietary, or personal information from device and drop off the Items to an of Omantel’s outlets or at any of the suppliers’ location. It is your responsibility to make sure that you obtain a receipt of the Items dropped off in Omantel’s outlet or with its supplier. ',
	},
	'return.policy.title.legal.disclaimer': {
		ar: 'إخلاء المسؤولية القانونية',
		en: 'Legal disclaimer',
	},
	'return.policy.title.legal.disclaimer.content': {
		ar:
			'تحتفظ عمانتل بالحق في رفض السلعة جرى تم إعادتها  بالمخالفة لسياسة إعادة السلع الخاصة بعمانتل. ويرجى إزالة أية معلومات سرية أو خاصة أو شخصية قبل إرجاع السلعة. وننوه بأن الشركة غير مسؤولة عن المعلومات المخزنة في السلعة المسترجعة.',
		en:
			'Omantel reserves the right to reject item returns that do not comply with the Return Policy. Please remove any confidential, proprietary, or personal information before returning your equipment. Omantel is not responsible for information left on returned Item',
	},
	'terms.and.conditions.subtitle': {
		ar: 'يرجى قراءة الشروط والأحكام والموافقة عليها لإتمام المعاملة',
		en: 'You need to accept T&Cs in order to continue your purchase.',
	},
	'megamenu.home.title': {
		ar: 'كل احتياجات منزلك الذكي',
		en: 'All your home digital needs',
	},
	'megamenu.mobile.services-and-addons': {
		ar: 'الخدمات والمزايا الإضافية',
		en: 'Services and addons',
	},
	'megamenu.mobile.efloos': {
		ar: 'eFloos',
		en: 'eFloos',
	},
	'megamenu.category.more': {
		ar: 'المزيد',
		en: 'More',
	},
	'megamenu.mobile.overview': {
		ar: 'نظرة عامة',
		en: 'Overview',
	},
	'megamenu.mobile.5g': {
		ar: 'الجيل الخامس المتنقل من عمانتل',
		en: 'Omantel 5G mobility',
	},
	'megamenu.mobile.prepaid': {
		ar: 'مسبقة الدفع',
		en: 'PREPAID',
	},
	'megamenu.mobile.postpaid': {
		ar: 'آجلة الدفع',
		en: 'postpaid',
	},
	'megamenu.mobile.roaming': {
		ar: 'التجوال',
		en: 'roaming',
	},
	'megamenu.mobile.hayyak': {
		ar: 'حياك',
		en: 'Hayyak',
	},
	'megamenu.mobile.new-baqati': {
		ar: 'باقتي الجديدة',
		en: 'New Baqati',
	},
	'megamenu.mobile.baqati': {
		ar: 'باقتي الأفق',
		en: 'Baqati Al Ufuq',
	},
	'megamenu.mobile.roaming-abroad': {
		ar: 'التجوال في الخارج',
		en: 'Roaming Abroad',
	},
	'megamenu.home.home-internet': {
		ar: 'الانترنت المنزلي',
		en: 'Home Internet',
	},
	'megamenu.home.ultra-fast': {
		ar: 'انترنت هائل السرعة',
		en: 'Ultra fast',
	},
	'megamenu.home.basic': {
		ar: 'الأساسية',
		en: 'Basic',
	},
	'megamenu.home.wireless-4g-5g': {
		ar: 'والخامس اللاسلكي',
		en: 'Wireless (4G/5G)',
	},
	'megamenu.home.afaaq': {
		ar: 'آفاق',
		en: 'Afaaq',
	},
	'megamenu.home.smart.homes': {
		ar: 'المنزل الذكي',
		en: 'Smart Homes',
	},
	'megamenu.home.microsoft-products': {
		ar: 'منتجات مايكروسوفت',
		en: 'Microsoft Products',
	},
	'megamenu.home.home-family': {
		ar: 'خدمة العائلة الإضافية',
		en: 'Home Family Plan',
	},
	'megamenu.home.fixed-service': {
		ar: 'الخدمات الثابتة',
		en: 'Fixed Services',
	},
	'megamenu.home.family-plan': {
		ar: 'خدمة العائلة الإضافية',
		en: 'Family Plan',
	},
	'megamenu.home.fixed-line': {
		ar: 'الهاتف الثابت',
		en: 'Fixed line',
	},
	'megamenu.home.sahl': {
		ar: 'سهل',
		en: 'Sahl',
	},
	'megamenu.home.entertainment': {
		ar: 'الترفيهية',
		en: 'ENTERTAINMENT',
	},
	'megamenu.home.omantel-tv': {
		ar: 'عمانتل TV+',
		en: 'Omantel TV+',
	},
	'megamenu.home.gaming': {
		ar: 'الألعاب',
		en: 'Gaming',
	},
	'megamenu.home.apple-tv': {
		ar: 'Apple TV',
		en: 'Apple TV',
	},
	'megamenu.home.additional-service': {
		ar: 'خدمات إضافية',
		en: 'Additional services',
	},
	'megamenu.home.track-hbb': {
		ar: 'تتبع حالة طلبك للأنترنت المنزلي',
		en: 'Track HBB request',
	},
	'login.form.password.error.matches': {
		ar: 'يجب أن تتضمن كلمة المرور أحرفا',
		en: 'Password must include letters',
	},
	'deliver-address.disabled-position': {
		ar: 'تأكد من تفعيل خدمات الموقع الجيوغرافي من خلال إعدادات الموقع الالكتروني.',
		en: 'Location is disabled. Please check your browser settings.',
	},
	'product.configuration.value': {
		ar: 'القيمة',
		en: 'Value',
	},
	'account.management.order.canceled': {
		ar: 'تم إلغاء الطلب',
		en: 'Order canceled',
	},
	'checkout-summary.timeout.reached': {
		ar: 'انتهت مدة صلاحية الجلسة',
		en: 'Checkout timeout',
	},
	'checkout-summary.timeout.reached.title': {
		ar: 'عذرًا ! استغرقت وقتَا طويلا لإنهاء عملية الشراء. تم إلغاء حجزك للمنتجات المختارة.',
		en: 'Sorry! It took too long to finalize your checkout. We`ve cancelled your items reservation.',
	},
	'checkout-summary.timeout.reached.description': {
		ar: 'الرجاء العودة إلى المتجر و إضافة المنتجات الى عربة التسوق مرة أخرى و إتمام عملية الشراء.',
		en: 'Please go back to store, add your products to cart and proceed to checkout again.',
	},
	'checkout-summary.go.back.to.store': {
		ar: 'العودة إلى المتجر',
		en: 'Go back to store',
	},
	'product.details.plan.expires.on': {
		ar: 'الإلتزام الحالي ينتهي',
		en: 'Current commitment expires',
	},
	'plan-bar.recommended.plan': {
		ar: 'الباقة المرشحة',
		en: 'Recommended plan',
	},
	'product.cart.no.commitment': {
		ar: 'من غير التزام',
		en: 'No commitment',
	},
	'product.cart.plan.no.commitment': {
		ar: 'من غير التزام',
		en: 'No commitment',
	},
	'product.cart-card.modal.multiple.tariffs.title': {
		ar: 'تم إضافة تعرفة الباقة إلى عربة التسوق مسبقاً',
		en: 'Plan tariff already in cart',
	},
	'product.cart-card.modal.multiple.installments.title': {
		ar: 'سلة التسوق ممتلئة',
		en: 'Your cart is full ! ',
	},
	'product.cart-card.modal.mixed.installments.title': {
		ar: 'أرقام مختلفة في السلة',
		en: 'Different numbers in cart',
	},
	'product.cart-card.modal.multiple.tariffs.description': {
		ar: 'يوجد لديك تعرفة باقة في عربة التسوق حاليا. يرجى إنهاء المعاملة الحالية قبل شراء باقة أخرى.',
		en:
			'You already have a plan tariff in your cart. Please finalize your current order before purchasing another plan tariff.',
	},
	'product.cart-card.modal.multiple.installments.description': {
		ar: 'لا يمكنك شراء  %%و %%ي نفس الوقت. لشراء منتج آخر بالتقسيط ، يرجى إكمال عملية الشراء الحالية.',
		en:
			'You cannot purchase %% and %% at the same time. To purchase another product on installments, please complete your current purchase.',
	},
	'product.cart-card.modal.mixed.installments.description': {
		ar: 'لا يمكنك طلب منتجين بالأقساط باستخدام أرقام مختلفة في عملية شراء واحدة. يرجى طلب كل منتج بمفرده.',
		en:
			'You cannot order two products on installments using different numbers in one purchase. Please order each product separately.',
	},
	'banner.get-now': {
		ar: 'احصل الآن​',
		en: 'Get now',
	},
	'generic.user.session.error': {
		ar: 'انتهت مدة صلاحية الجلسة',
		en: 'Your session expired',
	},
	'generic.user.session.error.description': {
		ar: 'انتهت مدة صلاحية الجلسة، يرجى تسجيل الدخول مرة أخرى',
		en: 'In order to continue, please log in to your account once again.',
	},
	'plan.selector.no.commitment': {
		ar: 'من غير التزام',
		en: 'No commitment',
	},
	'plan.selector.commitment': {
		ar: 'مدة الإلتزام: %% شهر',
		en: '%% months commitment',
	},
	'gift.card.code': {
		ar: 'رمز بطاقة الإهداء: ',
		en: 'Gift Card code: ',
	},
	'gift.card.serial': {
		ar: 'رقم سري: %%',
		en: 'Serial Number: %%',
	},
	'gift.card.expiry.date': {
		ar: 'تاريخ الانتهاء: %%',
		en: 'Expiry date: %%',
	},
	'gift.card.code.mail': {
		ar: 'تم إرسال رمز بطاقة الإهداء إلى بريدك الإلكتروني: ',
		en: 'Your Gift Card codes were also sent to your email:',
	},
	'copy.to.clipboard': {
		ar: 'نسخ',
		en: 'Copy to clipboard',
	},
	'copy.to.clipboard.success': {
		ar: 'تم النسخ بنجاح',
		en: 'Copied succesfully',
	},
	'plans.selected.number.POSTPAID.MOBILE': {
		ar: 'باقاتي',
		en: 'Baqati',
	},
	'plans.selected.number.POSTPAID.FIX': {
		ar: 'الانترنت المنزلي',
		en: 'Fix',
	},
	'plans.selected.number.POSTPAID.INTERNET': {
		ar: 'انترنت هائل السرعة',
		en: 'HBB',
	},
	'plans.selected.number.POSTPAID.WFBB': {
		ar: 'الانترنت اللاسلكي',
		en: 'WFBB',
	},
	'plans.selected.number.PREPAID.MOBILE': {
		ar: 'حياك',
		en: 'Hayyak',
	},
	'plans.selected.number.PREPAID.FIX': {
		ar: '[AR] Fix',
		en: 'Fix',
	},
	'plans.selected.number.PREPAID.INTERNET': {
		ar: '[AR] HBB',
		en: 'HBB',
	},
	'plans.selected.number.PREPAID.WFBB': {
		ar: '[AR] WFBB',
		en: 'WFBB',
	},
	'product.details.plan.edit.warning.8920100': {
		ar:
			'بطاقتك الشخصية منتهية أو ستنتهي قريباً. لشراء جهاز بعقد التزام، يجب أن تكون بطاقتك الشخصية صالحة لمدة لا تقل عن 3 أشهر من اليوم.',
		en:
			'Your ID is expired or soon to be expired. To purchase a device commitment your ID needs to be valid for 3 months from today at least.',
	},
	'product.details.plan.edit.warning.8920101': {
		ar: 'يرجى تجديد بطاقتك الشخصية قبل إجراء أي تغييرات على الباقة.',
		en: 'Please update the ID expiry date before making any changes to your plan.',
	},
	'product.details.plan.edit.warning.8920102': {
		ar: 'عذرًا، يوجد لديك عقد إلتزام جاري حاليًا.',
		en: 'Sorry, you already have an active device commitment.',
	},
	'product.details.plan.edit.warning.8920103': {
		ar: 'عذرًا، يجب أن تكون من مشتركي عمانتل لمدة لا تقل عن 90 يوم لشراء جهاز بعقد إلتزام.',
		en: "Sorry, you need to be Omantel's customer for at least 90 days to purchase a device commitment.",
	},
	'product.details.plan.edit.warning.8920104': {
		ar: 'عذرًا، لا يمكنك شراء جهاز بعقد إلتزام من متجر عمانتل. للمزيد من المعلومات، يرجى التواصل على %%.',
		en:
			"Sorry, you can't get a device commitment in Omantel eShop. For further instructions please call our Call Center.",
	},
	'product.details.plan.edit.warning.8920105': {
		ar: 'عذرًا، لا يمكنك شراء جهاز بعقد إلتزام في الوقت الحالي. للمزيد من المعلومات، يرجى التواصل على 1234.',
		en:
			"Sorry, you can't get a device commitment at this moment. For further instructions please call our Call Center.",
	},
	'product.details.plan.edit.not.eligible': {
		ar: 'عذراً، لست مؤهل حاليًا للحصول على التقسيط. يرجى التواصل معنا عبر المساعد الرقمي "نور" لتلقي الدعم.',
		en:
			'Sorry, you are not eligible for an installment plan at the moment. Please contact us through our digital assistant ‘Noor’ for support.',
	},
	'product.details.plan.edit.no.credit.limit': {
		ar:
			'عذراً، لا يمكن شراء هذا الجهاز بالتقسيط حيث يتطلب دفع المبلغ كله مقدمًا. ويمكنك أيضاً اختيار جهاز آخر أقل سعرًا للتقسيط.',
		en:
			'Sorry, you cannot purchase this device through installments. You can buy it with a full upfront payment or choose a lower-priced device for installments.',
	},
	'gift.card.see.code': {
		ar: 'انظر الكود',
		en: 'See code',
	},
	'gift.card.modal.details': {
		ar: 'التفاصيل',
		en: 'Details',
	},
	'plan-comparison.data.included': {
		ar: 'البيانات المتضمنة',
		en: 'Data included',
	},
	'plan-comparison.download.speed': {
		ar: 'سرعة التنزيل',
		en: 'Download speed',
	},
	'plan-comparison.upload.speed': {
		ar: 'سرعة التحميل',
		en: 'Upload speed',
	},
	'plan-comparison.free.minutes.to.fixed': {
		ar: 'دقائق مجانية لأرقام عمانتل الثابتة',
		en: 'Free minutes to Omantel fixed line',
	},
	'plan-comparison.intl.calls.discount': {
		ar: 'تخفيض المكالمات الدولية',
		en: 'International calls discount',
	},
	'plan-comparison.price.with.vat': {
		ar: 'مع %%% الضريبة: %% ريال عماني',
		en: 'With %%% VAT: %% OMR',
	},
	'account.management.settings.address.book': {
		ar: 'عنوان الإقامة',
		en: 'Address book',
	},
	'account.management.settings.address.book.empty': {
		ar: 'لم يتم حفظ عنوانك بعد',
		en: 'You have no addresses saved yet.',
	},
	'account.management.settings.address.book.add': {
		ar: 'إضافة عنوان جديد',
		en: 'Add new address',
	},
	'product.details.plan.edit.wrong.plan.selected': {
		ar:
			'عذرًا، لا يمكننا التحقق من تفاصيل باقتك أو العروض المتاحة في الوقت الحالي. يرجى المحاولة مرة أخرى لاحقًا أو التواصل معنا عبر المساعد الرقمي "نور" لتلقي الدعم.',
		en:
			'Sorry, we are unable to check your plan or offer details at the moment. Please try again later or contact us through our digital assistant ‘Noor’ for support.',
	},
	'product.details.plan.edit.warning.select.other.plan': {
		ar: 'اختر باقة اخرى، اشترِ',
		en: 'Select other plan, buy ',
	},
	'payment.summary.price': {
		ar: 'السعر',
		en: 'Price',
	},
	'payment.summary.subscription': {
		ar: 'اشتراك',
		en: 'Subscription',
	},
	'contact-details.digital.on.email.address': {
		ar: 'سيتم توصيل منتجك الرقمي إلى عنوانك المسجل',
		en: 'Your digital products will be delivered to address entered.',
	},
	'shipping-method.title.without.plan': {
		ar: 'خيارات الشحن',
		en: 'Shipping options',
	},
	'shipping-details.accordion.contact-data.title.without.billing': {
		ar: 'تفاصيل التواصل',
		en: 'Contact details',
	},
	'shipping-method.select.from.address.book': {
		ar: 'اختر من العناوين المسجلة',
		en: 'Select from address book',
	},
	'view.filters.button.counter': {
		ar: 'تصفية',
		en: 'Filters (%%)',
	},
	'view.filters.button.filter': {
		ar: 'تصفية',
		en: 'Filters',
	},
	'payment.summary.prices.may.change': {
		ar: 'قد يتغير السعر على حسب اختيار الباقة',
		en: 'Prices may change when purchasing with different plans.',
	},
	'plans.is.hbb.installemnts.offer': {
		ar: 'باقتك تتناسب مع نظام الأقساط الشهري، لن يحدث أي تغيير على عقدك',
		en: ' Your plan is eligible for monthly installments. No changes will be made to your plan contract.',
	},
	'payment.summary.will.expire': {
		ar: 'ستنتهي في',
		en: 'Will expire on',
	},
	'payment.summary.title.device.commitment': {
		ar: 'عقد المنتج',
		en: 'Product commitment expiration',
	},
	'product.details.plan.edit.warning.already.contract': {
		ar:
			'لديك جهاز مرتبط بعقد مع هذا الحساب، لذلك لا يمكنك شراء هذا الجهاز بنظام التقسيط. يرجى التواصل معنا عبر المساعد الرقمي "نور" لتلقي الدعم.',
		en:
			'You already have a device under contract with this account, so you are not eligible to purchase this device through installments. Please contact us through our digital assistant ‘Noor’ for support.',
	},
	'product.details.plan.edit.warning.two-device-accessories-installment': {
		ar: 'يمكنك شراء إكسسوار واحد بالتقسيط في كل مرة. لشراء اكسسوار آخر بالتقسيط يرجى إكمال عملية الشراء الحالية.',
		en:
			'You can only purchase one accessory on installments at a time. To purchase another accessory on installments, please complete your current purchase.',
	},
	'product.details.plan.edit.warning.two-mobile-device-installment': {
		ar:
			'يمكنك شراء جهاز محمول واحد فقط بالتقسيط في كل عملية شراء. لشراء جهاز محمول آخر بالتقسيط ، يرجى إكمال عملية الشراء الحالية.',
		en:
			'You can only purchase one device on installments at a time. To purchase another device on installments, please complete your current purchase.',
	},
	'product.details.plan.edit.warning.legacy.plan': {
		ar: 'نعتذر! يبدو أنك على إحدى الباقات القديمة. لا يمكنك استخدامها لإجراء عملية شراء في متجر عمانتل الإلكتروني.',
		en: 'Sorry! It looks like you’re on one of legacy plans. You can’t use it to make a purchase in Omantel eShop.',
	},
	'product.details.plan.edit.warning.no.cprp.response': {
		ar: 'عذرًا، نواجه مشكلة في تحميل ملفك الشخصي. يرجى تحديث الصفحة والانتظار قليلًا ثم المحاولة مرة أخرى.',
		en:
			'Sorry, we’re having trouble loading your profile. Please try refreshing the page, wait a moment and try again.',
	},
	'product.details.plan.edit.warning.no.current.plan': {
		ar: 'عذرًا، لا يمكننا عرض باقتك الحالية. يرجى تحديث الصفحة والانتظار قليلًا ثم المحاولة مرة أخرى.',
		en:
			'Sorry, we’re unable to view your current plan at the moment. Please refresh the page, wait for a while and try again later.',
	},
	'product.details.plan.edit.warning.no.response.catalog.plan': {
		ar:
			'عذرًا، نواجه حاليًا بعض المشكلات التقنية ونعمل على حلها في أقرب وقت. يرجى تحديث الصفحة والانتظار قليلًا ثم المحاولة مرة أخرى.',
		en:
			'Sorry, we’re experiencing some technical issues at the moment. We’re working to resolve them shortly. Please try refreshing the page and wait a while.',
	},
	'product.details.plan.warning.no.active.plan.in.response.catalog': {
		ar:
			'عذرًا، لا يمكننا التحقق مما إذا كنت مؤهلا للحصول على تقسيط في الوقت الحالي. يرجى تحديث الصفحة والانتظار قليلًا ثم المحاولة مرة أخرى.',
		en:
			'Sorry, we are unable to check your eligibility for installments at the moment. Please refresh the page, wait for some time, and try again later.',
	},
	'notify-me.error.title': {
		ar: 'Oh no!',
		en: 'Oh no!',
	},
	'notify-me.error.subtitle': {
		ar: 'حدث خطأ ما في متجرنا الإلكتروني. يرجى المحاولة مرة أخرى إذا استمرت المشكلة ، اتصل على  %% لتلقي المساعدة.',
		en:
			'Something went wrong with our eShop. Please try again If the problem persists, call %% to receive futhure assistance.',
	},
	'notify-me.error-subscribed.title': {
		ar: 'لقد قمت بالتسجيل سابقاً',
		en: "You've already signed up",
	},
	'notify-me.error-subscribed.subtitle': {
		ar: 'لقد اشتركت سابقًا في إشعار هذا المنتج. سنخبرك بمجرد توفره في المخزون.',
		en: "You've subscribed previously for this product notification. We'll let you know once its back in stock.",
	},
	'checkout-summary.ms-product': {
		ar: ':سيتم إرسال رمز البرنامج على البريد الالكتروني',
		en: 'Your software code will be sent to your e-mail:',
	},
	'checkout-summary.success.payment.completed': {
		ar: 'تم إتمام عملية الدفع بنجاح',
		en: 'Your payment is completed successfully.',
	},
	'checkout-summary.microsoft.software-code': {
		ar: 'البرنامج مفتاح:',
		en: 'Software code:',
	},
	'product.configuration.subscription': {
		ar: 'الإشتراك',
		en: 'subscription',
	},
	'cart-item.subscription': {
		ar: 'الإشتراك: %%',
		en: 'Subscription: %%',
	},
	'microsoft.modal.subscription': {
		ar: '%% الإشتراك',
		en: '%% subscription',
	},
	'microsoft.modal.email-info': {
		ar: 'لكترونيالإ بريدك الى بك الخاص البرنامج مفتاح إرسال تم لقد:',
		en: 'Your software codes were also sent to your email:',
	},
	'microsoft.visit-page.info.first': {
		ar: 'بالأعلى إستلمته الذي المفتاح وإدخال مايكروسوفت موقع زيارة الرجاء',
		en: "Visit Microsoft page and enter code you've received above",
	},
	'microsoft.visit-page.info.second': {
		ar: 'الخدمة تفعيل أجل من',
		en: 'to activate your service',
	},
	'microsoft.modal.error': {
		ar:
			'أخرى مرة المحاولة الرجاء .اللحظة هذه في بك الخاص البرنامج مفتاح جلب أثناء الصعوبات بعض واجهتنا لقد  %%بالرقم الإتصال او الإلكتروني البريد في بك الخاص البرنامج مفتاح عن البحث الرجاء المشكلة ةاستمر اذا دقائق. عدة بعدالمساعدة من للمزيد',
		en:
			'We had troubles getting your software codes at this very moment. Please try again in a few minutes. If the problem persists - please look for your software codes in email you’ve received or call %% for further assistance.',
	},
	'microsoft.please-wait': {
		ar: 'بك الخاص البرنامج مفتاح جلب على نعمل ... الإنتظار الرجا.',
		en: 'Please wait a minute... We are generating your software codes.',
	},
	'microsoft.error.1': {
		ar: 'اللحظة ههذ في بك الخاص البرنامج مفتاح جلب أثناء المشكلات بعض واجهتنا قدل.',
		en: 'We had troubles getting all of your software codes at this very moment.',
	},
	'microsoft.error.2': {
		ar: 'قصير وقت في الإلكتروني بريدك لىع جميعا بإستلامها تقوم سوف ... للقلق لاداعي:',
		en: "Please don't worry - you'll receive them to your email shortly:",
	},
	'microsoft.error.3': {
		ar: '%% على الإتصال ارجاء المساعدة من للمزيد الحاجة حالة في.',
		en: 'In case of any further assistance needed - please call %%.',
	},
	'microsoft.visit-page.button': {
		ar: 'مايكروسوفت صفحة زيارة الرجاء',
		en: 'Visit Microsoft page',
	},
	'checkout-summary.ms-product.in.24.h': {
		ar: 'خلال ٢٤ ساعة.',
		en: 'in 24 hours',
	},
	'shipping-details.accordion.delivery-method.pickup': {
		ar:
			'سيتم تسليم طلبك من مبنى عمانتل الرئيسي بعد التدشين، ابتدءًا من %%. إذا لم تتمكن من استلام الطلب في غضون يوم واحد ، سوف يتم الإتصال بك من شركة التوصيل لشحن طلبك إلى موقعك. ',
		en:
			"Order will wait for your pickup in Omantel HQ after the launch event, starting on %%. If you'll not be able to pickup the order within 1 day, delivery company will contact you to ship your order at preferred location. ",
	},
	'shipping-details.accordion.delivery-method.title.pickup': {
		ar: 'استلم',
		en: 'Pickup',
	},
	'shipping-details.accordion.delivery-method.title.outlet-pickup': {
		ar: 'الاستلام من الصالة',
		en: 'Outlet pickup',
	},
	'shipping-details.subtitle.delivery-method.title.outlet-pickup': {
		ar: 'الاستلام من الصالة',
		en: 'Outlet pickup,',
	},
	'shipping-details.accordion.delivery-method.title.outlet-pickup-appointment': {
		ar: 'موعد الاستلام من الصالة',
		en: 'Outlet pickup appointment',
	},
	'shipping-details.accordion.shipping-data.subtitle-pickup': {
		ar: 'الإستلام من مبنى عمانتل الرئيسي',
		en: 'Pickup from Omantel point',
	},
	'shipping-method.deliver.address.title': {
		ar: 'ادخل عنوان التوصيل',
		en: 'Enter delivery address',
	},
	'shipping-method.deliver.address.label-subtitle': {
		ar: 'يرجى تزويدنا بتفاصيل التسليم.',
		en: 'Please provide us the delivery details.',
	},
	'shipping-method.deliver.address.subtitle': {
		ar: 'المنتجات ستصل إلى بابك.',
		en: 'Let us deliver your products to your door.',
	},
	'shipping-method.deliver.pickup.title': {
		ar: 'استلم طلبك من مركز الإستلام',
		en: 'Collect order from pickup point',
	},
	'shipping-method.deliver.pickup.subtitle': {
		ar: 'استلم طلبك من نقطة عمانتل',
		en: 'Collect your products from Omantel point.',
	},
	'shipping-method.deliver.outlet.title': {
		ar: 'الاستلام من الصالة',
		en: 'Outlet pickup',
	},
	'shipping-method.deliver.outlet.subtitle': {
		ar: 'استلم طلبك من صالة عمانتل',
		en: 'Collect your products from Omantel outlet.',
	},
	'shipping-method.deliver.outlet-pickup.subtitle': {
		ar: 'استلم طلبك من منفذ عمانتل.',
		en: "Collect your order from Omantel's outlet.",
	},
	'shipping-method.pickup-info-1': {
		ar:
			'سيتم تسليم طلبك من مبنى عمانتل الرئيسي بعد التدشين، ابتدءًا من 8 أكتوبر 2021. إذا لم تتمكن من استلام الطلب في غضون يوم واحد ، سوف يتم الإتصال بك من شركة التوصيل لشحن طلبك إلى موقعك.',
		en: 'Order will wait for you pickup in ',
	},
	'shipping-method.pickup-info-2': {
		ar: '',
		en: 'after the launch event, starting on ',
	},
	'shipping-method.pickup-info-3': {
		ar: '',
		en:
			"If you'll not be able to pickup the order within 1 day, delivery company will contact you to ship your order at preferred location.",
	},
	'shipping-method.outlet.label-1': {
		ar: 'الاستلام من الصالة',
		en: 'Outlet pickup',
	},
	'shipping-method.outlet.label-2': {
		ar: 'يرجى تحديد إحدى الصالات التالية',
		en: 'Please choose one of the following outlets',
	},
	'book-appointment.outlet.label-1': {
		ar: 'موعد الاستلام من الصالة',
		en: 'Outlet pickup appointment',
	},
	'book-appointment.outlet.label-2': {
		ar: 'يمكنك حجز موعد الاستلام لتجنب الانتظار',
		en: 'You can book an appointment to pick-up your order, and you will not have to wait in a queue.',
	},
	'book-appointment.outlet.book-button': {
		ar: 'حجز',
		en: 'Book',
	},
	'book-appointment.outlet.warning': {
		ar: 'يرجى تحديد المنفذ الذي تريد استلام طلبك فيه أولاً.',
		en: 'Please select the outlet where you want to pick up your order first.',
	},
	'payment-success.pickup': {
		ar: 'سيتم تسليم طلبك من مبنى عمانتل الرئيسي بعد التدشين ، ابتدءًا من',
		en: 'Order will wait for your pickup in Omantel HQ after the launch event, starting on',
	},
	'payment-success.pickup-2': {
		ar: 'إذا لم تتمكن من استلام الطلب في غضون يوم واحد ، سوف يتم التواصل معك من شركة التوصيل لشحن الطلب إلى موقعك.',
		en:
			'If you’ll not be able to pick up the order within 1 day, delivery company will contact you to ship your order at preferred location.',
	},
	'payment-success.pickup-3': {
		ar: 'يرجى إظهار رقم الطلب المدرج أعلاه وإحضار هويتك عند استلام طلبك.',
		en: 'Please show order number listed above and have your ID handy when collecting your order.',
	},
	'account.management.pickup-address': {
		ar: 'عنوان الإستلام',
		en: 'Pickup address',
	},
	'pickup-order.title': {
		ar: 'استلم طلبك',
		en: 'Pick up your order',
	},
	'pickup-order.subtitle': {
		ar: 'استلم طلبك من مبنى عمانتل الرئيسي',
		en: 'Collect your order from Omantel HQ.',
	},
	'shipping-method.pickup.info': {
		ar:
			'استلام الطلب متاح فقط ل iPhone 13. إذا كنت ترغب استلام طلبك ، فيرجى إزالة جميع البضاعات الأخرى من سلة التسوق الخاصة بك.',
		en:
			'Order pickup is only available for iPhone 13 smartphones. If you want to collect your order, please remove all other items from your cart.',
	},
	'account.management.order-in-progress': {
		ar: 'قيد التوصيل',
		en: 'Delivery in progress',
	},
	'pickup-from-outlet.selected-appointment': {
		ar: 'الموعد المحدد:',
		en: 'Selected appointment:',
	},
	'pickup-from-outlet.edit-appointment-date': {
		ar: 'تعديل تاريخ الموعد',
		en: 'Edit appointment date',
	},
	'pickup-from-outlet.delete-appointment-date': {
		ar: 'حذف الموعد',
		en: 'Delete appointment',
	},
	'pickup-from-outlet.unavailable-appointments': {
		ar: 'عذرا، لا توجد مواعيد متاحة في',
		en: 'We’re sorry, but there are no available appointments for',
	},
	'pickup-from-outlet.th-of': {
		ar: ' من',
		en: 'th of',
	},
	'pickup-from-outlet.different-day': {
		ar: 'اختر يوم آخر',
		en: 'Try a different day.',
	},
	'pickup-from-outlet.find-first-available-day': {
		ar: 'احصل على أقرب موعد متاح',
		en: 'Find the first available appointment',
	},
	'pickup-from-outlet.booking-modal.cancel': {
		ar: 'إلغاء',
		en: 'Cancel',
	},
	'pickup-from-outlet.booking-modal.available-label': {
		ar: 'الأوقات',
		en: 'Available',
	},
	'pickup-from-outlet.booking-modal.slots-label': {
		ar: 'المتاحة:',
		en: 'slots:',
	},
	'pickup-from-outlet.booking-modal.back-to-today.button': {
		ar: 'الرجوع لتاريخ اليوم',
		en: 'Back to today',
	},
	'pickup-from-outlet.booking-modal.title': {
		ar: 'حدد التاريخ و الوقت',
		en: 'Pick date and time',
	},

	'counter.days': {
		ar: 'أيام',
		en: 'days',
	},
	'counter.hours': {
		ar: 'ساعات',
		en: 'hours',
	},
	'counter.minutes': {
		ar: 'دقائق',
		en: 'minutes',
	},
	'counter.seconds': {
		ar: 'ثواني',
		en: 'seconds',
	},
	'comparison.length-error': {
		ar: 'لا يمكنك مقارنة أكثر من 3 منتجات.',
		en: 'You can’t compare more than 3 products at a time.',
	},
	'comparison.limitation': {
		ar: 'يمكنك مقارنة 3 منتجات من نفس الفئة.',
		en: 'You can compare up to 3 products from the same category.',
	},
	'comparison.title': {
		ar: 'الأجهزة الذكية',
		en: 'Smartphones',
	},
	'comparison.button.select-products': {
		ar: 'اختر المنتجات',
		en: 'Select Products',
	},
	'account.management.order.complete': {
		ar: 'اكتمل الطلب',
		en: 'Order complete',
	},
	'get-esim.title': {
		ar: 'احصل على شريحة إلكترونية (eSIM) لجهازك الجديد الآن',
		en: 'Get eSIM for your new device now.',
	},
	'get-esim.subtitle': {
		ar: 'عند استلام جهازك، سيصلك بريد إلكتروني يوضح كيفية تفعيل الشريحة الإلكترونية (eSIM) خطوة بخطوة.',
		en: 'Upon receiving your new device, we will email you instructions on how to install your eSIM.',
	},
	'get-esim.subtitle.transfer': {
		ar: 'عند استلام جهازك، سيصلك بريد إلكتروني يوضح كيفية تفعيل الشريحة الإلكترونية (eSIM) خطوة بخطوة.',
		en: 'Upon receiving your new device, we will email you instructions on how to install your eSIM.',
	},
	'get-esim.button.select': {
		ar: ' اختر الرقم',
		en: 'Select number',
	},
	'select-number-modal.title': {
		ar: 'رقم الشريحة الإلكترونية',
		en: 'eSIM number',
	},
	'select-number-modal.subtitle': {
		ar: ' اختر الرقم الذي ترغب بتحويله إلى جهازك الجديد',
		en: 'Select a number you’d like to transfer to your new device.',
	},
	'order-item.new-esim': {
		ar: ' شريحة إلكترونية جديدة',
		en: 'New eSIM',
	},
	'order-item.transfer-esim': {
		ar: ' تحويل الشريحة الإلكترونية',
		en: 'eSIM transfer',
	},
	'cancel-order.description.order.history': {
		ar:
			"[AR]You can cancel your order until we dispatch it. After cancelation, you will get a refund from the bank within 30 days. Please remember that you can't cancel orders that include Gift cards or Microsoft products.",
		en:
			"You can cancel your order until we dispatch it. After cancelation, you will get a refund from the bank within 30 days. Please remember that you can't cancel orders that include Gift cards or Microsoft products.",
	},
	'cancel-order.description.unavailable-cancel.order.history': {
		ar:
			"[AR]Sorry, you can't cancel orders that include digital products, gift cards or microsoft products. Please contact our customer service on %% to see if we can help you.",
		en:
			"Sorry, you can't cancel orders that include digital products, gift cards or microsoft products. Please contact our customer service on %% to see if we can help you.",
	},
	'cancel-order.button.cancel': {
		ar: '[AR]Cancel order',
		en: 'Cancel order',
	},
	'cancel-order.order-canceled.info.title': {
		ar: '[AR]Order canceled',
		en: 'Order canceled',
	},
	'cancel-order.order-canceled.info.description': {
		ar:
			'[AR]You have canceled this order on %%. You will get a refund from the bank within 30 days from the cancelation date.',
		en:
			'You have canceled this order on %%. You will get a refund from the bank within 30 days from the cancelation date.',
	},
	'cancel-order.modal.first-step.title': {
		ar: '[AR]Are you Sure you want to cancel your order?',
		en: 'Are you Sure you want to cancel your order?',
	},
	'cancel-order.modal.first-step.button-back': {
		ar: '[AR]No, take me back',
		en: 'No, take me back',
	},
	'cancel-order.modal.first-step.button-cancel': {
		ar: '[AR]Yes, cancel my order',
		en: 'Yes, cancel my order',
	},
	'cancel-order.modal.first-step.subtitle': {
		ar:
			'[AR]You are about to cancel your order. If you do that, you will get a refund from the bank withing 30 days.',
		en: 'You are about to cancel your order. If you do that, you will get a refund from the bank withing 30 days.',
	},
	'cancel-order.modal.success.title': {
		ar: '[AR]You have succesfully canceled your order',
		en: 'You have succesfully canceled your order',
	},
	'cancel-order.modal.success.subtitle': {
		ar: '[AR]You have canceled your order. You will get a refund from the bank within 30 days.',
		en: 'You have canceled your order. You will get a refund from the bank within 30 days.',
	},
	'cancel-order.modal.generic-error.title': {
		ar: 'عذراً، حدث خطأ ما.',
		en: 'Sorry, an unexpected error has occurred.',
	},
	'cancel-order.modal.generic-error.subtitle': {
		ar:
			'نعتذر، حدث خطأ ما ولم نتمكن من إلغاء طلبك. يرجى المحاولة مرة أخرى بعد دقائق أو اتصل بخدمة المشتركين عبر %%.',
		en:
			"Something went wrong, and we couldn't cancel your order. Please try again in a few minutes or contact Customer Service on %%.",
	},
	'cancel-order.modal.error.title': {
		ar: "[AR]You can't cancel the order.",
		en: "You can't cancel the order.",
	},
	'cancel-order.modal.error.subtitle': {
		ar: '[AR]Your order is already being processed.',
		en: 'Your order is already being processed.',
	},
	'cancel-order.modal.loading.title': {
		ar: '[AR]We are cancelling your order...',
		en: 'We are cancelling your order...',
	},
	'cancel-order.modal.loading.subtitle': {
		ar: '[AR]Please wait a minute while we are working to cancel your order.',
		en: 'Please wait a minute while we are working to cancel your order.',
	},
	'get-esim.subtitle.transfer.order.history': {
		ar: ' تحويل الشريحة الإلكترونية',
		en: 'eSIM transfer',
	},
	'get-esim.subtitle.order.history': {
		ar: ' شريحة إلكترونية جديدة',
		en: 'New eSIM',
	},
	'get-esim.button.change.number': {
		ar: ' تغيير الرقم',
		en: 'Change number',
	},
	'get-esim.button.remove.number': {
		ar: ' حذف الشريحة الإلكترونية',
		en: 'Remove eSIM',
	},
	'cart.item.insurance.title': {
		ar: ' %% نحن نقدم لك حماية الجهاز كإضافة تبدأ من 2 ريال عماني لمدة شهر.',
		en: 'We are offering you device protection as an add-on starting from 2 OMR for a Month. %%',
	},
	'cart.item.insurance.title-instalments': {
		ar: 'الان متوفر باقساط مريحه.',
		en: 'Now available in easy installment.',
	},
	'get.insurance.select-plan': {
		ar: ' اختر الباقة',
		en: 'Select plan',
	},
	'get.insurance.open.modal': {
		ar: ' تغيير إلى %% شهر',
		en: 'Change to %% months',
	},
	'get.insurance.remove.button': {
		ar: ' حذف التأمين',
		en: 'Remove protection',
	},
	'additional.product.modal.title': {
		ar: ' خدمة حماية الجهاز',
		en: 'Device protection plan',
	},
	'select-protection-modal.select': {
		ar: ' تطبيق الخدمة',
		en: 'Add to my order',
	},
	'additional.product.select.your.protection': {
		ar: ' اختر مدة التأمين',
		en: 'Select your protection period:',
	},
	'additional.product.how.would.you.like.to.pay': {
		ar: 'طريقتك المفضلة للدفع؟',
		en: 'How would you like to pay?',
	},
	'additional.product.payment.upfront': {
		ar: 'المقدّم',
		en: 'Upfront',
	},
	'additional.product.payment.installments': {
		ar: 'الأقساط',
		en: 'Installments',
	},
	'additional.product.insurance': {
		ar: ' %% شهر',
		en: '%% months',
	},
	'insurance.description.title': {
		ar: 'احمي جهازك من الفقدان او التلف:',
		en: 'Protect your device from damage and loss:',
	},
	'insurance.description.1': {
		ar: ' الأضرار الناتجة عن الرمال*.',
		en: 'Damages caused by sand*.',
	},
	'insurance.description.2': {
		ar: ' الأضرار الناتجة عن التسرب أو السقوط في السوائل*.',
		en: 'Damages caused by the spill or accidental fall in liquids*.',
	},
	'insurance.description.3': {
		ar: ' الأضرار الناتجة عن الرطوبة*.',
		en: 'Damages caused by humidity*.',
	},
	'insurance.description.4': {
		ar: ' الأضرار الناتجة عن السقوط أو الصدمات*.',
		en: 'Damages caused by dropping or impacts*.',
	},
	'insurance.description.5': {
		ar: ' الأضرار الناتجة عن الخدوش*.',
		en: 'Damages caused by Abrasion*.',
	},
	'insurance.description.6': {
		ar:
			' الأضرار الناتجة عن تعمد أطراف ثالثة غير مرخص لها من قبل المالك واستخدام القوة أو الترهيب ضد المؤمن عليه (يجب تقديم تقرير الشرطة في حالة المطالبة).',
		en:
			'Damages caused intentionally by third parties not authorized by the owner and using force or intimidation against the insured (a police report must be provided in the event of a claim).',
	},
	'insurance.description.7': {
		ar: ' السرقة*.',
		en: 'Robbery & Burglary*',
	},
	'select-protection-modal.instruction.subtitle': {
		ar: '* كما هو محدد تماما في صياغة السياسة.',
		en: '* As fully defined in the Policy wording.',
	},
	'select-protection-modal.payment.subtitle': {
		ar: ' يتم دفع السعر الإجمالي لباقة تأمين الجهاز مقدما في المتجر و سيتم إضافته إلى سلة التسوق الخاصة بك.',
		en: 'Total price for the device protection plan is paid upfront in eShop and will be added to your cart.',
	},
	'select-protection-modal.payment.mo': {
		ar: 'شهري/',
		en: '/mo.',
	},
	'select-protection-modal.payment.vat': {
		ar: 'يشمل %%% ضريبة القيمة المضافة​',
		en: '(%%% VAT included)',
	},
	'select-protection-modal.payment.upfront': {
		ar: 'المقدّم',
		en: 'Upfront',
	},
	'get.insurance.device.will.be.protected': {
		ar: ' سيتم تأمين جهازك ل %% شهر.',
		en: 'Your device will be protected for %% months.',
	},
	'get.insurance.warning.title': {
		ar: ' لا يمكنك شراء أجهزة متعددة عند شراء التأمين',
		en: 'Can’t purchase multiple devices when buying insurance',
	},
	'get.insurance.warning.subtitle': {
		ar: ' لديك حالياً جهاز مع التأمين في عربة التسوق الخاصة بك. يرجى إنهاء هذه المعاملة قبل شراء جهاز آخر.',
		en:
			'You currently have a device with insurance added to your cart. Please finalize this transaction at first and then continue with your next device purchase.',
	},
	'order.item.insurance.subtitle': {
		ar: ' %% شهر',
		en: '(%% months)',
	},
	'order.item.hayyak.subtitle': {
		ar: '[AR]Hayyak SIM',
		en: 'Hayyak SIM',
	},
	'general-error.title': {
		ar: ' الخدمة غير متوفرة',
		en: 'Service not available',
	},
	'general-error.subtitle': {
		ar: 'يعمل الفنيون لحل هذه المشكلة في أسرع وقت ممكن. يرجى المحاولة مرة أخرى قريبا.',
		en: 'Our technicians are working hard to solve this issue as soon as possible. Please try again soon.',
	},
	'order.history.purchased.insurandce': {
		ar: ' قمت بشراء %% شهر تأمين.',
		en: 'You have purchased %% months insurance.',
	},
	'upgrade.plan.button.upgrade.now': {
		ar: 'ترقية الباقة',
		en: 'Upgrade now',
	},
	'upgrade.plan.button.get.details': {
		ar: 'اعرض التفاصيل',
		en: 'Get details',
	},
	'upgrade.plan.your.plan.will.be.upgraded': {
		ar: '%%سيتم ترقية باقتك الحالية إلى الباقة',
		en: 'Your plan will be upgraded to %% plan.',
	},
	'plan.plan.commitment.expiration': {
		ar: 'انتهاء عقد الالتزام للباقة',
		en: 'Plan commitment expiration',
	},
	'upgrade.plan.icon.unlimited.unit': {
		ar: 'GB',
		en: 'GB',
	},
	'comparison-bar.less-then-two': {
		ar: ' .حدد منتجين على الأقل للمقارنة',
		en: 'Add at least 2 products to compare them.',
	},
	'product-page.compare-1': {
		ar: 'قارن هذا المنتج ',
		en: 'Compare this product',
	},
	'product-page.compare-2': {
		ar: 'بمنتجات مشابهة',
		en: 'with similar items.',
	},
	'comparison.remove': {
		ar: 'حذف',
		en: 'Remove',
	},
	'tracking.title.ORDER_RECEIVED': {
		ar: 'تم تلقي الطلب ',
		en: 'Order received',
	},
	'tracking.description.ORDER_RECEIVED': {
		ar: 'لقد تلقينا طلبك.',
		en: 'We have received your order.',
	},
	'tracking.title.REQUEST_FROM_SUPPLIER': {
		ar: 'تم الطلب من المورد',
		en: 'Requested from supplier',
	},
	'tracking.description.REQUEST_FROM_SUPPLIER': {
		ar: 'لقد قمنا بطلب طلبك من المورد',
		en: 'We have requested your order from supplier.',
	},
	'tracking.title.PREPARED': {
		ar: 'تجهيز الطلب',
		en: 'Preparing',
	},
	'tracking.doneTitle.PREPARED': {
		ar: 'تم تجهيز الطلب',
		en: 'Prepared',
	},
	'tracking.description.PREPARED': {
		ar: 'نقوم الآن بتجهيز طلبك.',
		en: 'We are preparing your order.',
	},
	'tracking.doneDescription.PREPARED': {
		ar: 'لقد قمنا بتجهيز طلبك.',
		en: 'We have prepared your order.',
	},
	'tracking.title.SHIPPED': {
		ar: 'شحن الطلب',
		en: 'Shipping',
	},
	'tracking.doneTitle.SHIPPED': {
		ar: 'تم شحن الطلب',
		en: 'Shipped',
	},
	'tracking.description.SHIPPED': {
		ar: 'الطلب في الطريق',
		en: 'Your order is on the way.',
	},
	'tracking.title.DELIVERED': {
		ar: 'توصيل',
		en: 'Delivery',
	},
	'tracking.doneTitle.DELIVERED': {
		ar: 'تم تسليم الطلب',
		en: 'Delivered',
	},
	'tracking.doneDescription.DELIVERED': {
		ar: 'طلبك الآن بين يديك!',
		en: 'Hooray, your order is in your hands!',
	},
	'tracking.inProgress': {
		ar: 'الطلب قيد التقدم',
		en: 'In progress',
	},
	'account.management.payment.shipment.products': {
		ar: 'منتجات',
		en: 'Products',
	},
	'account.management.payment.shipment.pack': {
		ar: 'حزمة %%',
		en: 'Pack %%',
	},
	'account.management.payment.digital-delivery': {
		ar: 'التسليم رقمي',
		en: 'Digital delivery',
	},
	'cart.items.plan.details-see': {
		ar: 'تفاصيل الباقة',
		en: 'See plan details',
	},
	'checkout-info.title-3': {
		ar: 'المستندات المقبولة',
		en: 'Accepted documents',
	},
	'checkout-info.title-3.description': {
		ar:
			'يتم قبول نسخ البطاقة الشخصية وبطاقة الإقامة لشراء باقات الإنترنت المنزلي. لا يمكن قبول جواز السفر والوثائق الأخرى غير المذكورة سابقًا في هذه الحالة',
		en:
			'Only National ID and Resident card entitle to buy HBB plan. Passport and other documents than previously mentioned could not be accepted in this case',
	},
	'checkout-info.title-3.description.1': {
		ar:
			' يتم قبول البطاقة الشخصية وبطاقة الإقامة فقط لشراء باقاتي وباقات الإنترنت ، ولا يمكن النظر في المستندات الأخرى.',
		en:
			'Only National ID and Resident Card are accepted for buying Baqati and internet plans, other documents cannot be considered.',
	},
	'checkout-info.title-3.description.2': {
		ar:
			'لشراء شريحة هاتف نقال ((SIM جديدة أو باقة إنترنت من المتجر الإلكتروني، يتطلب منك إبراز البطاقة الشخصية أو بطاقة الإقامة. ولا تقبل جوازات السفر إلا عند شراء الشريحة من منافذ عمانتل أو المتاجر الفعلية الأخرى.',
		en:
			'To purchase a new SIM card or internet plan from the eShop, you need to present a National ID or Residence Card. Passports can only be accepted for buying SIM in Omantel’s outlets or other physical stores.',
	},
	'waiting.tracking.details.title': {
		ar: 'Waiting for order tracking details',
		en: 'Waiting for order tracking details',
	},
	'waiting.tracking.details.description-1': {
		ar: 'Your order was set successfully.',
		en: 'Your order was set successfully.',
	},
	'waiting.tracking.details.description-2': {
		ar:
			'We are waiting for tracking details from our delivery partners. Refresh this page in a moment to get details about your products and delivery details.',
		en:
			'We are waiting for tracking details from our delivery partners. Refresh this page in a moment to get details about your products and delivery details.',
	},
	'document.details.radio.button.101': {
		ar: 'البطاقة الشخصية ',
		en: 'National ID',
	},
	'document.details.radio.button.104': {
		ar: 'بطاقة المقيم',
		en: 'Resident card',
	},
	'sim-document.details.radio.button.101': {
		ar: 'البطاقة الشخصية ',
		en: 'National ID',
	},
	'sim-document.details.radio.button.104': {
		ar: 'بطاقة الإقامة',
		en: 'Resident card',
	},
	'document-details.title': {
		ar: 'تفاصيل المستند',
		en: 'Document details',
	},
	'sim-document-details.title': {
		ar: 'تفاصيل المستند',
		en: 'Document details',
	},
	'document-details.provide.details': {
		ar: 'يرجى تزويدنا بتفاصيل المستند الخاص بك.',
		en: 'Please provide us with your document details.',
	},
	'sim-document-details.provide.details': {
		ar: 'يرجى تزويدنا بتفاصيل المستند الخاص بك',
		en: 'Please provide us your document details',
	},
	'document-details.1.point': {
		ar: '1. نسخة من الوثيقة التي ترغب في تقديمها؟',
		en: '1. Photo of which document would you like to provide',
	},
	'sim-document-details.1.point': {
		ar: '1. اختر الوثيقة الخاصة بك',
		en: '1. Please select your identification document.',
	},
	'document-details.2.point': {
		ar: '3. يرجى إدخال تاريخ انتهاء البطاقة',
		en: '3. Please enter the expiry date of your ID',
	},
	'document-details.3.point': {
		ar: '4. أضف صورًا أو نسخًا ممسوحة ضوئيًا للصفحة الأمامية والخلفية للمستند الذي اخترته',
		en: '4. Add photos or scans of front and back page of your chosen document',
	},
	'document-details.description.1.point': {
		ar:
			'يتم قبول نسخ البطاقة الشخصية وبطاقة الإقامة لشراء باقات الإنترنت المنزلي. لا يمكن قبول جواز السفر والوثائق الأخرى غير المذكورة سابقًا في هذه الحالة',
		en:
			'Only National ID and Resident card entitle to buy HBB plan. Passport and other documents than previously mentioned could not be accepted in this case.',
	},
	'sim-document-details.description.1.point': {
		ar:
			'لشراء بطاقة SIM جديدة أو باقة إنترنت من المتجر الإلكتروني، يلزمك إبراز البطاقة الشخصية أو بطاقة الإقامة. يمكن قبول جوازات السفر فقط لشراء بطاقة SIM في منافذ عمانتل أو المتاجر الفعلية الأخرى.',
		en:
			'To purchase a new SIM or Internet plan in the eShop you need to present a National ID or Resident Card. Passports can only be accepted for buying SIM in Omantel outlets or other physical stores.',
	},
	'contact-details.input.civil.number': {
		ar: 'تاريخ الإنتهاء',
		en: 'Expiry date',
	},
	'document-details.description.2.point': {
		ar: ' يمكنك العثور على تاريخ انتهاء الصلاحية على الجهة الأمامية من البطاقة الشخصية أو بطاقة الإقامة.',
		en: 'You can find the expiry date on the front page of the National ID or Resident card.',
	},
	'sim-document-details.description.2.point': {
		ar: 'يمكنك العثور على الرقم المدني في الجهة الأمامية من البطاقة الشخصية أو بطاقة الإقامة.',
		en: 'You can find the civil number on the front page of the National ID or Resident card.',
	},
	'document-details.description.3.point': {
		ar:
			'تحتاج إلى تقديم مسح ضوئي للصفحة الأمامية والخلفية أو صور للمستند بحيث تكون جميع المعلومات قابلة للقراءة. لا يمكن أن يزيد حجم الملفات عن 1 ميجابايت، ويمكن تحميلها بهذه الصيغ: jpg و pdf و png.',
		en:
			'You need to provide scans or photos of the front and back page of the document, so that all information will be readable. Files cannot be bigger than 1 MB and can be uploaded in the following formats: jpg, pdf and png.',
	},
	'drag.drop.document.side': {
		ar: ' المستند',
		en: 'Document side',
	},
	'drag.drop.document.side.front': {
		ar: 'الجانب الأمامي',
		en: 'Front side',
	},
	'drag.drop.document.side.back': {
		ar: 'الجانب الخلفي',
		en: 'Back side',
	},
	'drag.drop.document.drop.file': {
		ar: 'سحب وإضافة الملف أو',
		en: 'Drag and drop file or',
	},
	'drag.drop.document.browse.file': {
		ar: 'إرفاق ملف',
		en: 'Browse file',
	},
	'drag.drop.file.too.big': {
		ar: 'تعذر تحميل الملف، حاول مجددا.',
		en: 'The file couldn’t be uploaded. Please try again.',
	},
	'drag.drop.file.not.supported': {
		ar: 'تعذر تحميل الملف، حاول مجددا.',
		en: 'The file couldn’t be uploaded. Please try again.',
	},
	'map.view.title': {
		ar: 'أين تريد استخدام خدماتنا؟',
		en: 'Where would you like to use our services?',
	},
	'map.view.subtitle': {
		ar: 'ابحث عن موقع بتمرير الخريطة وإدخال إحداثياتك وتحديد المنطقة والولاية والمدينة وبعدها اضغط على زر الطلب.',
		en:
			'Search a location by scrolling the map, entering your coordinates, selecting the region, wilayat and town, and pressing the order button.',
	},
	'map.view.description': {
		ar: 'النقاط التي تتوفر فيها خدمات الإنترنت من عمانتل بالفعل',
		en: '- points where Omantel internet services already exist.',
	},
	'map.breadcrubs.map': {
		ar: 'خريطة',
		en: 'Map',
	},
	'contact.bar.title': {
		ar: 'أنت تتحقق من عناوين الباقات المتوفرة:',
		en: 'You are checking plans for the address: ',
	},
	'contact.bar.title.change': {
		ar: 'تغيير العنوان',
		en: 'Change address',
	},
	'contact.title': {
		ar: 'نأسف، لا توجد باقة متاحة لموقعك.',
		en: 'Unfortunately, no plans are available in your location.',
	},
	'contact.title.wfbb': {
		ar: ' يرجى ترك بيانات الاتصال الخاصة بك ، وسوف نتصل بك قريبًا.',
		en: 'Please leave us your contact details, and we will contact you shortly. ',
	},
	'contact.subtitle': {
		ar: 'اتصل بـ @  %%@ لمزيد من المعلومات، أو اترك لنا تفاصيل الاتصال الخاصة بك للتمكن من التواصل معك وخدمتك.',
		en: 'Call @%%@ to get more information or leave us your contact details and we will contact you shortly. ',
	},
	'contact.button.primary': {
		ar: 'إرسال',
		en: 'Send',
	},
	'contact.name.label': {
		ar: 'الإسم',
		en: 'Name',
	},
	'contact.name.placeholder': {
		ar: 'الإسم',
		en: 'Name',
	},
	'contact.phone.number.label': {
		ar: 'رقم الهاتف',
		en: 'Phone number',
	},
	'contact.phone.number.placeholder': {
		ar: 'رقم الهاتف',
		en: 'Phone number',
	},
	'contact.error.name.only.letters': {
		ar: ' مطلوب أحرف فقط',
		en: 'Only letters required',
	},
	'contact.name.error.required': {
		ar: 'الاسم مطلوب',
		en: 'Name required',
	},
	'contact.error.phone.required': {
		ar: ' رقم الهاتف مطلوب',
		en: 'Phone number required',
	},
	'contact.title.success.thank.you': {
		ar: 'شكرا لاختيار خدمات عمانتل للمؤسسات.',
		en: "Thank you for choosing Omantel's Enterprise services",
	},
	'contact.request.sent.subtitle': {
		ar: 'سيتم الاتصال بك في غضون 2 أيام عمل. لمتابعة طلبك، يرجى الاتصال على 1235',
		en: 'You will be contacted within 2 working days. To follow up on your request, please contact 1235',
	},
	'contact.request.reference.number': {
		ar: 'رقمك المرجعي هو: %%.',
		en: 'Your reference number is: %%',
	},
	'go.back.button.primary': {
		ar: 'العودة إلى الصفحة الرئيسية',
		en: 'Return to homepage',
	},
	'upgrade.plan.more.internet.for.local.gcc.more': {
		ar: ' قُم بالترقية إلى %% واحصل على %% %% أكثر من الإنترنت داخل عمان ودول الخليج مقابل %% ر.ع فقط.',
		en: 'Upgrade to %% and get %% %% more internet for Local & GCC for just %% OMR more.',
	},
	'upgrade.plan.more.internet.for.local.gcc.less': {
		ar: ' قُم بالترقية إلى %% واحصل على %% %% أكثر من الإنترنت داخل عمان ودول الخليج مقابل %% ر.ع أقل.',
		en: 'Upgrade to %% and get %% %% more internet for Local & GCC for just %% OMR less.',
	},
	'upgrade.plan.more.internet.for.faster.internet.more': {
		ar: ' قُم بالترقية إلى %% واحصل على %% %% إنترنت أسرع مقابل %% ريال عماني فقط.',
		en: 'Upgrade to %% and get %% %% faster internet for just %% OMR more.',
	},
	'upgrade.plan.more.internet.for.faster.internet.less': {
		ar: ' قُم بالترقية إلى %% واحصل على %% %% إنترنت أسرع مقابل %% ريال عماني أقل.',
		en: 'Upgrade to %% and get %% %% faster internet for just %% OMR less.',
	},
	'product.cart.plan.commitment': {
		ar: 'تجديد العقد',
		en: 'Commitment renewal',
	},
	'plan-comparison.apply.plan': {
		ar: 'اطلب',
		en: 'Apply',
	},
	'checkout-info.description-3-hbbwfbb': {
		ar: 'تاريخ انتهاء الصلاحية وإرفاق نسخة من البطاقة الشخصية أو بطاقة الإقامة (من الخلف والأمام))',
		en: 'Expiry date and a photo of your National ID or Resident Card (Back and Front)',
	},
	'document.data.form.document.type.required': {
		ar: 'نوع الملف مطلوب',
		en: 'Document type required',
	},
	'document.data.form.expiry.required': {
		ar: 'تاريخ انتهاء الصلاحية مطلوب',
		en: 'Expiry date required',
	},
	'document.data.form.both': {
		ar: 'يجب إرفاق النسخة الأمامية والخلفية من البطاقة',
		en: 'Both sides of document are required',
	},
	'product.cart.plan.duration.contract': {
		ar: '%% رفع مستوى العقد',
		en: '%% months contract',
	},
	'checkout-bar.step-4.other-title': {
		ar: 'عنوان التسليم',
		en: 'Delivery address',
	},
	'shipping-method.title.hbb.wfbb': {
		ar: 'عنوان تركيب الإنترنت',
		en: 'Internet installation address',
	},
	'shipping-method.title.hbb.wfbb.desc': {
		ar: 'يرجى تزويدنا بتفاصيل موقع التثبيت.',
		en: 'Please provide us details of the installation location.',
	},
	'shipping-method.same.as.internet.installation': {
		ar: 'عنوان تركيب الإنترنت ذاته',
		en: 'Same as the internet installation address.',
	},
	'shipping-method.title.hbb.wfbb.device': {
		ar: 'عنوان شحن الجهاز',
		en: 'Device shipping address',
	},
	'shipping-method.title.hbb.wfbb.desc.device': {
		ar:
			'ترسل الأجهزة إلى عنوان تركيب الإنترنت عادة، ولكن إن كنت ترغب بتلقي الجهاز في مكان آخر فيرجى تحديد خيار آخر.',
		en:
			'Usually, we send devices to the same address as the internet installation address. Although if you would like to get device at another location, please select from the options.',
	},
	'shipping.method.additional.landmark': {
		ar: 'معلومات إضافية حول موقع التسليم والمعالم المحيطة به وما إلى ذلك (اختياري)',
		en: 'Add additional directions about delivery, landmark etc. (optional)',
	},
	'checkout-bar.step-hbb.wfbb': {
		ar: 'معلومات إضافية حول موقع التسليم والمعالم المحيطة به وما إلى ذلك (اختياري)',
		en: 'Add additional directions about delivery, landmark etc. (optional)',
	},
	'shipping.method.save-address': {
		ar: 'احفظ هذا العنوان للاستخدام في المستقبل',
		en: 'Save this address for future usage',
	},
	'shipping-details.accordion.contact-data.personal.info': {
		ar: 'بيانات شخصية',
		en: 'Personal info',
	},
	'shipping-details.accordion.provided.document': {
		ar: 'وثيقة مقدمة',
		en: 'Provided document',
	},
	'shipping-details.accordion.provided.document.subtitle-101': {
		ar: 'تاريخ انتهاء البطاقة الشخصية',
		en: 'National ID ED: %%',
	},
	'shipping-details.accordion.provided.document.subtitle-104': {
		ar: 'تاريخ انتهاء بطاقة الإقامة',
		en: 'Residence Card ED: %%',
	},
	'sim-order-details.accordion.provided.document.subtitle-101': {
		ar: 'البطاقة الشخصية ',
		en: 'National ID ',
	},
	'sim-rder-details.accordion.provided.document.subtitle-104': {
		ar: 'بطاقة المقيم',
		en: 'Resident Card',
	},
	'shipping-details.accordion.provided-document.section-header-101': {
		ar: 'البطاقة الشخصية ',
		en: 'National ID',
	},
	'shipping-details.accordion.provided-document.section-header-104': {
		ar: 'بطاقة المقيم',
		en: 'Resident Card',
	},
	'sim-order-details.accordion.provided-document.section-header-101': {
		ar: 'البطاقة الشخصية ',
		en: 'National ID',
	},
	'sim-order-details.accordion.provided-document.section-header-104': {
		ar: 'بطاقة المقيم',
		en: 'Resident Card',
	},
	'sim-order-details.accordion.contact-data.data.expiry-date': {
		ar: 'تاريخ الانتهاء',
		en: 'Expiry date',
	},
	'shipping-details.accordion.provided-document.section-header-documents': {
		ar: 'الملفات التي رفعت',
		en: 'Uploaded files',
	},
	'file.preview.name.button': {
		ar: 'معاينة',
		en: 'Preview',
	},
	'shipping-details.accordion.title.delivery.details': {
		ar: 'تفاصيل التسليم',
		en: 'Delivery details',
	},
	'shipping-details.accordion.internet-installation.section-header': {
		ar: 'عنوان تثبيت الإنترنت',
		en: 'Internet installation address',
	},
	'document-details.fill-date-properly': {
		ar: 'يرجى اختيار تاريخ صالح',
		en: 'Please provide valid date format DD/MM/YYYY',
	},
	'document-details.invalid-date': {
		ar: 'التاريخ غير صالح',
		en: 'Invalid date',
	},
	'document-details.name.only.number': {
		ar: 'أرقام فقط',
		en: 'Only numbers',
	},
	'contact.error.name.only.numbers': {
		ar: 'أرقام فقط',
		en: 'Only numbers',
	},
	'plans.plans.available': {
		ar: 'الباقات المتوفرة في موقعك',
		en: 'Plans available in your location',
	},
	'plans.selected.plan.not.available': {
		ar:
			'نعتذر ، الباقة التي قُمت بإختيارها (%%) غير متوفرة في موقعك الجديد. يمكنك رؤية الباقات المتاحة لك بالأسفل.',
		en:
			'We are sorry, but your selected plan (%%) is unavailable in your new location. Below you can see plans which are available for you.',
	},
	'drag.drop.try.again': {
		ar: 'حاول مجددا',
		en: 'Try again',
	},
	'drag.drop.preview': {
		ar: 'معاينة',
		en: 'Preview',
	},
	'drag.drop.delete': {
		ar: 'حذف',
		en: 'Delete',
	},
	'checkout.summary.something.went.wrong': {
		ar: 'حدث خطأ',
		en: 'Something went wrong.',
	},
	'checkout.summary.problem.with.request': {
		ar: 'حدث خطأ في تقديم طلبك',
		en: 'There was a problem with your request.',
	},
	'checkout-summary.success.payment.track-order.part-1': {
		ar: ':تتبع طلبك ',
		en: 'Track your order: ',
	},
	'checkout-summary.success.payment.track-delivery.part-1': {
		ar: '[AR] Track delivery of your device:',
		en: 'Track delivery of your device:',
	},
	'checkout-summary.success.payment.internet-request': {
		ar: 'رقم طلب الإنترنت الخاص بك: %%',
		en: 'Your internet request number: %%',
	},
	'shipping.method.omante.hq': {
		ar: 'مبنى عمانتل الرئيسي',
		en: 'Omantel HQ',
	},
	'tracking.title.REQUEST_RECEIVED': {
		ar: 'استلام الطلب',
		en: 'Request received',
	},
	'tracking.title.REQUEST_REJECTED': {
		ar: 'تم الغاء المعاملة',
		en: 'Request rejected',
	},
	'tracking.title.PROCCESSING': {
		ar: 'التنفيذ',
		en: 'Proccessing',
	},
	'tracking.title.FULFILLMENT_IN_PROGRESS': {
		ar: 'الطلب قيد التنفيذ',
		en: 'Fulfilment in-progress',
	},
	'tracking.title.INSTALLATION_COMPLETED': {
		ar: 'تم اكتمال التثبيت',
		en: 'Installation completed',
	},
	'tracking.title.INSTALLATION': {
		ar: 'التثبيت',
		en: 'Installation',
	},
	'tracking.doneTitle.FULFILLMENT_IN_PROGRESS': {
		ar: 'الطلب قيد التنفيذ',
		en: 'Fulfilment in-progress',
	},
	'tracking.description.FULFILLMENT_IN_PROGRESS': {
		ar: 'ستتلقى المكالمة قبل يوم من التثبيت',
		en: 'You will get the call a day before installation',
	},
	'tracking.doneDescription.FULFILLMENT_IN_PROGRESS': {
		ar: 'تم توصيل الخدمة',
		en: 'Installation was successful.',
	},
	'tracking.doneTitle.REQUEST_RECEIVED': {
		ar: 'استلام الطلب',
		en: 'Request received',
	},
	'tracking.doneTitle.REQUEST_REJECTED': {
		ar: 'تم الغاء المعاملة',
		en: 'Request rejected',
	},
	'tracking.doneTitle.REQUEST_ACCEPTED': {
		ar: 'تم قبول الطلب',
		en: 'Request accepted',
	},
	'tracking.doneTitle.PROCCESSING': {
		ar: 'تم قبول الطلب',
		en: 'Request accepted',
	},
	'tracking.doneTitle.INSTALLATION_COMPLETED': {
		ar: 'التثبيت',
		en: 'Installation',
	},
	'tracking.doneTitle.INSTALLATION': {
		ar: 'تم اكتمال التثبيت',
		en: 'Installation completed',
	},
	'tracking.doneTitle.REQUEST_COMPLETED': {
		ar: 'تم الطلب',
		en: 'Request completed',
	},
	'tracking.description.PROCCESSING': {
		ar: 'طلبك قيد التنفيذ',
		en: 'We are proccessing your request.',
	},
	'tracking.description.INSTALLATION_COMPLETED': {
		ar: 'تم تأكيد موعد التركيب الخاص بك مع فريق الفنيين ',
		en: 'Your installation meeting with our technician is scheduled',
	},
	'tracking.doneDescription.REQUEST_RECEIVED': {
		ar: 'تم استلام طلبك',
		en: 'We have received your request',
	},
	'tracking.doneDescription.PROCCESSING': {
		ar: 'تم تنفيذ طلبك بنجاح',
		en: 'Your request has been processed successfully',
	},
	'tracking.doneDescription.REQUEST_ACCEPTED': {
		ar: 'تم تنفيذ طلبك بنجاح',
		en: 'Your request has been processed successfully',
	},
	'tracking.doneDescription.REQUEST_REJECTED': {
		ar: 'تمت معالجة طلبك دون نجاح.',
		en: 'Your request has been processed unsuccessfully',
	},
	'tracking.doneDescription.INSTALLATION_COMPLETED': {
		ar: ' تم تأكيد موعد التركيب الخاص بك مع فريق الفنيين ',
		en: 'Your installation meeting with our technician was scheduled',
	},
	'tracking.doneDescription.INSTALLATION': {
		ar: 'تهانينا! شبكة الإنترنت الخاصة بك جاهزة للاستخدام',
		en: 'Hooray, your internet connection is ready to use!',
	},
	'tracking.doneDescription.REQUEST_COMPLETED': {
		ar: 'تهانينا! شبكة الإنترنت الخاصة بك جاهزة للاستخدام',
		en: 'Hooray, your internet connection is ready to use!',
	},
	'tracking.title.READY_TO_PICKUP': {
		ar: '[AR] Ready to pickup',
		en: 'Ready to pickup',
	},
	'tracking.description.READY_TO_PICKUP': {
		ar: '[AR] Your order is ready to be picked up in your selected outlet.',
		en: 'Your order is ready to be picked up in your selected outlet.',
	},
	'tracking.title.COLLECTED': {
		ar: '[AR] Collected',
		en: 'Collected',
	},
	'tracking.description.COLLECTED': {
		ar: '[AR] You have collected your order from the outlet. Thanks!',
		en: 'You have collected your order from the outlet. Thanks!',
	},
	'account.management.payment.shipment.hbb.wfbb.product': {
		ar: 'تفاصيل توصيل الإنترنت',
		en: 'Internet delivery details',
	},
	'product.details.plan.edit.warning.block.5g': {
		ar: 'عزيزي المستخدم ، لا يسمح جهازك الحالي بالترقية إلى باقات 5G الأعلى ',
		en: 'Dear user, your current device does not allow to upgrade to higher 5G plans',
	},
	'product.details.plan.edit.warning.block.business': {
		ar:
			'أنت تستخدم حسابًا تجاريًا وبعض الميزات قد لا تكون متوفرة. يرجى التواصل معنا عبر المساعد الرقمي "نور" لتلقي الدعم.',
		en:
			'You’re using a business account, and some features may not be available. Please contact us through our digital assistant ‘Noor’ for support.',
	},
	'product.details.plan.edit.warning.8920004': {
		ar: 'لطفاً، نرجو منك دفع المستحقات السابقة لتتمكن من متابعة هذا الطلب.',
		en: 'Sorry! It looks like you have dues to be paid. Kindly pay the dues first to proceed with this order.',
	},
	'product.details.plan.select-number.warning': {
		ar: '[AR]Select a mobile number to see a summary of your purchase.',
		en: 'Select a mobile number to see a summary of your purchase.',
	},
	'document-details.provide-document-id': {
		ar: '2. يرجى إدخال الرقم المدني',
		en: '2. Please enter your Civil Number',
	},
	'sim-document-details.provide-civil-number': {
		ar: '2. يرجى تزويدنا بالرقم المدني للوثيقة التي اخترتها',
		en: '2. Please provide us the civil number of your selected document',
	},
	'document.data.form.document.id.required': {
		ar: 'نسخة البطاقة الشخصية مطلوبة',
		en: 'Document id required',
	},
	'document.data.form.document.id': {
		ar: ' نسخة البطاقة الشخصية ',
		en: 'Document ID',
	},
	'sim-document.data.form.civil-number.required': {
		ar: 'الرقم المدني مطلوب',
		en: 'Civil number required',
	},
	'sim-document.data.form.civil-number': {
		ar: 'الرقم المدني',
		en: 'Civil number',
	},
	'insurance.step.details': {
		ar: 'التفاصيل',
		en: 'Details',
	},
	'insurance.step.vehicle-details': {
		ar: 'بيانات\u00a0المركبة',
		en: 'Vehicle\u00a0details',
	},
	'insurance.step.quotes': {
		ar: 'العرض',
		en: 'Quotes',
	},
	'insurance.step.quotes.extended': {
		ar: 'للمتابعة حدد نوع التغطية و خيارات التأمين',
		en: 'To continue, specify the coverage and select the region.',
	},
	'insurance.step.summary': {
		ar: 'مخلص',
		en: 'Summary',
	},
	'insurance.step.back': {
		ar: 'عودة',
		en: 'Back',
	},
	'insurance.collecting-data.title': {
		ar: 'استعد, بقى القليل',
		en: 'It may take a while.',
	},
	'insurance.collecting-data.subtitle': {
		ar: 'نقدم لك أفضل العروض',
		en: 'We are collecting details about your vehicle.',
	},
	'insurance.type.title': {
		ar: 'تأمين',
		en: 'Insurance',
	},
	'insurance.type.subtitle': {
		ar: 'نوع',
		en: 'TYPE',
	},
	'insurance.type.choice1': {
		ar: 'تأمين شامل',
		en: 'Comprehensive',
	},
	'insurance.type.choice2': {
		ar: 'طرف ثالث',
		en: 'Third party',
	},
	'insurance.insurer.title': {
		ar: 'المؤمن',
		en: 'Insurer',
	},
	'insurance.insurer.insured': {
		ar: 'سنة',
		en: 'years old',
	},
	'insurance.insurer.age': {
		ar: 'المؤمن',
		en: 'Insured',
	},
	'insurance.insurer.license': {
		ar: 'رخصة القيادة',
		en: 'INSURER LICENSE',
	},
	'insurance.insurer.license.placeholder': {
		ar: 'رقم رخصة القيادة',
		en: 'License numbers',
	},
	'insurance.insurer.license.validation.error': {
		ar: 'الرقم المدخل غير صحيح',
		en: 'Entered number is incorrect.',
	},
	'insurance.insurer.contact': {
		ar: 'رقم التواصل',
		en: 'CONTACT',
	},
	'insurance.insurer.contact.placeholder': {
		ar: 'رقم النقال',
		en: 'Contact number',
	},
	'insurance.insurer.contact.hint': {
		ar: 'رقم نقال مسجل في سلطنة عُمان',
		en: 'Only Omani numbers ',
	},
	'insurance.vehicle.title': {
		ar: 'المركبة',
		en: 'Vehicle',
	},
	'insurance.vehicle.plates': {
		ar: 'بيانات اللوحة',
		en: 'PLATES',
	},
	'insurance.vehicle.plates.chars.placeholder': {
		ar: 'الرمز',
		en: 'Chars',
	},
	'insurance.vehicle.plates.chars.validation.error': {
		ar: 'يرجى اختيار رمز اللوحة.',
		en: 'Please select the chars.',
	},
	'insurance.vehicle.plates.number.placeholder': {
		ar: 'رقم السيارة',
		en: 'Vehicle number',
	},
	'insurance.vehicle.value': {
		ar: 'قيمة المركبة',
		en: 'SPECIFY THE VALUE',
	},
	'insurance.vehicle.value.placeholder': {
		ar: 'قيمة السيارة',
		en: 'Vehicle value',
	},
	'insurance.vehicle.value.hint': {
		ar: 'أنت تدخل القيمة المقدرة لسيارتك التي وضعتها بنفسك، وقد لا تقبل شركات التأمين هذا التقييم',
		en: 'You are putting your own valuation, remember that insurance companies may not accept it',
	},
	'insurance.vehicle.value.validation.error': {
		ar: 'القيمة المدخلة غير صحيحة',
		en: 'Entered value is incorrect.',
	},
	'insurance.stepper.button': {
		ar: 'المتابعة',
		en: 'Continue',
	},
	'insurance.stepper.next-step.label': {
		ar: 'الخطوة التالية:',
		en: 'Next step:',
	},
	'insurance.vehicle.value.label': {
		ar: 'القيمة',
		en: 'Value',
	},
	'insurance.vehicle.value.estimates.label': {
		ar: 'تقدير قيمة',
		en: 'Estimates',
	},
	'insurance.vehicle.details.info': {
		ar: 'إذا كانت بيانات المركبة غير صحيحة، فأدخل رقم و رمز اللوحة من جديد',
		en: 'If the details of the vehicle are incorrect, please provide the new plates numbers.',
	},
	'insurance.vehicle.details.title': {
		ar: 'بيانات المركبة',
		en: 'Vehicle details',
	},
	'insurance.offer.cover.label': {
		ar: 'تغطية',
		en: 'Cover',
	},
	'insurance.offer.region.label': {
		ar: 'التأمين',
		en: 'Region',
	},
	'insurance.offer.total-amount.label': {
		ar: 'المبلغ الإجمالي',
		en: 'TOTAL AMOUNT',
	},
	'insurance.offer.benefits.label': {
		ar: 'المميزات المشمولة',
		en: 'Covered benefits',
	},
	'insurance.insurer.contact.owner-name.label': {
		ar: 'بيانات المؤمن',
		en: 'Owner name',
	},
	'insurance.insurer.name.placeholder': {
		ar: 'الاسم الأول',
		en: 'First name',
	},
	'insurance.insurer.last-name.placeholder': {
		ar: 'القبيلة',
		en: 'Last name',
	},
	'insurance.summary.title': {
		ar: 'خيارات مخلص',
		en: 'Insurance summary',
	},
	'insurance.summary.upfront': {
		ar: 'مقدم',
		en: 'Upfront',
	},
	'insurance.add-to-cart': {
		ar: 'اضف إلى عربة التسوق',
		en: 'Add to cart',
	},
	'insurance.title': {
		ar: 'أمن سيارتك بكل سهولة عبر التطبيق',
		en: 'Get car insurance easy online.',
	},
	'insurance.subtitle': {
		ar: 'لآن يمكنك التحقق من عروض شركات التأمين.',
		en: 'Now you can check the offers of insurance companies.',
	},
	'insurance.action': {
		ar: 'ابدا مع بيمة',
		en: 'Start with BIMA',
	},
	'insurance.get.now': {
		ar: 'عرض',
		en: 'Get now',
	},
	'insurance.vehicle.seats': {
		ar: 'مقاعد ',
		en: ' seats',
	},
	'insurance.vehicle.doors': {
		ar: 'أبواب ',
		en: ' doors',
	},
	'insurance.vehicle.mfg.year': {
		ar: 'سنة التصنيع ',
		en: ' mfg.year',
	},
	'insurance.bima.welcome': {
		ar:
			'بيمة® علامة تجارية مسجلة لشركة بيت التأمين ش. م. م، البوابة الأولى للتأمين في سلطنة عمان، وهي مرخصةللعمل من قبل الهيئة العامة لسوق المال',
		en: "Oman's first online insurance portal. Licensed to operate by the Capital Market Authority in Oman.",
	},
	'insurance.landingpage.bima.details': {
		ar: 'التفاصيل',
		en: ' DETAILS',
	},
	'insurance.landingpage.bima.title': {
		ar: 'بيمة',
		en: ' Bima',
	},
	'insurance.landingpage.bima.heading': {
		ar: 'نحن أكبر بوابة تأمين على الإنترنت في سلطنة عمان',
		en: ' We are the largest online insurance portal in Oman',
	},
	'insurance.landingpage.bima.paragraph': {
		ar:
			'بيمة® علامة تجارية مسجلة لشركة بيت التأمين ش. م. م، البوابة الأولى للتأمين في سلطنة عمان، وهي مرخصة للعمل من قبل الهيئة العامة لسوق المال..',
		en:
			' Bima (trade mark of Insurance House L.L.C.), Oman\u0027s first online insurance	portal. Licensed to operate by the Capital Market Authority in Oman. \nWe use technology to serve you better, save your time, less paperwork and gives you more	options.',
	},
	'car-insurance.breadcrumb': {
		ar: 'تأمين السيارت',
		en: 'Car insurance',
	},
	'car-insurance.login.prompt': {
		ar: 'جب أن يكون لديك حساب عمانتل للمتابعة.',
		en: 'You need to have an Omantel account to continue.',
	},
	'car-insurance.already.in.cart.title': {
		ar: 'يوجد لديك طلب مسبق للتأمين في سلة التسوق',
		en: 'Car insurance already in your cart',
	},
	'car-insurance.already.in.cart.subtitle.part1': {
		ar: 'يمكنك طلب تأمين سيارة واحد فقط في على كل عملية شراء.',
		en: 'You can only purchase one car insurance at a single checkout.',
	},
	'vehicle-details.clasification': {
		ar: 'تصنيف ',
		en: ' clasification',
	},
	'country.oman': {
		ar: 'عُمان',
		en: 'Oman',
	},
	'insurance.owner.data.incorrect.email': {
		ar: 'عنوان البريد الإلكتروني المدخل غير صحيح.',
		en: 'Provided email address is incorrect.',
	},
	'insurance.term.and.conditions.label': {
		ar: 'أوافق على',
		en: 'I agree to the ',
	},
	'otp-card.error': {
		ar: 'رمز التأكيد غير صحيح',
		en: 'The SMS verification code is incorrect.',
	},
	'otp-card.title': {
		ar: 'أدخل رمز التأكيد المرسل عبر رسالة نصية',
		en: 'Enter SMS verification code',
	},
	'otp-card.subheader-1': {
		ar: 'لتغيير الباقة، يرجى تأكيد هذه الخطوة ',
		en: 'To change the plan, you need to confirm your action',
	},
	'makasib-otp-card.subheader-1': {
		ar: 'متابعة الدفع باستخدام نقاط مكاسب ، سنحتاج إلى تأكيد من الحالية',
		en: 'To proceed payment with Makasib points we will need confirmation from current',
	},
	'otp-card.subheader-2': {
		ar: 'رقم الخط الرئيسي',
		en: 'main line number.',
	},
	'2fa.otp.header': {
		en: 'Two Factor Authentication ',
		ar: 'المصادقة الثنائية',
	},
	'number.settings.password.sent': {
		en: 'One time password was send to your contact number.',
		ar: 'تم إرسال كلمة المرور لمرة واحدة إلى رقم الهاتف الخاص بك.',
	},
	'mfa.otp.error.OTP_NOT_SENT': {
		en:
			"If you haven't received an OTP; it might be because your mobile number is incorrect. Please reach out to your Super Admin, or if you are a Super Admin contact our call center at 1235 to update your details.",
		ar:
			'إذا لم تتلقَ رمز التحقق (OTP) فقد يكون السبب هو أن رقم هاتفك غير صحيح. يرجى التواصل مع المشرف الأعلى أو إذا كنت مشرفًا أعلى، يرجى الاتصال بمركز الاتصال على الرقم 1235 لتحديث بياناتك',
	},
	'mfa.otp.error.OTP_FAIL': {
		en: 'OTP is temporary unavailable, please try again later.',
		ar: 'رمز التحقق (OTP) غير متوفر حاليًا، يرجى المحاولة مرة أخرى لاحقًا',
	},
	'mfa.otp.success.OTP': {
		en: 'OTP has been sent to your registered number',
		ar: 'تم إرسال رمز التحقق إلى رقمك المسجل',
	},
	'mfa.otp.error.LOGIN_FAILED': {
		en:
			'Please double-check your username and password. If the issue persists, reset your password to meet our enhanced security.',
		ar:
			'يرجى التحقق من اسم المستخدم وكلمة المرور. إذا استمرت المشكلة، يرجى إعادة تعيين كلمة المرور لتوافق معايير الأمان المحسّنة.',
	},
	'mfa.otp.error.USER_SECURE_AUTH_CACHING_EXCEPTION_OCCURRED': {
		en: 'Our server is currently experiencing issues. Please try again later.',
		ar: 'يواجه خادمنا حاليًا مشكلات. يرجى المحاولة مرة أخرى لاحقًا.',
	},
	'mfa.otp.error.INVALID_OTP': {
		en: "We're having trouble verifying your OTP code. Please try resending or request a new code.",
		ar: 'نواجه مشكلة في التحقق من رمز OTP الخاص بك. يرجى إعادة الإرسال أو طلب رمز جديد.',
	},
	'mfa.otp.error.INTERNAL_SERVER_ERROR': {
		en: 'Our server is currently experiencing issues. Please try again later.',
		ar: 'يواجه خادمنا حاليًا مشكلات. يرجى المحاولة مرة أخرى لاحقًا.',
	},
	'mfa.otp.error.NOT_ABLE_TO_GENERATE_CORRELATION_ID': {
		en: 'We are currently experiencing to generate the token. Please try again.',
		ar: 'We are currently experiencing to generate the token. Please try again.',
	},
	'mfa.otp.error.TOKEN_MISSING': {
		en: 'We are currently experiencing to generate the token. Please try again.',
		ar: 'We are currently experiencing to generate the token. Please try again.',
	},
	'mfa.otp.error.resend': {
		en: 'We are currently experiencing issue to generate the token. Please try again.',
		ar:
			'إذا لم تتلقَ رقم التحقق (OTP)، قد يكون رقم هاتفك المحمول المسجل غير صحيح. يرجى التواصل مع المشرف العام أو مدير الحساب لتحديث بياناتك.',
	},

	'makasib-otp-card.subheader-2': {
		ar: 'الرقم الأساسي',
		en: 'Primary Number.',
	},
	'otp-card.subheader-3': {
		ar: 'سيصلك رمز التأكيد المكون من ٥ أرقام على هاتفك المتنقل',
		en: 'You will shortly receive a 5-digits code on your mobile:',
	},
	'makasib-otp-card.subheader-3': {
		ar: 'سيتم إرسال كلمة المرور المكونة من 5 أرقام على هاتفك النقال:',
		en: 'The 5-digits password will be sent on mobile: ',
	},
	'otp-card.otp-title': {
		ar: '[AR] Enter it below to confirm.',
		en: 'Enter it below to confirm.',
	},
	'otp-card.valid': {
		ar: 'رمز التأكيد صالح لـ',
		en: 'Your code is valid for:',
	},
	'otp-card.resend': {
		ar: 'إعادة إرسال الرمز',
		en: 'Resend the code',
	},
	'otp-card.terms-1': {
		ar: 'لقد أنهيت القراءة وفهمت، وأوافق على كافة',
		en: 'I have read, understood, and agree to the ',
	},
	'otp-card.terms-2': {
		ar: 'الشروط والأحكام',
		en: 'Terms & Conditions',
	},
	'otp-card.confirm': {
		ar: 'تأكيد',
		en: 'Confirm',
	},
	'otp-card.cancel': {
		ar: 'إلغاء',
		en: 'Cancel',
	},
	'choose-number.check': {
		ar: 'تحقق من رقم آخر',
		en: 'Chceck another number',
	},
	'choose-number.back': {
		ar: 'العودة إلى الصفحة الرئيسية',
		en: 'Return to home page',
	},
	'choose-number.error-not-prepaid': {
		ar: 'ليس رقماً مسبق الدفع لعمانتل',
		en: 'It is not a prepaid Omantel number.',
	},
	'choose-number.error': {
		ar: 'نعتذر، رقمك غير مستوف لمتطلبات الترقية إلى آجل الدفع.',
		en: 'Unfortunately, your number does not meet the requirements for a postpaid upgrade.',
	},
	'choose-number.title': {
		ar: 'مرحبًا! هل ترغب بالترقية إلى إحدى الباقات آجلة الدفع؟',
		en: 'Hey! Are you looking to upgrade to a postpaid plan?',
	},
	'choose-number.subtitle': {
		ar: 'أدخل رقم هاتفك وسنتحقق من أفضل ما يمكننا تقديمه لك.',
		en: 'Enter your mobile number and let us check the best that we can offer to you.',
	},
	'choose-number.text-field.placeholder': {
		ar: 'رقم هاتفك',
		en: 'Your phone number',
	},
	'choose-number.dropdown.placeholder': {
		ar: 'الرقم الذي ترغب بنقله',
		en: 'Number you want to upgrade',
	},
	'choose-number.button': {
		ar: 'الاطلاع على العروض',
		en: 'Check offers',
	},
	'choose-number.warning': {
		ar: ' لا توجد أي أرقام مسبقة الدفع مرتبطة بحسابك.',
		en: 'You don’t have any prepaid numbers assigned to your account.',
	},
	'migration-plans.title': {
		ar: 'اختر إحدى باقات "باقتي" التي ترغب في تفعيلها',
		en: 'Choose which Baqati plan you would like to upgrade',
	},
	'migration-plans.tab-1': {
		ar: '12 شهر',
		en: '12-month',
	},
	'migration-plans.tab-2': {
		ar: 'دون عقد',
		en: 'No contract',
	},
	'migration-plan-selector.error.title': {
		ar: 'حدث خطأ ما',
		en: 'Something went wrong',
	},
	'migration-plan-selector.error.text': {
		ar: 'نعتذر، لم نتمكن من تفعيل باقتك. يرجى التواصل مع فريق خدمة المشتركين عبر الرقم %%.',
		en: 'Unfortunately, we couldn’t activate your plan. Please contact our Customer Service team on %%.',
	},
	'migration-plan-selector.contact': {
		ar: 'اذهب إلى صفحة اتصل بنا ',
		en: 'Go to Contact Us page',
	},
	'migration-plan-selector.success.title': {
		ar: 'تم!',
		en: 'Great!',
	},
	'migration-plan-selector.success.text': {
		ar: 'أمورك طيبة، يرجى الانتظار بضع دقائق حتى إتمام ترقية باقتك.',
		en: 'it’s all good, but it may take a few minutes to upgrade your plan.',
	},
	'migration-plan-selector.go-home': {
		ar: 'العودة إلى الصفحة الرئيسية',
		en: 'Go back to home page',
	},
	'migration-plan-selector.log-out': {
		ar: 'تسجيل الخروج',
		en: 'Log out',
	},
	'migration-plan-selector.not-linked': {
		ar: 'لقد قمت بتسجيل الدخول إلى حساب غير مرتبط بالرقم الذي أدخلته:',
		en: 'You have logged into an account that is not linked with the number you entered: ',
	},
	'migration-plan-selector.log-off': {
		ar: 'لترقية هذا الرقم إلى رقم آجل الدفع، يرجى تسجيل الخروج وتسجيل الدخول إلى حساب بأذونات الإدارة المناسبة.',
		en:
			'In order to convert this number into a postpaid number, please log off and log into an account with the proper management permissions.',
	},
	'migration-plan-selector.apply': {
		ar: 'اطلب',
		en: 'Apply',
	},
	'migration-plan-selector.error.title-1': {
		ar: 'لم تنجح الترقية',
		en: 'Upgrade was unsuccessful',
	},
	'migration-plan-selector.error.BILLS_OUTSTANDING_AMOUNT_EXCEEDED': {
		ar: 'لديك فواتير غير مدفوعة على بطاقتك الشخصية. يرجى دفعها لاستكمال الإجراءات.',
		en: 'You have outstanding bills on your ID card. Please pay them to proceed.',
	},
	'migration-plan-selector.error.REGISTERED_DOCUMENT_EXPIRED': {
		ar: 'انتهت صلاحية بطاقة الهوية المسجلة، يرجى زيارة أقرب منفذ لعمانتل وتحديث البيانات..',
		en: 'Your registered ID Card has expired. Please visit your nearest Omantel outlet to update your information.',
	},
	'choosen-account-bar.title': {
		ar: 'أنت تطلع على العروض الخاصة بهذا الرقم',
		en: 'You are checking offers for the number: ',
	},
	'choosen-account-bar.title-xs': {
		ar: 'الرقم ',
		en: 'Number: ',
	},
	'choosen-account-bar.button': {
		ar: 'جرب رقماً آخر',
		en: 'Check another number',
	},
	'telemarketer.bar.tooltip': {
		ar:
			'لإنشاء طلب جديد للمشترك، أدخل رقم الهاتف والبريد الإلكتروني وأضف المنتجات المحددة إلى عربة التسوق. بعد ذلك، اضغط على الزر "حفظ وإرسال" لإرسال الطلب.',
		en:
			'To create a new order for a customer, enter their phone number, e-mail and add the selected items to the cart. Once ready, press “Save & Send” button to submit the order.',
	},
	'telemarketer.bar.button.save.send': {
		ar: 'حفظ وإرسال',
		en: 'Save & Send',
	},
	'telemarketer.bar.button.logOut': {
		ar: 'تسجيل خروج',
		en: 'Log out',
	},
	'telesales.email.error.email': {
		ar: 'يرجى إدخال بريد إلكتروني صالح',
		en: 'Please provide valid email format',
	},
	'telesales.email.error.required': {
		ar: 'عليك إدخال البريد الإلكتروني الخاص بالمشترك للتمكن من إرسال الطلب.',
		en: 'You need to enter the customer`s email before sending the order.',
	},
	'telesales.error.name.only.numbers': {
		ar: 'يجب أن يكون رقماً',
		en: 'Must be a number',
	},
	'telesales.error.phone.required': {
		ar: 'الرقم مطلوب',
		en: 'Number is required',
	},
	'telesales-number-error-less': {
		ar: 'يجب أن يكون أقل ٪٪ من رقم ',
		en: 'Must be less than %% digits',
	},
	'telesales-number-error-more': {
		ar: 'يجب أن يكون أكثر ٪٪ من رقم ',
		en: 'Must be more than %% digits',
	},
	'telesales-number-not-oman': {
		ar: 'يمكنك إدخال أرقام عمانتل فقط',
		en: 'You can enter only Omantel numbers.',
	},
	'telesales-field-logged-as': {
		ar: 'أنت مسجل الدخول ك',
		en: 'You are logged in as: ',
	},
	'telesales-success-info': {
		ar: ' حفظت عربة التسوق لرقم الهاتف ٪٪ بنجاح ',
		en: 'Cart for phone number %% was successfully saved',
	},
	'telesales-field-logged-as.telemarketer': {
		ar: 'التسويق عبر الهاتف',
		en: 'Telemarketer',
	},
	'telesales-field-order.number': {
		ar: 'رقم الطلب:',
		en: 'Order number:',
	},
	'telesales.phone.number.label': {
		ar: 'رقم الهاتف',
		en: 'Phone number',
	},
	'telesales.phone.number.placeholder': {
		ar: 'رقم الهاتف',
		en: 'Phone number',
	},
	'telesales.email.label': {
		ar: 'البريد الإلكتروني',
		en: 'E-mail',
	},
	'telesales.email.placeholder': {
		ar: 'البريد الإلكتروني',
		en: 'E-mail',
	},
	'continue.save.and.send': {
		ar: 'حفظ وإرسال',
		en: 'Save & Send',
	},
	'error.please.add.to.cart': {
		ar: 'لم تقم بإضافة أي شيء إلى عربة التسوق. لا يوجد شيء لحفظه.',
		en: 'You haven`t added anything to the cart. There is nothing to save.',
	},
	'migration-plan-selector.pay-bills': {
		ar: 'ادفع فواتيرك',
		en: 'Pay your bills',
	},
	'migration-plan-selector.outlet': {
		ar: 'البحث عن أقرب منفذ',
		en: 'Look for the nearest outlet',
	},
	'plans.tab.ultra.fast': {
		ar: 'إنترنت هائل السرعة',
		en: 'Ultra fast',
	},
	'plans.tab.4g.5g': {
		ar: 'إنترنت الجيل الرابع والخامس اللاسلكي',
		en: 'Wireless (4G/5G)',
	},
	'checkout-bar.confirmation': {
		ar: 'تأكيد',
		en: 'Confirmation',
	},
	'telesales.expired': {
		ar:
			'للأسف ، انتهت صلاحية طلبك ، ولم تعد المنتجات التي تريدها متوفرة في سلة التسوق الخاصة بك. يمكنك دائمًا التحقق مما إذا كانت المنتجات المحددة موجودة في متجر عمانتل الخاص بنا أو تصفح أجهزتنا الأخرى',
		en:
			'Unfortunately, your order expired, and the products you wanted are no longer available in your cart. You can always check if the given products are in our Omantel store or browse through our other devices. ',
	},
	'car-insurance.api.error': {
		ar: 'هناك خطأ ما',
		en: 'Something went wrong ',
	},
	'car-insurance.api.error.message': {
		ar: 'حاول مرة اخرى',
		en: 'Please try again',
	},
	'insurance.not-buyable.back': {
		ar: ' العودة إلى العروض ',
		en: 'Back to quotes',
	},
	'insurance.not-buyable.homepage': {
		ar: ' العودة إلى الصفحة الرئيسية ',
		en: 'Back to homepage',
	},
	'prepaid-migration.caption': {
		ar:
			'* لا يوجد حد أقصى لاستهلاك البيانات المحلية. ولكن، إذا تجاوز الاستهلاك حجم البيانات المخصص للباقة، فقد تنخفض سرعة الإنترنت إلى 512 كيلوبت في الثانية. ويمكنك مواصلة متابعة مقاطع الفيديو وتصفح الإنترنت وتحميل الملفات.',
		en:
			'* There is no limit on local data consumption. However, if you fully consume the allocated data volume, you may experience reduced speeds as low as 512 Kbps. However, you may continue streaming videos, browsing the internet and downloading content.',
	},
	'plan-comparison.data.allowance': {
		ar: 'علاوة البيانات',
		en: 'Data allowance',
	},
	'plan-comparison.social.media.data': {
		ar: 'بيانات التواصل الاجتماعي',
		en: 'Social media data',
	},
	'plan-comparison.flexi.minutes': {
		ar: 'دقائق مرنة',
		en: 'Flexi minutes',
	},
	'plan-comparison.cashback.promotion': {
		ar: 'عرض الاسترداد النقدي',
		en: 'Cashback promotion',
	},
	'plan-comparison.details.title': {
		ar: 'تفاصيل الباقة',
		en: 'Plan details',
	},
	'plan-comparison.cashback.description': {
		ar: '10٪ استرداد من المبلغ على الاشتراك الثاني - صالح لمدة أسبوع واحد',
		en: '10% cashback on 2nd subscription - valid for 1 week',
	},
	'plan-comparison.plan.duration.time': {
		ar: 'مدة اشتراك الباقة',
		en: 'Plan duration time',
	},
	'prepaid.civil.number.validation.error.title': {
		ar: 'عذرا، لا يمكننا إكمال طلبك.',
		en: 'Sorry, we can`t process your request.',
	},
	'prepaid.civil.number.validation.error.description': {
		ar: 'يبدو أن الهوية المقدمة قد تعدت 10 أرقام كحد أقصى لعدد الأرقام المسجلة أو عليها مستحقات يجب دفعها.',
		en:
			'Seems like the provided ID has either reached the limit of 10 registered numbers or has outstanding bills that need to be paid.',
	},
	'order.summary.section.physical.products.title': {
		ar: 'التسليم يدوي',
		en: 'Physical delivery',
	},
	'order.summary.section.status.title': {
		ar: 'الحالة',
		en: 'Status',
	},
	'order.summary.delivery.method.title': {
		ar: 'طريقة التسليم',
		en: 'Delivery method',
	},
	'order.summary.delivery.method.subtitle': {
		ar: 'الاستلام من الصالة',
		en: 'Outlet pickup',
	},
	'order.summary.appointment.outlet-appointment-description': {
		ar: 'موعد الاستلام من الصالة ',
		en: 'Outlet pickup appointment, ',
	},
	'order.summary.appointment.outlet-appointment-ticket-number.title': {
		ar: 'رقم ‘الطلب',
		en: 'Ticket number',
	},
	'pickup.appointment.error.message': {
		ar: '[AR] Sorry, someone has just booked the last slot available on %%. Please, choose a new appointment date.',
		en: 'Sorry, someone has just booked the last slot available on %%. Please, choose a new appointment date.',
	},
	'microsoft-automation-proccess.stepper.step-1': {
		ar: 'بيانات المتصل',
		en: 'Contact details',
	},
	'microsoft-automation-proccess.stepper.step-2': {
		ar: 'تفاصيل الشركة',
		en: 'Company details',
	},
	'microsoft-automation-proccess.stepper.step-3': {
		ar: 'اسم النطاق',
		en: 'Domain name',
	},
	'microsoft-automation-proccess.checkout-items-info': {
		ar: 'نقوم بتعيين الترخيص لحساب شركتك في مجال Microsoft إذا لم يكن لديك حساب، فسننشئ حسابًا لك.',
		en:
			'We assign the license to your corporate account in the Microsoft domain. If you don’t have an account, we’ll create one for you.',
	},
	'microsoft-automation-proccess.cart-items-info': {
		ar: 'سنأخذك عبرعملية التحقق / الإنشاء من Microsoft Tenant ، وهي عملية إلزامية لشراء ترخيص.',
		en:
			'We will take you through the Microsoft Tenant verification/creation process, which is mandatory to purchase a license.',
	},
	'microsoft-automation-proccess.checkout-items-info.extended': {
		ar: 'تراخيص NCE (CSP).',
		en: 'NCE (CSP) Licenses.',
	},
	'microsoft-automation-proccess.checkout-summary-info.part-1': {
		ar: 'يتم إرسال معرف المستأجر وكلمة المرور الخاصين بك إلى بريدك الإلكتروني المسجل',
		en: 'Your tenant ID and password are shared to your registered email %%.',
	},
	'microsoft-automation-proccess.checkout-summary-info.part-2': {
		ar: 'تم ٪٪ ترخيصك لـ ٪٪ بنجاح وهو متاح في لوحة معلومات المستأجر.',
		en: 'Your license for %% is successfully %% and is available	in your tenant dashboard.',
	},
	'microsoft-automation-proccess.checkout-summary-info.part-3': {
		ar: 'مفعل',
		en: 'activated',
	},
	'microsoft-automation-proccess.checkout-summary-info.part-4': {
		ar: 'تحديث',
		en: 'updated',
	},
	'microsoft-automation-proccess.checkout-summary-info.part-5': {
		ar: 'الوصول إلى لوحة معلومات المستأجر الخاصة بك',
		en: 'Access your tenant dashboard ',
	},
	'microsoft-automation-proccess.checkout-summary-info.here': {
		ar: 'هنا',
		en: 'here',
	},
	'microsoft-automation-proccess.account-creation-form.info.part-1': {
		ar: 'اختر اسم المستأجر الخاص بك ، وسنستخدمه لإنشاء المجال الخاص بك الذي سيكون بالتنسيق التالي:',
		en: 'Choose your tenant name, and we will use it to generate your domain that will have the following format:',
	},
	'microsoft-automation-proccess.account-creation-form.info.part-2': {
		ar:
			'Pick a name close to your company’s, but without spaces or punctuation. Remember that once set, the tenant name',
		en:
			'Pick a name close to your company’s, but without spaces or punctuation. Remember that once set, the tenant name',
	},
	'microsoft-automation-proccess.account-creation-form.info.part-3': {
		ar: 'cannot be changed later.',
		en: 'cannot be changed later.',
	},
	'microsoft-automation-proccess.account-creation-form.info.hint': {
		ar: 'سيتم أيضًا استخدام البيانات التي تقدمها في هذا النموذج لاتفاقية العملاء من Microsoft',
		en: 'The data you provide in this form will be also used for the Microsoft Customer Agreement',
	},
	'microsoft-automation-proccess.account-creation-process.progress.part-1': {
		ar: 'نحن بصدد إنشاء حساب Microsoft 365 Business الخاص بك الآن.',
		en: ' We’re creating your Microsoft 365 Business account now.',
	},
	'microsoft-automation-proccess.account-creation-process.progress.part-2': {
		ar:
			'يرجى التحلي بالصبر لأنه قد يستغرق بضع دقائق. بمجرد الانتهاء، ستتمتع بإمكانية الوصول إلى مجموعة من منتجات وخدمات Microsoft',
		en:
			'Please be patient as it may take a few minutes. Once completed, you’ll have access to a range of Microsoft products and services.',
	},
	'microsoft-automation-proccess.account-creation-process.progress.part-3': {
		ar: 'بالإضافة إلى ذلك، سوف نرسل تأكيدًا إلى بريدك الإلكتروني:',
		en: 'In addition, we will send a confirmation to your email: ',
	},
	'microsoft-automation-proccess.account-creation-process.success.part-1': {
		ar: 'اكتمل الاستبيان',
		en: 'Survey completed',
	},
	'microsoft-automation-proccess.account-creation-process.success.part-2': {
		ar: 'لقد أنشأنا للتو حساب Microsoft 365 Business من أجلك!',
		en: 'We’ve just created a Microsoft 365 Business account for you!',
	},
	'microsoft-automation-proccess.account-creation-process.success.part-3': {
		ar: 'ستجد معرف المستأجر وكلمة المرور في البريد الإلكتروني:',
		en: 'You’ll find your Tenant ID and password on email: ',
	},
	'microsoft-automation-proccess.account-creation-process.success.go-to-checkout': {
		ar: 'اكمال عملية الدفع',
		en: 'Go to checkout',
	},
	'microsoft-automation-proccess.account-creation-process.failure.part-1': {
		ar: 'رفض تعبئة الاستبيان',
		en: 'Survey rejected',
	},
	'microsoft-automation-proccess.account-creation-process.failure.part-2': {
		ar: 'لم نتمكن من إنشاء حساب Microsoft 365 Business لك.',
		en: 'We’ve unable to create a Microsoft 365 Business account for you.',
	},
	'microsoft-automation-proccess.account-creation-process.failure.part-3': {
		ar: 'يرجى محاولة إعادة إدخال التفاصيل الخاصة بك.',
		en: 'Please try to re-enter your details.',
	},
	'microsoft-automation-proccess.account-creation-process.failure.try-again': {
		ar: 'حاول ثانية',
		en: 'Try again',
	},
	'microsoft-automation-proccess.change-provider.title': {
		ar: 'تغيير مزود',
		en: 'Change provider',
	},
	'microsoft-automation-proccess.different-provider.part-1': {
		ar: 'تم تعيين حساب Microsoft الخاص بك إلى موفر آخر.',
		en: 'Your Microsoft account is assigned to a different provider.',
	},
	'microsoft-automation-proccess.different-provider.part-2': {
		ar: 'To continue the process, click the "change provider" button and on Microsoft’s website ',
		en: 'To continue the process, click the "change provider" button and on Microsoft’s website ',
	},
	'microsoft-automation-proccess.different-provider.part-3': {
		ar: 'change the provider to Omantel',
		en: 'change the provider to Omantel',
	},
	'microsoft-automation-proccess.different-provider.part-4': {
		ar: ' and	then come back to us :)',
		en: ' and	then come back to us :)',
	},
	'microsoft-automation-proccess.change-provider.button.change-provider': {
		ar: 'تغيير المزود',
		en: 'Change provider',
	},
	'microsoft-automation-proccess.change-provider.button.assign-to-different-account': {
		ar: 'تعيين لحساب مختلف',
		en: 'Assign to different account',
	},
	'microsoft-automation-proccess.change-provider.part-1': {
		ar: 'نحن في انتظارك لتغيير المزود.',
		en: 'We are waiting for you to change provider.',
	},
	'microsoft-automation-proccess.change-provider.part-2': {
		ar: 'نتحقق من الخلفية لتغيير المزود.',
		en: 'We check in the background for a change of provider.',
	},
	'microsoft-automation-proccess.change-provider.part-3': {
		ar: 'لقد فتحنا موقع Microsoft في نافذة جديدة.',
		en: 'We have opened the Microsoft website in a new window.',
	},
	'microsoft-automation-proccess.change-provider.part-4': {
		ar:
			'تسجيل الدخول وتغيير مزود الخدمة الخاص بك إلى عمانتل. بعد تغيير البيانات، قد تستغرق المعالجة ما يصل إلى ,ثلاث دقائق.',
		en:
			'Log in and change your service provider to Omantel. After changing the data, processing may take up to 3 minutes.',
	},
	'microsoft-automation-proccess.change-provider.part-5': {
		ar: 'لا تغلق هذه النافذة.',
		en: 'Do not close this window.',
	},
	'microsoft-automation-proccess.account.do-you-have-ms-account': {
		ar: 'هل لديك حساب Microsoft 365 Business موجود؟',
		en: 'Do you have an existing Microsoft 365 Business account?',
	},
	'microsoft-automation-proccess.account.name': {
		ar: 'اسم حساب Microsoft الخاص بك.',
		en: 'Your Microsoft account name.',
	},
	'microsoft-automation-proccess.account.company-number': {
		ar: 'رقم شركة Microsoft الخاصة بك',
		en: 'Your Microsoft company Number',
	},
	'microsoft-automation-proccess.account.button.verify': {
		ar: 'يؤكد',
		en: 'Verify',
	},
	'microsoft-automation-proccess.account.no-account': {
		ar: 'إذا لم يكن لديك حساب Microsoft ، فسننشئ حسابًا في الخطوة التالية.',
		en: 'If you do not have a Microsoft account, we will create one in the next step.',
	},
	'microsoft-automation-proccess.tenant.verification.success.info': {
		ar: 'We have successfully verified your Tenant ID',
		en: 'We have successfully verified your Tenant ID',
	},
	'microsoft-automation-proccess.tenant.verification.success.tenant-name': {
		ar: 'Tenant Name:',
		en: 'Tenant Name:',
	},
	'microsoft-automation-proccess.tenant.verification.success.tenant-id': {
		ar: 'Tenant ID:',
		en: 'Tenant ID:',
	},
	'microsoft-automation-proccess.tenant.verification.success.provider': {
		ar: 'Provider:',
		en: 'Provider:',
	},
	'microsoft-automation-proccess.tenant.verification.success.go-to-checkout': {
		ar: 'Go to checkout to complete the process.',
		en: 'Go to checkout to complete the process.',
	},
	'microsoft-automation-proccess.activation-process-title': {
		ar: 'عملية التنشيط',
		en: 'ACTIVACTION PROCESS',
	},
	'microsoft-automation-proccess.activation-process-description': {
		ar: 'سيتم تعيين ترخيص NCE (CSP) لحساب Microsoft الخاص بك.',
		en: 'The NCE (CSP) license will be assigned to your Microsoft account.',
	},
	'microsoft-automation-proccess.is-microsoft-product-in-cart-title': {
		ar: 'لا يمكن شراء منتج آخر عند شراء منتج Microsoft Office 365',
		en: 'Can’t purchase other product when buying Microsoft Office 365 product',
	},
	'buy-now-pay-later.credit-rating-not-found': {
		ar:
			'عذرًا، لا يمكننا استرجاع التقييم الائتماني الخاص بك في الوقت الحالي. يرجى المحاولة مرة أخرى لاحقًا أو التواصل مع خدمة العملاء للحصول على المساعدة.',
		en:
			'We’re unable to retrieve your credit rating at the moment. Please try again later or contact customer support for assistance.',
	},
	'buy-now-pay-later.nationality-not-found': {
		ar:
			'لا يمكننا استرداد ملفك الشخصي في الوقت الحالي. يُرجى المحاولة مرة أخرى لاحقًا أو الاتصال بخدمة دعم العملاء للحصول على المساعدة.',
		en:
			'We’re unable to retrieve your profile at the moment. Please try again later or contact customer support for assistance.',
	},
	'buy-now-pay-later.credit-rating-and-nationality-not-found': {
		ar:
			'لا يمكننا استرداد تصنيفك الائتماني وملفك الشخصي في الوقت الحالي. يُرجى المحاولة مرة أخرى لاحقًا أو الاتصال بخدمة دعم العملاء للحصول على المساعدة.',
		en:
			'We’re unable to retrieve your credit rating and profile at the moment. Please try again later or contact customer support for assistance.',
	},
	'warning-for-green-bnpl-user': {
		ar: 'تعذر استرداد معلومات الأقساط. يرجى إعادة المحاولة.',
		en: 'Unable to retrieve installments information. Please retry.',
	},
	'buy-now-pay-later.is-bnpl-in-cart-title': {
		ar: 'لا يمكنك إضافة منتج الدفع لاحقًا مع وجود منتج آخر في سلة التسوق الخاصة بك.',
		en: "You can't add a pay-later product with another item already in your cart.",
	},
	'add-device-when-buy-now-pay-later-in-cart': {
		ar: 'لا يمكنك إضافة منتج آخر إلى سلة التسوق التي تحتوي على منتج آجل الدفع.',
		en: 'You cannot add another item to your cart with a pay-later product already in it',
	},
	'add-device-when-buy-now-pay-later-in-cart-description': {
		ar: 'يرجى إكمال الدفع مقابل للمنتجات الحالية أو إزالة المنتج المضاف للمتابعة.',
		en: 'Please complete the payment for the pay-later items in your cart or remove the product to proceed',
	},
	'add-device-when-upfront-installment-in-cart': {
		ar: 'لا يمكنك إضافة منتج آخر إلى سلتك إذا كان يحتوي بالفعل على منتج مقسط.',
		en: 'You cannot add another item to your cart with a installment product already in it',
	},
	'add-device-when-upfront-installment-in-cart-description': {
		ar: 'يرجى إتمام الدفع للمنتجات المقسطة في سلتك أو إزالة المنتج للمتابعة.',
		en: 'Please complete the payment for the installment items in your cart or remove the product to proceed',
	},
	'buy-now-pay-later.is-bnpl-in-cart-description': {
		ar: 'أكمل عملية الدفع للمنتجات المضافة في سلة التسوق الخاصة بك أولاً أو قم بإزالتها للمتابعة.',
		en: 'Complete the payment for the products in your cart or remove them to proceed.',
	},
	'buy-now-pay-later.modal.go-to-the-cart': {
		ar: 'اذهب إلى سلة التسوق.',
		en: 'Go to the cart',
	},
	'microsoft-automation-proccess.is-microsoft-product-in-cart-description': {
		ar:
			'لديك حاليًا منتج Microsoft Office 365 مضاف إلى سلة التسوق الخاصة بك. يرجى إنهاء هذه المعاملة في البداية ثم متابعة عملية شراء الغرض التالي.',
		en:
			'You currently have a Microsoft Office 365 product added to your cart. Please finalize this transaction at first and then continue with your next item purchase.',
	},
	'microsoft-automation-proccess.validate.company-name-required': {
		ar: 'اسم الشركة مطلوب',
		en: 'Company name is required',
	},
	'microsoft-automation-proccess.validate.company-id-required': {
		ar: 'معرف الشركة مطلوب',
		en: 'Company ID is required',
	},
	'microsoft-automation-proccess.validate.company-address-required': {
		ar: 'عنوان الشركة مطلوب',
		en: 'Company address is required',
	},
	'microsoft-automation-proccess.validate.company-state-required': {
		ar: 'حالة الشركة مطلوبة',
		en: 'Company state is required',
	},
	'microsoft-automation-proccess.validate.company-postal-code-required': {
		ar: 'الرمز البريدي للشركة مطلوب',
		en: 'Company postal code is required',
	},
	'microsoft-automation-proccess.validate.company-city-required': {
		ar: 'مطلوب مدينة الشركة',
		en: 'Company city is required',
	},
	'microsoft-automation-proccess.validate.company-country-required': {
		ar: 'بلد الشركة مطلوب',
		en: 'Company country is required',
	},
	'microsoft-automation-proccess.validate.domain-name-required': {
		ar: 'Tenant name is required',
		en: 'Tenant name is required',
	},
	'microsoft-automation-proccess.validate.company-name-match': {
		ar: '[AR] Enter a Company name with letters only',
		en: 'Enter a Company name with letters only',
	},
	'microsoft-automation-proccess.validate.company-id-match': {
		ar: '[AR] Enter a Company ID with digits only',
		en: 'Enter a Company ID with digits only',
	},
	'microsoft-automation-proccess.validate.company-address-match': {
		ar: '[AR] Enter a Company address with letters only',
		en: 'Enter a Company address with letters only',
	},
	'microsoft-automation-proccess.validate.company-state-match': {
		ar: '[AR] Enter a Company state with letters only',
		en: 'Enter a Company state with letters only',
	},
	'microsoft-automation-proccess.validate.company-postal-code-match': {
		ar: '[AR] Enter a Company postal code with digits only',
		en: 'Enter a Company postal code with digits only',
	},
	'microsoft-automation-proccess.validate.company-city-match': {
		ar: '[AR]Enter a Company city with letters only',
		en: 'Enter a Company city with letters only',
	},
	'microsoft-automation-proccess.validate.domain-name-match': {
		ar: '[AR]Enter a Domain name with letters only',
		en: 'Enter a Domain name with letters only',
	},
	'microsoft-automation-proccess.validate.tenant-name-required': {
		ar: 'اسم المستأجر مطلوب',
		en: 'Tenant name is required',
	},
	'microsoft-automation-proccess.validate.tenant-name-match': {
		ar: '[AR]Enter a tenant name with letters only',
		en: 'Enter a Tenant name with letters only',
	},
	'microsoft-automation-proccess.validate.tenant-id-required': {
		ar: 'معرف المستأجر مطلوب',
		en: 'Tenant ID is required',
	},
	'microsoft-automation-proccess.validate.tenant-id-match': {
		ar: 'يجب أن يحتوي معرف المستأجر على أرقام وشرطات فقط',
		en: 'Tenant ID must contain only digits and dashes',
	},
	'microsoft-automation-proccess.button.next': {
		ar: 'التالي',
		en: 'Next',
	},
	'microsoft-automation-proccess.button.back': {
		ar: 'عودة',
		en: 'Back',
	},
	'microsoft-automation-proccess.form.field.firstName': {
		ar: 'الاسم الأول',
		en: 'First name',
	},
	'microsoft-automation-proccess.form.field.lastName': {
		ar: 'القبيلة',
		en: 'Last name',
	},
	'microsoft-automation-proccess.form.field.email': {
		ar: 'E-mail address',
		en: 'E-mail address',
	},
	'microsoft-automation-proccess.form.field.phoneNumber': {
		ar: 'رقم الهاتف',
		en: 'Phone number',
	},
	'microsoft-automation-proccess.form.field.companyName': {
		ar: 'الاسم القانوني للشركة بالكامل',
		en: 'Full Company Legal Name',
	},
	'microsoft-automation-proccess.form.field.companyId': {
		ar: 'معرف تسجيل الشركة',
		en: 'Company Registration ID',
	},
	'microsoft-automation-proccess.form.field.companyAddress': {
		ar: 'رقم الشارع والمنزل / الشقة',
		en: 'Street and house/flat number',
	},
	'microsoft-automation-proccess.form.field.companyState': {
		ar: 'State',
		en: 'State',
	},
	'microsoft-automation-proccess.form.field.companyPostalCode': {
		ar: 'Postal Code',
		en: 'Postal Code',
	},
	'microsoft-automation-proccess.form.field.companyCity': {
		ar: 'City',
		en: 'City',
	},
	'microsoft-automation-proccess.form.field.companyCountry': {
		ar: 'Country',
		en: 'Country',
	},
	'microsoft-automation-proccess.form.field.domainName': {
		ar: 'Tenant Name',
		en: 'Tenant Name',
	},
	'microsoft-automation-proccess.product-unavailable.main-title': {
		ar: 'The product is unavailable',
		en: 'The product is unavailable',
	},
	'microsoft-automation-proccess.product-unavailable-sub-title-1': {
		ar: 'Sorry, the product is currently not available.',
		en: 'Sorry, the product is currently not available.',
	},
	'microsoft-automation-proccess.product-unavailable-sub-title-2': {
		ar: 'We encourage you to purchase other Microsoft products.',
		en: 'We encourage you to purchase other Microsoft products.',
	},
	'microsoft-automation-proccess.go-to-microsoft-products': {
		ar: 'Explore Microsoft products',
		en: 'Explore Microsoft products',
	},
	'buy-now-pay-later-payment-type-label': {
		ar: 'Buy now pay later',
		en: 'Buy now pay later',
	},
	'product.cart-card.sales-lead-purchase-info': {
		ar: 'ارتق بتجربة التسوق الخاصة بك معنا. يرجى ملء الاستمارة أدناه لاكتشاف عروض حصرية وخيارات مُصممة لك!.',
		en:
			'Elevate your shopping experience with us. Please fill out the form below to discover exclusive offers just for you!',
	},
	'product.card.request': {
		ar: 'اطلب الآن',
		en: 'Request now',
	},

	'product.additional.subtitle.how.can.request.businessdevice': {
		ar: 'كيف يمكنني طلب جهاز أعمال من عمانتل؟',
		en: 'how can I request a business device from Omantel?',
	},
	'product.additional.subtitle.how.can.request.businessdevice.content': {
		ar:
			'<div style="margin-right:15px">- اذهب إلى متجر عمانتل الإلكتروني.  <br/>- حدد الجهاز الذي تريده.<br/>- املأ الاستمارة.<br/>- سيتواصل معك فريقنا خلال يومي عمل لمناقشة الخطوات التالية لإكمال طلبك.</div>',
		en:
			'<div style="margin-left:15px">- Go to Omantel e-shop <br/>- Select the item or device that you want.<br/>- Fill in the form.<br/>- Our team will reach out to you within the next 2 working days to discuss the next steps for completing your request.</div>',
	},

	'product.additional.subtitle.track.businessdevice.order': {
		ar: 'كيف يمكنني متابعة طلبي؟',
		en: 'Can I track my order?',
	},
	'product.additional.subtitle.track.businessdevice.order.content': {
		ar:
			'<div style="margin-right:15px">فور تقديم استمارة الطلب، ستحصل على رقم الطلب. ولمعرفة حالة طلبك، اتصل بـ 1235 أو أرسل بريداً إلكتروني إلى: <br/> <a href="mailTo:enterpriseTelesales@omantel.om">EnterpriseTelesales@omantel.om</a></div>',
		en:
			'<div style="margin-left:15px">Once you submit the application form, you get order No., to know the status of your application, you can call 1235 or email us at: <br/> <a href="mailTo:enterpriseTelesales@omantel.om">EnterpriseTelesales@omantel.om</a></div>',
	},
	'product.additional.subtitle.buy.bulk.quantity.businessdevice': {
		ar: 'ماذا لو كنت أرغب في كمية كبيرة من الأجهزة؟',
		en: 'What if I want a bulk quantity of devices?',
	},
	'product.additional.subtitle.buy.bulk.quantity.businessdevice.content': {
		ar: 'يمكنك تقديم عبر الاستمارة الإلكترونية، وتوضيح الكمية المطلوبة من الأجهزة.',
		en: 'You can apply in the online form and write the desired quantity of devices. ',
	},
	'product.additional.subtitle.not.listed.businessdevice.purchase': {
		ar: 'ماذا لو كنت أرغب بنوع مختلف من الأجهزة غير المتوفرة على الموقع؟',
		en: 'What if I need different model of devices that are not available on the website?',
	},
	'product.additional.subtitle.not.listed.businessdevice.purchase.content': {
		ar: 'يمكنك طلب النوع المرغوب عبر الاستمارة الإلكترونية وتوضيح مواصفات الجهاز.',
		en: 'You can request the desired type in the online form with the device specifications.',
	},
	'buy-now-pay-later-banner-heading-text': {
		ar: 'اشترِ الآن وادفع لاحقًا',
		en: 'Buy now pay later',
	},
	'buy-now-pay-later-banner-text': {
		ar: 'أقساط ميسرة على مدى ٢٤/١٢ شهرًا',
		en: 'Easy 12/24 month installements',
	},
	'product.cart-card.sales-lead.form.comments': {
		ar: 'تعليقات',
		en: 'Comments',
	},
	'validate.comment': {
		ar: 'الرجاء إدخال الأحرف الأبجدية، الأرقام، المسافة، الفاصلة، أو النقطة فقط.',
		en: 'Please enter only alphanumeric, space, comma or full stop',
	},
};
